[
  {
  "code": "AF",
  "description": "Afghanistan",
  "regions": [
  {
  "id": "Badakhshan",
  "description": "Badakhshan"
  },
  {
  "id": "Badghis",
  "description": "Badghis"
  },
  {
  "id": "Baghlan",
  "description": "Baghlan"
  },
  {
  "id": "Balkh",
  "description": "Balkh"
  },
  {
  "id": "Bamyan",
  "description": "Bamyan"
  },
  {
  "id": "Daykundi",
  "description": "Daykundi"
  },
  {
  "id": "Farah",
  "description": "Farah"
  },
  {
  "id": "Faryab",
  "description": "Faryab"
  },
  {
  "id": "Ghazni",
  "description": "Ghazni"
  },
  {
  "id": "Ghowr",
  "description": "Ghowr"
  },
  {
  "id": "Helmand",
  "description": "Helmand"
  },
  {
  "id": "Herat",
  "description": "Herat"
  },
  {
  "id": "Jowzjan",
  "description": "Jowzjan"
  },
  {
  "id": "Kabul",
  "description": "Kabul"
  },
  {
  "id": "Kandahar",
  "description": "Kandahar"
  },
  {
  "id": "Kapisa",
  "description": "Kapisa"
  },
  {
  "id": "Khowst",
  "description": "Khowst"
  },
  {
  "id": "Kunar",
  "description": "Kunar"
  },
  {
  "id": "Kunduz",
  "description": "Kunduz"
  },
  {
  "id": "Laghman",
  "description": "Laghman"
  },
  {
  "id": "Logar",
  "description": "Logar"
  },
  {
  "id": "Maidan Wardak Province",
  "description": "Maidan Wardak Province"
  },
  {
  "id": "Nangarhar",
  "description": "Nangarhar"
  },
  {
  "id": "Nimroz",
  "description": "Nimroz"
  },
  {
  "id": "Nuristan",
  "description": "Nuristan"
  },
  {
  "id": "Oruzgan",
  "description": "Oruzgan"
  },
  {
  "id": "Paktia",
  "description": "Paktia"
  },
  {
  "id": "Paktika",
  "description": "Paktika"
  },
  {
  "id": "Panjshir",
  "description": "Panjshir"
  },
  {
  "id": "Parwan",
  "description": "Parwan"
  },
  {
  "id": "Samangan",
  "description": "Samangan"
  },
  {
  "id": "Sar-e Pol Province",
  "description": "Sar-e Pol Province"
  },
  {
  "id": "Takhar",
  "description": "Takhar"
  },
  {
  "id": "Zabul",
  "description": "Zabul"
  }
  ]
  },
  {
  "code": "AL",
  "description": "Albania",
  "regions": [
  {
  "id": "Berat County",
  "description": "Berat County"
  },
  {
  "id": "Dibër County",
  "description": "Dibër County"
  },
  {
  "id": "Durrës County",
  "description": "Durrës County"
  },
  {
  "id": "Elbasan County",
  "description": "Elbasan County"
  },
  {
  "id": "Fier County",
  "description": "Fier County"
  },
  {
  "id": "Gjirokastër County",
  "description": "Gjirokastër County"
  },
  {
  "id": "Korçë County",
  "description": "Korçë County"
  },
  {
  "id": "Kukës County",
  "description": "Kukës County"
  },
  {
  "id": "Lezhë County",
  "description": "Lezhë County"
  },
  {
  "id": "Shkodër County",
  "description": "Shkodër County"
  },
  {
  "id": "Tirana",
  "description": "Tirana"
  },
  {
  "id": "Vlorë County",
  "description": "Vlorë County"
  }
  ]
  },
  {
  "code": "DZ",
  "description": "Algeria (El Djazair)",
  "regions": [
  {
  "id": "Adrar",
  "description": "Adrar"
  },
  {
  "id": "Aïn Defla",
  "description": "Aïn Defla"
  },
  {
  "id": "Aïn Témouchent",
  "description": "Aïn Témouchent"
  },
  {
  "id": "Algiers",
  "description": "Algiers"
  },
  {
  "id": "Annaba",
  "description": "Annaba"
  },
  {
  "id": "Batna",
  "description": "Batna"
  },
  {
  "id": "Béchar",
  "description": "Béchar"
  },
  {
  "id": "Béjaïa",
  "description": "Béjaïa"
  },
  {
  "id": "Beni Abbes",
  "description": "Beni Abbes"
  },
  {
  "id": "Biskra",
  "description": "Biskra"
  },
  {
  "id": "Blida",
  "description": "Blida"
  },
  {
  "id": "Bordj Badji Mokhtar",
  "description": "Bordj Badji Mokhtar"
  },
  {
  "id": "Bordj Bou Arréridj",
  "description": "Bordj Bou Arréridj"
  },
  {
  "id": "Bouira",
  "description": "Bouira"
  },
  {
  "id": "Boumerdes",
  "description": "Boumerdes"
  },
  {
  "id": "Chlef",
  "description": "Chlef"
  },
  {
  "id": "Constantine",
  "description": "Constantine"
  },
  {
  "id": "Djanet",
  "description": "Djanet"
  },
  {
  "id": "Djelfa",
  "description": "Djelfa"
  },
  {
  "id": "El Bayadh",
  "description": "El Bayadh"
  },
  {
  "id": "El Menia",
  "description": "El Menia"
  },
  {
  "id": "El Mghair",
  "description": "El Mghair"
  },
  {
  "id": "El Oued",
  "description": "El Oued"
  },
  {
  "id": "El Tarf",
  "description": "El Tarf"
  },
  {
  "id": "Ghardaia",
  "description": "Ghardaia"
  },
  {
  "id": "Guelma",
  "description": "Guelma"
  },
  {
  "id": "Illizi",
  "description": "Illizi"
  },
  {
  "id": "In Guezzam",
  "description": "In Guezzam"
  },
  {
  "id": "In Salah",
  "description": "In Salah"
  },
  {
  "id": "Jijel",
  "description": "Jijel"
  },
  {
  "id": "Khenchela",
  "description": "Khenchela"
  },
  {
  "id": "Laghouat",
  "description": "Laghouat"
  },
  {
  "id": "Mascara",
  "description": "Mascara"
  },
  {
  "id": "Medea",
  "description": "Medea"
  },
  {
  "id": "Mila",
  "description": "Mila"
  },
  {
  "id": "Mostaganem",
  "description": "Mostaganem"
  },
  {
  "id": "M'Sila",
  "description": "M'Sila"
  },
  {
  "id": "Naama",
  "description": "Naama"
  },
  {
  "id": "Oran",
  "description": "Oran"
  },
  {
  "id": "Ouargla",
  "description": "Ouargla"
  },
  {
  "id": "Ouled Djellal",
  "description": "Ouled Djellal"
  },
  {
  "id": "Oum el Bouaghi",
  "description": "Oum el Bouaghi"
  },
  {
  "id": "Relizane",
  "description": "Relizane"
  },
  {
  "id": "Saida",
  "description": "Saida"
  },
  {
  "id": "Sétif",
  "description": "Sétif"
  },
  {
  "id": "Sidi Bel Abbès",
  "description": "Sidi Bel Abbès"
  },
  {
  "id": "Skikda",
  "description": "Skikda"
  },
  {
  "id": "Souk Ahras",
  "description": "Souk Ahras"
  },
  {
  "id": "Tamanrasset",
  "description": "Tamanrasset"
  },
  {
  "id": "Tébessa",
  "description": "Tébessa"
  },
  {
  "id": "Tiaret",
  "description": "Tiaret"
  },
  {
  "id": "Timimoun",
  "description": "Timimoun"
  },
  {
  "id": "Tindouf",
  "description": "Tindouf"
  },
  {
  "id": "Tipaza",
  "description": "Tipaza"
  },
  {
  "id": "Tissemsilt",
  "description": "Tissemsilt"
  },
  {
  "id": "Tizi Ouzou",
  "description": "Tizi Ouzou"
  },
  {
  "id": "Tlemcen",
  "description": "Tlemcen"
  },
  {
  "id": "Touggourt",
  "description": "Touggourt"
  }
  ]
  },
  {
  "code": "AS",
  "description": "American Samoa",
  "regions": [
  {
  "id": "Eastern District",
  "description": "Eastern District"
  },
  {
  "id": "Manu'a",
  "description": "Manu'a"
  },
  {
  "id": "Rose Island",
  "description": "Rose Island"
  },
  {
  "id": "Swains Island",
  "description": "Swains Island"
  },
  {
  "id": "Western District",
  "description": "Western District"
  }
  ]
  },
  {
  "code": "AD",
  "description": "Andorra",
  "regions": [
  {
  "id": "Andorra la Vella",
  "description": "Andorra la Vella"
  },
  {
  "id": "Canillo",
  "description": "Canillo"
  },
  {
  "id": "Encamp",
  "description": "Encamp"
  },
  {
  "id": "Escaldes-Engordany",
  "description": "Escaldes-Engordany"
  },
  {
  "id": "La Massana",
  "description": "La Massana"
  },
  {
  "id": "Ordino",
  "description": "Ordino"
  },
  {
  "id": "Sant Julià de Loria",
  "description": "Sant Julià de Loria"
  }
  ]
  },
  {
  "code": "AO",
  "description": "Angola",
  "regions": [
  {
  "id": "Bengo",
  "description": "Bengo"
  },
  {
  "id": "Benguela",
  "description": "Benguela"
  },
  {
  "id": "Bíe",
  "description": "Bíe"
  },
  {
  "id": "Cabinda",
  "description": "Cabinda"
  },
  {
  "id": "Cuando Cobango",
  "description": "Cuando Cobango"
  },
  {
  "id": "Cuanza Norte",
  "description": "Cuanza Norte"
  },
  {
  "id": "Cunene",
  "description": "Cunene"
  },
  {
  "id": "Huambo",
  "description": "Huambo"
  },
  {
  "id": "Huíla",
  "description": "Huíla"
  },
  {
  "id": "Kwanza Sul",
  "description": "Kwanza Sul"
  },
  {
  "id": "Luanda",
  "description": "Luanda"
  },
  {
  "id": "Luanda Norte",
  "description": "Luanda Norte"
  },
  {
  "id": "Lunda Sul",
  "description": "Lunda Sul"
  },
  {
  "id": "Malanje",
  "description": "Malanje"
  },
  {
  "id": "Moxico",
  "description": "Moxico"
  },
  {
  "id": "Namibe",
  "description": "Namibe"
  },
  {
  "id": "Uíge",
  "description": "Uíge"
  },
  {
  "id": "Zaire",
  "description": "Zaire"
  }
  ]
  },
  {
  "code": "AI",
  "description": "Anguilla",
  "regions": [
  {
  "id": "Blowing Point",
  "description": "Blowing Point"
  },
  {
  "id": "East End",
  "description": "East End"
  },
  {
  "id": "George Hill",
  "description": "George Hill"
  },
  {
  "id": "Island Harbour",
  "description": "Island Harbour"
  },
  {
  "id": "North Hill",
  "description": "North Hill"
  },
  {
  "id": "North Side",
  "description": "North Side"
  },
  {
  "id": "Sandy Ground",
  "description": "Sandy Ground"
  },
  {
  "id": "Sandy Hill",
  "description": "Sandy Hill"
  },
  {
  "id": "South Hill",
  "description": "South Hill"
  },
  {
  "id": "Stoney Ground",
  "description": "Stoney Ground"
  },
  {
  "id": "The Farrington",
  "description": "The Farrington"
  },
  {
  "id": "The Quarter",
  "description": "The Quarter"
  },
  {
  "id": "The Valley",
  "description": "The Valley"
  },
  {
  "id": "West End",
  "description": "West End"
  }
  ]
  },
  {
  "code": "AQ",
  "description": "Antarctica",
  "regions": []
  },
  {
  "code": "AG",
  "description": "Antigua and Barbuda",
  "regions": [
  {
  "id": "Barbuda",
  "description": "Barbuda"
  },
  {
  "id": "Redonda",
  "description": "Redonda"
  },
  {
  "id": "Saint George Parish",
  "description": "Saint George Parish"
  },
  {
  "id": "Saint John Parish",
  "description": "Saint John Parish"
  },
  {
  "id": "Saint Mary Parish",
  "description": "Saint Mary Parish"
  },
  {
  "id": "Saint Paul Parish",
  "description": "Saint Paul Parish"
  },
  {
  "id": "Saint Peter Parish",
  "description": "Saint Peter Parish"
  },
  {
  "id": "Saint Philip Parish",
  "description": "Saint Philip Parish"
  }
  ]
  },
  {
  "code": "AR",
  "description": "Argentina",
  "regions": [
  {
  "id": "Buenos Aires",
  "description": "Buenos Aires"
  },
  {
  "id": "Buenos Aires F.D.",
  "description": "Buenos Aires F.D."
  },
  {
  "id": "Catamarca",
  "description": "Catamarca"
  },
  {
  "id": "Chaco",
  "description": "Chaco"
  },
  {
  "id": "Chubut",
  "description": "Chubut"
  },
  {
  "id": "Cordoba",
  "description": "Cordoba"
  },
  {
  "id": "Corrientes",
  "description": "Corrientes"
  },
  {
  "id": "Entre Rios",
  "description": "Entre Rios"
  },
  {
  "id": "Formosa",
  "description": "Formosa"
  },
  {
  "id": "Jujuy",
  "description": "Jujuy"
  },
  {
  "id": "La Pampa",
  "description": "La Pampa"
  },
  {
  "id": "La Rioja",
  "description": "La Rioja"
  },
  {
  "id": "Mendoza",
  "description": "Mendoza"
  },
  {
  "id": "Misiones",
  "description": "Misiones"
  },
  {
  "id": "Neuquen",
  "description": "Neuquen"
  },
  {
  "id": "Rio Negro",
  "description": "Rio Negro"
  },
  {
  "id": "Salta",
  "description": "Salta"
  },
  {
  "id": "San Juan",
  "description": "San Juan"
  },
  {
  "id": "San Luis",
  "description": "San Luis"
  },
  {
  "id": "Santa Cruz",
  "description": "Santa Cruz"
  },
  {
  "id": "Santa Fe",
  "description": "Santa Fe"
  },
  {
  "id": "Santiago del Estero",
  "description": "Santiago del Estero"
  },
  {
  "id": "Tierra del Fuego",
  "description": "Tierra del Fuego"
  },
  {
  "id": "Tucuman",
  "description": "Tucuman"
  }
  ]
  },
  {
  "code": "AM",
  "description": "Armenia",
  "regions": [
  {
  "id": "Aragatsotn",
  "description": "Aragatsotn"
  },
  {
  "id": "Ararat",
  "description": "Ararat"
  },
  {
  "id": "Armavir",
  "description": "Armavir"
  },
  {
  "id": "Gegharkunik",
  "description": "Gegharkunik"
  },
  {
  "id": "Kotayk",
  "description": "Kotayk"
  },
  {
  "id": "Lori",
  "description": "Lori"
  },
  {
  "id": "Shirak",
  "description": "Shirak"
  },
  {
  "id": "Syunik",
  "description": "Syunik"
  },
  {
  "id": "Tavush",
  "description": "Tavush"
  },
  {
  "id": "Vayots Dzor",
  "description": "Vayots Dzor"
  },
  {
  "id": "Yerevan",
  "description": "Yerevan"
  }
  ]
  },
  {
  "code": "AW",
  "description": "Aruba",
  "regions": []
  },
  {
  "code": "AU",
  "description": "Australia",
  "regions": [
  {
  "id": "ACT",
  "description": "Australian Capital Territory"
  },
  {
  "id": "NSW",
  "description": "New South Wales"
  },
  {
  "id": "NT",
  "description": "Northern Territory"
  },
  {
  "id": "QLD",
  "description": "Queensland"
  },
  {
  "id": "SA",
  "description": "South Australia"
  },
  {
  "id": "TAS",
  "description": "Tasmania"
  },
  {
  "id": "VIC",
  "description": "Victoria"
  },
  {
  "id": "WA",
  "description": "Western Australia"
  }
  ]
  },
  {
  "code": "AT",
  "description": "Austria",
  "regions": [
  {
  "id": "Burgenland",
  "description": "Burgenland"
  },
  {
  "id": "Carinthia",
  "description": "Carinthia"
  },
  {
  "id": "Lower Austria",
  "description": "Lower Austria"
  },
  {
  "id": "Salzburg",
  "description": "Salzburg"
  },
  {
  "id": "Styria",
  "description": "Styria"
  },
  {
  "id": "Tyrol",
  "description": "Tyrol"
  },
  {
  "id": "Upper Austria",
  "description": "Upper Austria"
  },
  {
  "id": "Vienna",
  "description": "Vienna"
  },
  {
  "id": "Vorarlberg",
  "description": "Vorarlberg"
  }
  ]
  },
  {
  "code": "AZ",
  "description": "Azerbaijan",
  "regions": [
  {
  "id": "Abşeron",
  "description": "Abşeron"
  },
  {
  "id": "Ağcabǝdi",
  "description": "Ağcabǝdi"
  },
  {
  "id": "Ağdam",
  "description": "Ağdam"
  },
  {
  "id": "Ağdaş",
  "description": "Ağdaş"
  },
  {
  "id": "Ağstafa",
  "description": "Ağstafa"
  },
  {
  "id": "Agsu District",
  "description": "Agsu District"
  },
  {
  "id": "Astara",
  "description": "Astara"
  },
  {
  "id": "Baki",
  "description": "Baki"
  },
  {
  "id": "Balakan District",
  "description": "Balakan District"
  },
  {
  "id": "Barda",
  "description": "Barda"
  },
  {
  "id": "Beyləqan",
  "description": "Beyləqan"
  },
  {
  "id": "Bilasuvar District",
  "description": "Bilasuvar District"
  },
  {
  "id": "Daşkǝsǝn",
  "description": "Daşkǝsǝn"
  },
  {
  "id": "Fuzuli District",
  "description": "Fuzuli District"
  },
  {
  "id": "Gadabay District",
  "description": "Gadabay District"
  },
  {
  "id": "Gǝncǝ",
  "description": "Gǝncǝ"
  },
  {
  "id": "Goranboy District",
  "description": "Goranboy District"
  },
  {
  "id": "Göyçay",
  "description": "Göyçay"
  },
  {
  "id": "Goygol Rayon",
  "description": "Goygol Rayon"
  },
  {
  "id": "Hacıqabul",
  "description": "Hacıqabul"
  },
  {
  "id": "İmişli",
  "description": "İmişli"
  },
  {
  "id": "Ismayilli District",
  "description": "Ismayilli District"
  },
  {
  "id": "Jabrayil",
  "description": "Jabrayil"
  },
  {
  "id": "Jalilabad",
  "description": "Jalilabad"
  },
  {
  "id": "Kalbajar",
  "description": "Kalbajar"
  },
  {
  "id": "Khojavend",
  "description": "Khojavend"
  },
  {
  "id": "Kurdamir District",
  "description": "Kurdamir District"
  },
  {
  "id": "Laçın",
  "description": "Laçın"
  },
  {
  "id": "Lankaran Sahari",
  "description": "Lankaran Sahari"
  },
  {
  "id": "Lerik District",
  "description": "Lerik District"
  },
  {
  "id": "Lənkəran",
  "description": "Lənkəran"
  },
  {
  "id": "Masally",
  "description": "Masally"
  },
  {
  "id": "Mingǝcevir",
  "description": "Mingǝcevir"
  },
  {
  "id": "Naftalan",
  "description": "Naftalan"
  },
  {
  "id": "Nakhchivan",
  "description": "Nakhchivan"
  },
  {
  "id": "Nakhichevan ASSR",
  "description": "Nakhichevan ASSR"
  },
  {
  "id": "Neftçala",
  "description": "Neftçala"
  },
  {
  "id": "Oğuz",
  "description": "Oğuz"
  },
  {
  "id": "Qabala District",
  "description": "Qabala District"
  },
  {
  "id": "Qax",
  "description": "Qax"
  },
  {
  "id": "Qazax",
  "description": "Qazax"
  },
  {
  "id": "Qobustan",
  "description": "Qobustan"
  },
  {
  "id": "Quba",
  "description": "Quba"
  },
  {
  "id": "Qubadlı",
  "description": "Qubadlı"
  },
  {
  "id": "Qusar District",
  "description": "Qusar District"
  },
  {
  "id": "Saatlı",
  "description": "Saatlı"
  },
  {
  "id": "Sabirabad District",
  "description": "Sabirabad District"
  },
  {
  "id": "Salyan District",
  "description": "Salyan District"
  },
  {
  "id": "Şamaxı",
  "description": "Şamaxı"
  },
  {
  "id": "Samux",
  "description": "Samux"
  },
  {
  "id": "Şǝmkir",
  "description": "Şǝmkir"
  },
  {
  "id": "Shabran",
  "description": "Shabran"
  },
  {
  "id": "Shaki",
  "description": "Shaki"
  },
  {
  "id": "Shaki City",
  "description": "Shaki City"
  },
  {
  "id": "Shirvan",
  "description": "Shirvan"
  },
  {
  "id": "Shusha City",
  "description": "Shusha City"
  },
  {
  "id": "Siyǝzǝn",
  "description": "Siyǝzǝn"
  },
  {
  "id": "Sumqayit",
  "description": "Sumqayit"
  },
  {
  "id": "Şuşa",
  "description": "Şuşa"
  },
  {
  "id": "Tartar District",
  "description": "Tartar District"
  },
  {
  "id": "Tovuz District",
  "description": "Tovuz District"
  },
  {
  "id": "Ucar",
  "description": "Ucar"
  },
  {
  "id": "Xaçmaz",
  "description": "Xaçmaz"
  },
  {
  "id": "Xankǝndi",
  "description": "Xankǝndi"
  },
  {
  "id": "Xızı",
  "description": "Xızı"
  },
  {
  "id": "Xocalı",
  "description": "Xocalı"
  },
  {
  "id": "Yardimli District",
  "description": "Yardimli District"
  },
  {
  "id": "Yevlax",
  "description": "Yevlax"
  },
  {
  "id": "Yevlax City",
  "description": "Yevlax City"
  },
  {
  "id": "Zangilan District",
  "description": "Zangilan District"
  },
  {
  "id": "Zaqatala District",
  "description": "Zaqatala District"
  },
  {
  "id": "Zərdab",
  "description": "Zərdab"
  }
  ]
  },
  {
  "code": "BS",
  "description": "Bahamas",
  "regions": [
  {
  "id": "Acklins",
  "description": "Acklins"
  },
  {
  "id": "Berry Islands",
  "description": "Berry Islands"
  },
  {
  "id": "Bimini",
  "description": "Bimini"
  },
  {
  "id": "Black Point",
  "description": "Black Point"
  },
  {
  "id": "Cat Island",
  "description": "Cat Island"
  },
  {
  "id": "Central Abaco",
  "description": "Central Abaco"
  },
  {
  "id": "Central Andros",
  "description": "Central Andros"
  },
  {
  "id": "Central Eleuthera",
  "description": "Central Eleuthera"
  },
  {
  "id": "Crooked Island and Long Cay",
  "description": "Crooked Island and Long Cay"
  },
  {
  "id": "East Grand Bahama",
  "description": "East Grand Bahama"
  },
  {
  "id": "Exuma",
  "description": "Exuma"
  },
  {
  "id": "Freeport",
  "description": "Freeport"
  },
  {
  "id": "Grand Cay",
  "description": "Grand Cay"
  },
  {
  "id": "Harbour Island",
  "description": "Harbour Island"
  },
  {
  "id": "Hope Town",
  "description": "Hope Town"
  },
  {
  "id": "Inagua",
  "description": "Inagua"
  },
  {
  "id": "Long Island",
  "description": "Long Island"
  },
  {
  "id": "Mangrove Cay",
  "description": "Mangrove Cay"
  },
  {
  "id": "Mayaguana",
  "description": "Mayaguana"
  },
  {
  "id": "Moore’s Island",
  "description": "Moore’s Island"
  },
  {
  "id": "New Providence",
  "description": "New Providence"
  },
  {
  "id": "North Abaco",
  "description": "North Abaco"
  },
  {
  "id": "North Andros",
  "description": "North Andros"
  },
  {
  "id": "North Eleuthera",
  "description": "North Eleuthera"
  },
  {
  "id": "Ragged Island",
  "description": "Ragged Island"
  },
  {
  "id": "Rum Cay",
  "description": "Rum Cay"
  },
  {
  "id": "San Salvador",
  "description": "San Salvador"
  },
  {
  "id": "South Abaco",
  "description": "South Abaco"
  },
  {
  "id": "South Andros",
  "description": "South Andros"
  },
  {
  "id": "South Eleuthera",
  "description": "South Eleuthera"
  },
  {
  "id": "Spanish Wells",
  "description": "Spanish Wells"
  },
  {
  "id": "West Grand Bahama",
  "description": "West Grand Bahama"
  }
  ]
  },
  {
  "code": "BH",
  "description": "Bahrain",
  "regions": [
  {
  "id": "Manama",
  "description": "Manama"
  },
  {
  "id": "Muharraq",
  "description": "Muharraq"
  },
  {
  "id": "Northern",
  "description": "Northern"
  },
  {
  "id": "Southern Governorate",
  "description": "Southern Governorate"
  }
  ]
  },
  {
  "code": "BD",
  "description": "Bangladesh",
  "regions": [
  {
  "id": "Barisal Division",
  "description": "Barisal Division"
  },
  {
  "id": "Chittagong",
  "description": "Chittagong"
  },
  {
  "id": "Dhaka Division",
  "description": "Dhaka Division"
  },
  {
  "id": "Khulna Division",
  "description": "Khulna Division"
  },
  {
  "id": "Mymensingh Division",
  "description": "Mymensingh Division"
  },
  {
  "id": "Rajshahi Division",
  "description": "Rajshahi Division"
  },
  {
  "id": "Rangpur Division",
  "description": "Rangpur Division"
  },
  {
  "id": "Sylhet Division",
  "description": "Sylhet Division"
  }
  ]
  },
  {
  "code": "BB",
  "description": "Barbados",
  "regions": [
  {
  "id": "Christ Church",
  "description": "Christ Church"
  },
  {
  "id": "Saint Andrew",
  "description": "Saint Andrew"
  },
  {
  "id": "Saint George",
  "description": "Saint George"
  },
  {
  "id": "Saint James",
  "description": "Saint James"
  },
  {
  "id": "Saint John",
  "description": "Saint John"
  },
  {
  "id": "Saint Joseph",
  "description": "Saint Joseph"
  },
  {
  "id": "Saint Lucy",
  "description": "Saint Lucy"
  },
  {
  "id": "Saint Michael",
  "description": "Saint Michael"
  },
  {
  "id": "Saint Peter",
  "description": "Saint Peter"
  },
  {
  "id": "Saint Philip",
  "description": "Saint Philip"
  },
  {
  "id": "Saint Thomas",
  "description": "Saint Thomas"
  }
  ]
  },
  {
  "code": "BY",
  "description": "Belarus",
  "regions": [
  {
  "id": "Brest",
  "description": "Brest"
  },
  {
  "id": "Gomel Oblast",
  "description": "Gomel Oblast"
  },
  {
  "id": "Grodnenskaya",
  "description": "Grodnenskaya"
  },
  {
  "id": "Minsk",
  "description": "Minsk"
  },
  {
  "id": "Minsk City",
  "description": "Minsk City"
  },
  {
  "id": "Mogilev",
  "description": "Mogilev"
  },
  {
  "id": "Vitebsk",
  "description": "Vitebsk"
  }
  ]
  },
  {
  "code": "BE",
  "description": "Belgium",
  "regions": [
  {
  "id": "Brussels Capital",
  "description": "Brussels Capital"
  },
  {
  "id": "Flanders",
  "description": "Flanders"
  },
  {
  "id": "Wallonia",
  "description": "Wallonia"
  }
  ]
  },
  {
  "code": "BZ",
  "description": "Belize",
  "regions": [
  {
  "id": "Belize District",
  "description": "Belize District"
  },
  {
  "id": "Cayo District",
  "description": "Cayo District"
  },
  {
  "id": "Corozal District",
  "description": "Corozal District"
  },
  {
  "id": "Orange Walk District",
  "description": "Orange Walk District"
  },
  {
  "id": "Southern District",
  "description": "Southern District"
  },
  {
  "id": "Toledo District",
  "description": "Toledo District"
  }
  ]
  },
  {
  "code": "BJ",
  "description": "Benin",
  "regions": [
  {
  "id": "Alibori",
  "description": "Alibori"
  },
  {
  "id": "Atakora",
  "description": "Atakora"
  },
  {
  "id": "Atlantique",
  "description": "Atlantique"
  },
  {
  "id": "Borgou",
  "description": "Borgou"
  },
  {
  "id": "Collines",
  "description": "Collines"
  },
  {
  "id": "Donga",
  "description": "Donga"
  },
  {
  "id": "Kouffo",
  "description": "Kouffo"
  },
  {
  "id": "Littoral",
  "description": "Littoral"
  },
  {
  "id": "Mono",
  "description": "Mono"
  },
  {
  "id": "Ouémé",
  "description": "Ouémé"
  },
  {
  "id": "Plateau",
  "description": "Plateau"
  },
  {
  "id": "Zou",
  "description": "Zou"
  }
  ]
  },
  {
  "code": "BM",
  "description": "Bermuda",
  "regions": [
  {
  "id": "Devonshire",
  "description": "Devonshire"
  },
  {
  "id": "Hamilton",
  "description": "Hamilton"
  },
  {
  "id": "Hamilton city",
  "description": "Hamilton city"
  },
  {
  "id": "Paget",
  "description": "Paget"
  },
  {
  "id": "Pembroke",
  "description": "Pembroke"
  },
  {
  "id": "Saint George",
  "description": "Saint George"
  },
  {
  "id": "Saint Georgeʼs",
  "description": "Saint Georgeʼs"
  },
  {
  "id": "Sandys",
  "description": "Sandys"
  },
  {
  "id": "Smithʼs",
  "description": "Smithʼs"
  },
  {
  "id": "Southampton",
  "description": "Southampton"
  },
  {
  "id": "Warwick",
  "description": "Warwick"
  }
  ]
  },
  {
  "code": "BT",
  "description": "Bhutan",
  "regions": [
  {
  "id": "Bumthang District",
  "description": "Bumthang District"
  },
  {
  "id": "Chukha",
  "description": "Chukha"
  },
  {
  "id": "Dagana",
  "description": "Dagana"
  },
  {
  "id": "Gasa",
  "description": "Gasa"
  },
  {
  "id": "Haa",
  "description": "Haa"
  },
  {
  "id": "Lhuntse",
  "description": "Lhuntse"
  },
  {
  "id": "Mongar",
  "description": "Mongar"
  },
  {
  "id": "Paro",
  "description": "Paro"
  },
  {
  "id": "Pemagatshel",
  "description": "Pemagatshel"
  },
  {
  "id": "Punakha",
  "description": "Punakha"
  },
  {
  "id": "Samdrup Jongkhar",
  "description": "Samdrup Jongkhar"
  },
  {
  "id": "Samtse District",
  "description": "Samtse District"
  },
  {
  "id": "Sarpang District",
  "description": "Sarpang District"
  },
  {
  "id": "Thimphu District",
  "description": "Thimphu District"
  },
  {
  "id": "Tongsa",
  "description": "Tongsa"
  },
  {
  "id": "Trashigang District",
  "description": "Trashigang District"
  },
  {
  "id": "Trashi Yangste",
  "description": "Trashi Yangste"
  },
  {
  "id": "Tsirang District",
  "description": "Tsirang District"
  },
  {
  "id": "Wangdi Phodrang",
  "description": "Wangdi Phodrang"
  },
  {
  "id": "Zhemgang District",
  "description": "Zhemgang District"
  }
  ]
  },
  {
  "code": "BO",
  "description": "Bolivia",
  "regions": [
  {
  "id": "Beni Department",
  "description": "Beni Department"
  },
  {
  "id": "Chuquisaca Department",
  "description": "Chuquisaca Department"
  },
  {
  "id": "Cochabamba",
  "description": "Cochabamba"
  },
  {
  "id": "La Paz Department",
  "description": "La Paz Department"
  },
  {
  "id": "Oruro",
  "description": "Oruro"
  },
  {
  "id": "Pando",
  "description": "Pando"
  },
  {
  "id": "Potosí Department",
  "description": "Potosí Department"
  },
  {
  "id": "Santa Cruz Department",
  "description": "Santa Cruz Department"
  },
  {
  "id": "Tarija Department",
  "description": "Tarija Department"
  }
  ]
  },
  {
  "code": "BA",
  "description": "Bosnia-Herzegovina",
  "regions": [
  {
  "id": "Brčko",
  "description": "Brčko"
  },
  {
  "id": "Federation of B&H",
  "description": "Federation of B&H"
  },
  {
  "id": "Srpska",
  "description": "Srpska"
  }
  ]
  },
  {
  "code": "BW",
  "description": "Botswana",
  "regions": [
  {
  "id": "Central",
  "description": "Central"
  },
  {
  "id": "Chobe",
  "description": "Chobe"
  },
  {
  "id": "City of Francistown",
  "description": "City of Francistown"
  },
  {
  "id": "Gaborone",
  "description": "Gaborone"
  },
  {
  "id": "Ghanzi",
  "description": "Ghanzi"
  },
  {
  "id": "Jwaneng",
  "description": "Jwaneng"
  },
  {
  "id": "Kgalagadi",
  "description": "Kgalagadi"
  },
  {
  "id": "Kgatleng",
  "description": "Kgatleng"
  },
  {
  "id": "Kweneng",
  "description": "Kweneng"
  },
  {
  "id": "Lobatse",
  "description": "Lobatse"
  },
  {
  "id": "Ngwaketsi",
  "description": "Ngwaketsi"
  },
  {
  "id": "North-East",
  "description": "North-East"
  },
  {
  "id": "North-West",
  "description": "North-West"
  },
  {
  "id": "Selibe Phikwe",
  "description": "Selibe Phikwe"
  },
  {
  "id": "South-East",
  "description": "South-East"
  },
  {
  "id": "Sowa Town",
  "description": "Sowa Town"
  }
  ]
  },
  {
  "code": "BV",
  "description": "Bouvet Island",
  "regions": []
  },
  {
  "code": "BR",
  "description": "Brazil",
  "regions": [
  {
  "id": "Acre",
  "description": "Acre"
  },
  {
  "id": "Alagoas",
  "description": "Alagoas"
  },
  {
  "id": "Amapá",
  "description": "Amapá"
  },
  {
  "id": "Amazonas",
  "description": "Amazonas"
  },
  {
  "id": "Bahia",
  "description": "Bahia"
  },
  {
  "id": "Ceará",
  "description": "Ceará"
  },
  {
  "id": "Espírito Santo",
  "description": "Espírito Santo"
  },
  {
  "id": "Federal District",
  "description": "Federal District"
  },
  {
  "id": "Goiás",
  "description": "Goiás"
  },
  {
  "id": "Maranhão",
  "description": "Maranhão"
  },
  {
  "id": "Mato Grosso",
  "description": "Mato Grosso"
  },
  {
  "id": "Mato Grosso do Sul",
  "description": "Mato Grosso do Sul"
  },
  {
  "id": "Minas Gerais",
  "description": "Minas Gerais"
  },
  {
  "id": "Pará",
  "description": "Pará"
  },
  {
  "id": "Paraíba",
  "description": "Paraíba"
  },
  {
  "id": "Paraná",
  "description": "Paraná"
  },
  {
  "id": "Pernambuco",
  "description": "Pernambuco"
  },
  {
  "id": "Piauí",
  "description": "Piauí"
  },
  {
  "id": "Rio de Janeiro",
  "description": "Rio de Janeiro"
  },
  {
  "id": "Rio Grande do Norte",
  "description": "Rio Grande do Norte"
  },
  {
  "id": "Rio Grande do Sul",
  "description": "Rio Grande do Sul"
  },
  {
  "id": "Rondônia",
  "description": "Rondônia"
  },
  {
  "id": "Roraima",
  "description": "Roraima"
  },
  {
  "id": "Santa Catarina",
  "description": "Santa Catarina"
  },
  {
  "id": "São Paulo",
  "description": "São Paulo"
  },
  {
  "id": "Sergipe",
  "description": "Sergipe"
  },
  {
  "id": "Tocantins",
  "description": "Tocantins"
  }
  ]
  },
  {
  "code": "IO",
  "description": "Bristish Indian Ocean Territory",
  "regions": []
  },
  {
  "code": "BN",
  "description": "Brunei Darussalam",
  "regions": [
  {
  "id": "Belait",
  "description": "Belait"
  },
  {
  "id": "Brunei-Muara District",
  "description": "Brunei-Muara District"
  },
  {
  "id": "Temburong",
  "description": "Temburong"
  },
  {
  "id": "Tutong",
  "description": "Tutong"
  }
  ]
  },
  {
  "code": "BG",
  "description": "Bulgaria",
  "regions": [
  {
  "id": "Blagoevgrad",
  "description": "Blagoevgrad"
  },
  {
  "id": "Burgas",
  "description": "Burgas"
  },
  {
  "id": "Dobrich",
  "description": "Dobrich"
  },
  {
  "id": "Gabrovo",
  "description": "Gabrovo"
  },
  {
  "id": "Haskovo",
  "description": "Haskovo"
  },
  {
  "id": "Kardzhali",
  "description": "Kardzhali"
  },
  {
  "id": "Kyustendil",
  "description": "Kyustendil"
  },
  {
  "id": "Lovech",
  "description": "Lovech"
  },
  {
  "id": "Montana",
  "description": "Montana"
  },
  {
  "id": "Pazardzhik",
  "description": "Pazardzhik"
  },
  {
  "id": "Pernik",
  "description": "Pernik"
  },
  {
  "id": "Pleven",
  "description": "Pleven"
  },
  {
  "id": "Plovdiv",
  "description": "Plovdiv"
  },
  {
  "id": "Razgrad",
  "description": "Razgrad"
  },
  {
  "id": "Ruse",
  "description": "Ruse"
  },
  {
  "id": "Shumen",
  "description": "Shumen"
  },
  {
  "id": "Silistra",
  "description": "Silistra"
  },
  {
  "id": "Sliven",
  "description": "Sliven"
  },
  {
  "id": "Smolyan",
  "description": "Smolyan"
  },
  {
  "id": "Sofia",
  "description": "Sofia"
  },
  {
  "id": "Sofia-Capital",
  "description": "Sofia-Capital"
  },
  {
  "id": "Stara Zagora",
  "description": "Stara Zagora"
  },
  {
  "id": "Targovishte",
  "description": "Targovishte"
  },
  {
  "id": "Varna",
  "description": "Varna"
  },
  {
  "id": "Veliko Tarnovo",
  "description": "Veliko Tarnovo"
  },
  {
  "id": "Vidin",
  "description": "Vidin"
  },
  {
  "id": "Vratsa",
  "description": "Vratsa"
  },
  {
  "id": "Yambol",
  "description": "Yambol"
  }
  ]
  },
  {
  "code": "BF",
  "description": "Burkina Faso",
  "regions": [
  {
  "id": "Boucle du Mouhoun",
  "description": "Boucle du Mouhoun"
  },
  {
  "id": "Cascades Region",
  "description": "Cascades Region"
  },
  {
  "id": "Centre",
  "description": "Centre"
  },
  {
  "id": "Centre-Est",
  "description": "Centre-Est"
  },
  {
  "id": "Centre-Nord",
  "description": "Centre-Nord"
  },
  {
  "id": "Centre-Ouest",
  "description": "Centre-Ouest"
  },
  {
  "id": "Centre-Sud",
  "description": "Centre-Sud"
  },
  {
  "id": "Est",
  "description": "Est"
  },
  {
  "id": "Hauts-Bassins",
  "description": "Hauts-Bassins"
  },
  {
  "id": "Nord",
  "description": "Nord"
  },
  {
  "id": "Plateau-Central",
  "description": "Plateau-Central"
  },
  {
  "id": "Sahel",
  "description": "Sahel"
  },
  {
  "id": "Sud-Ouest",
  "description": "Sud-Ouest"
  }
  ]
  },
  {
  "code": "BI",
  "description": "Burundi",
  "regions": [
  {
  "id": "Bubanza",
  "description": "Bubanza"
  },
  {
  "id": "Bujumbura Mairie",
  "description": "Bujumbura Mairie"
  },
  {
  "id": "Bujumbura Rural",
  "description": "Bujumbura Rural"
  },
  {
  "id": "Bururi",
  "description": "Bururi"
  },
  {
  "id": "Cankuzo",
  "description": "Cankuzo"
  },
  {
  "id": "Cibitoke",
  "description": "Cibitoke"
  },
  {
  "id": "Gitega",
  "description": "Gitega"
  },
  {
  "id": "Karuzi",
  "description": "Karuzi"
  },
  {
  "id": "Kayanza",
  "description": "Kayanza"
  },
  {
  "id": "Kirundo",
  "description": "Kirundo"
  },
  {
  "id": "Makamba",
  "description": "Makamba"
  },
  {
  "id": "Muramvya",
  "description": "Muramvya"
  },
  {
  "id": "Muyinga",
  "description": "Muyinga"
  },
  {
  "id": "Mwaro",
  "description": "Mwaro"
  },
  {
  "id": "Ngozi",
  "description": "Ngozi"
  },
  {
  "id": "Rumonge",
  "description": "Rumonge"
  },
  {
  "id": "Rutana",
  "description": "Rutana"
  },
  {
  "id": "Ruyigi",
  "description": "Ruyigi"
  }
  ]
  },
  {
  "code": "KH",
  "description": "Cambodia",
  "regions": [
  {
  "id": "Banteay Meanchey",
  "description": "Banteay Meanchey"
  },
  {
  "id": "Battambang",
  "description": "Battambang"
  },
  {
  "id": "Kampong Cham",
  "description": "Kampong Cham"
  },
  {
  "id": "Kampong Chhnang",
  "description": "Kampong Chhnang"
  },
  {
  "id": "Kampong Speu Province",
  "description": "Kampong Speu Province"
  },
  {
  "id": "Kampong Thom",
  "description": "Kampong Thom"
  },
  {
  "id": "Kampot",
  "description": "Kampot"
  },
  {
  "id": "Kandal",
  "description": "Kandal"
  },
  {
  "id": "Kep",
  "description": "Kep"
  },
  {
  "id": "Koh Kong",
  "description": "Koh Kong"
  },
  {
  "id": "Kratie",
  "description": "Kratie"
  },
  {
  "id": "Mondolkiri",
  "description": "Mondolkiri"
  },
  {
  "id": "Ŏtâr Méanchey",
  "description": "Ŏtâr Méanchey"
  },
  {
  "id": "Pailin",
  "description": "Pailin"
  },
  {
  "id": "Phnom Penh",
  "description": "Phnom Penh"
  },
  {
  "id": "Preah Sihanouk",
  "description": "Preah Sihanouk"
  },
  {
  "id": "Preah Vihear",
  "description": "Preah Vihear"
  },
  {
  "id": "Prey Veng",
  "description": "Prey Veng"
  },
  {
  "id": "Pursat",
  "description": "Pursat"
  },
  {
  "id": "Ratanakiri",
  "description": "Ratanakiri"
  },
  {
  "id": "Siem Reap",
  "description": "Siem Reap"
  },
  {
  "id": "Stung Treng",
  "description": "Stung Treng"
  },
  {
  "id": "Svay Rieng",
  "description": "Svay Rieng"
  },
  {
  "id": "Takeo",
  "description": "Takeo"
  },
  {
  "id": "Tboung Khmum",
  "description": "Tboung Khmum"
  }
  ]
  },
  {
  "code": "CM",
  "description": "Cameroon",
  "regions": [
  {
  "id": "Adamaoua",
  "description": "Adamaoua"
  },
  {
  "id": "Centre",
  "description": "Centre"
  },
  {
  "id": "East",
  "description": "East"
  },
  {
  "id": "Far North",
  "description": "Far North"
  },
  {
  "id": "Littoral",
  "description": "Littoral"
  },
  {
  "id": "North",
  "description": "North"
  },
  {
  "id": "North-West",
  "description": "North-West"
  },
  {
  "id": "South",
  "description": "South"
  },
  {
  "id": "South-West",
  "description": "South-West"
  },
  {
  "id": "West",
  "description": "West"
  }
  ]
  },
  {
  "code": "CA",
  "description": "Canada",
  "regions": [
  {
  "id": "AB",
  "description": "Alberta"
  },
  {
  "id": "BC",
  "description": "British Columbia"
  },
  {
  "id": "MB",
  "description": "Manitoba"
  },
  {
  "id": "NB",
  "description": "New Brunswick"
  },
  {
  "id": "NL",
  "description": "Newfoundland"
  },
  {
  "id": "NS",
  "description": "Nova Scotia"
  },
  {
  "id": "NT",
  "description": "Northwest Territories"
  },
  {
  "id": "NU",
  "description": "Nunavut"
  },
  {
  "id": "ON",
  "description": "Ontario"
  },
  {
  "id": "PE",
  "description": "Prince Edward Island"
  },
  {
  "id": "QC",
  "description": "Quebec"
  },
  {
  "id": "SK",
  "description": "Saskatchewan"
  },
  {
  "id": "YT",
  "description": "Yukon Territory"
  }
  ]
  },
  {
  "code": "CV",
  "description": "Cape Verde",
  "regions": [
  {
  "id": "Boa Vista",
  "description": "Boa Vista"
  },
  {
  "id": "Brava",
  "description": "Brava"
  },
  {
  "id": "Maio",
  "description": "Maio"
  },
  {
  "id": "Mosteiros",
  "description": "Mosteiros"
  },
  {
  "id": "Paul",
  "description": "Paul"
  },
  {
  "id": "Porto Novo",
  "description": "Porto Novo"
  },
  {
  "id": "Praia",
  "description": "Praia"
  },
  {
  "id": "Ribeira Brava",
  "description": "Ribeira Brava"
  },
  {
  "id": "Ribeira Grande",
  "description": "Ribeira Grande"
  },
  {
  "id": "Ribeira Grande de Santiago",
  "description": "Ribeira Grande de Santiago"
  },
  {
  "id": "Sal",
  "description": "Sal"
  },
  {
  "id": "Santa Catarina",
  "description": "Santa Catarina"
  },
  {
  "id": "Santa Catarina do Fogo",
  "description": "Santa Catarina do Fogo"
  },
  {
  "id": "Santa Cruz",
  "description": "Santa Cruz"
  },
  {
  "id": "São Domingos",
  "description": "São Domingos"
  },
  {
  "id": "São Filipe",
  "description": "São Filipe"
  },
  {
  "id": "São Lourenço dos Órgãos",
  "description": "São Lourenço dos Órgãos"
  },
  {
  "id": "São Miguel",
  "description": "São Miguel"
  },
  {
  "id": "São Salvador do Mundo",
  "description": "São Salvador do Mundo"
  },
  {
  "id": "São Vicente",
  "description": "São Vicente"
  },
  {
  "id": "Tarrafal",
  "description": "Tarrafal"
  },
  {
  "id": "Tarrafal de São Nicolau",
  "description": "Tarrafal de São Nicolau"
  }
  ]
  },
  {
  "code": "KY",
  "description": "Cayman Islands",
  "regions": [
  {
  "id": "Bodden Town",
  "description": "Bodden Town"
  },
  {
  "id": "East End",
  "description": "East End"
  },
  {
  "id": "George Town",
  "description": "George Town"
  },
  {
  "id": "North Side",
  "description": "North Side"
  },
  {
  "id": "Sister Island",
  "description": "Sister Island"
  },
  {
  "id": "West Bay",
  "description": "West Bay"
  }
  ]
  },
  {
  "code": "CF",
  "description": "Central African Republic",
  "regions": [
  {
  "id": "Bamingui-Bangoran",
  "description": "Bamingui-Bangoran"
  },
  {
  "id": "Bangui",
  "description": "Bangui"
  },
  {
  "id": "Basse-Kotto",
  "description": "Basse-Kotto"
  },
  {
  "id": "Haute-Kotto",
  "description": "Haute-Kotto"
  },
  {
  "id": "Haut-Mbomou",
  "description": "Haut-Mbomou"
  },
  {
  "id": "Kémo",
  "description": "Kémo"
  },
  {
  "id": "Lim-Pendé",
  "description": "Lim-Pendé"
  },
  {
  "id": "Lobaye",
  "description": "Lobaye"
  },
  {
  "id": "Mambéré",
  "description": "Mambéré"
  },
  {
  "id": "Mambéré-Kadéï",
  "description": "Mambéré-Kadéï"
  },
  {
  "id": "Mbomou",
  "description": "Mbomou"
  },
  {
  "id": "Nana-Grébizi",
  "description": "Nana-Grébizi"
  },
  {
  "id": "Nana-Mambéré",
  "description": "Nana-Mambéré"
  },
  {
  "id": "Ombella-M'Poko",
  "description": "Ombella-M'Poko"
  },
  {
  "id": "Ouaka",
  "description": "Ouaka"
  },
  {
  "id": "Ouham",
  "description": "Ouham"
  },
  {
  "id": "Ouham-Fafa",
  "description": "Ouham-Fafa"
  },
  {
  "id": "Ouham-Pendé",
  "description": "Ouham-Pendé"
  },
  {
  "id": "Sangha-Mbaéré",
  "description": "Sangha-Mbaéré"
  },
  {
  "id": "Vakaga",
  "description": "Vakaga"
  }
  ]
  },
  {
  "code": "TD",
  "description": "Chad",
  "regions": [
  {
  "id": "Barh el Gazel",
  "description": "Barh el Gazel"
  },
  {
  "id": "Batha",
  "description": "Batha"
  },
  {
  "id": "Borkou",
  "description": "Borkou"
  },
  {
  "id": "Chari-Baguirmi",
  "description": "Chari-Baguirmi"
  },
  {
  "id": "Ennedi-Est",
  "description": "Ennedi-Est"
  },
  {
  "id": "Ennedi-Ouest",
  "description": "Ennedi-Ouest"
  },
  {
  "id": "Guéra",
  "description": "Guéra"
  },
  {
  "id": "Hadjer-Lamis",
  "description": "Hadjer-Lamis"
  },
  {
  "id": "Kanem",
  "description": "Kanem"
  },
  {
  "id": "Lac",
  "description": "Lac"
  },
  {
  "id": "Logone Occidental",
  "description": "Logone Occidental"
  },
  {
  "id": "Logone Oriental",
  "description": "Logone Oriental"
  },
  {
  "id": "Mandoul",
  "description": "Mandoul"
  },
  {
  "id": "Mayo-Kebbi Est",
  "description": "Mayo-Kebbi Est"
  },
  {
  "id": "Mayo-Kebbi Ouest",
  "description": "Mayo-Kebbi Ouest"
  },
  {
  "id": "Moyen-Chari",
  "description": "Moyen-Chari"
  },
  {
  "id": "N’Djaména",
  "description": "N’Djaména"
  },
  {
  "id": "Ouadaï",
  "description": "Ouadaï"
  },
  {
  "id": "Salamat",
  "description": "Salamat"
  },
  {
  "id": "Sila",
  "description": "Sila"
  },
  {
  "id": "Tandjilé",
  "description": "Tandjilé"
  },
  {
  "id": "Tibesti",
  "description": "Tibesti"
  },
  {
  "id": "Wadi Fira",
  "description": "Wadi Fira"
  }
  ]
  },
  {
  "code": "CL",
  "description": "Chile",
  "regions": [
  {
  "id": "Antofagasta",
  "description": "Antofagasta"
  },
  {
  "id": "Araucanía",
  "description": "Araucanía"
  },
  {
  "id": "Arica y Parinacota Region",
  "description": "Arica y Parinacota Region"
  },
  {
  "id": "Atacama",
  "description": "Atacama"
  },
  {
  "id": "Aysén",
  "description": "Aysén"
  },
  {
  "id": "Biobío",
  "description": "Biobío"
  },
  {
  "id": "Coquimbo Region",
  "description": "Coquimbo Region"
  },
  {
  "id": "Los Lagos Region",
  "description": "Los Lagos Region"
  },
  {
  "id": "Los Ríos Region",
  "description": "Los Ríos Region"
  },
  {
  "id": "Maule Region",
  "description": "Maule Region"
  },
  {
  "id": "Ñuble",
  "description": "Ñuble"
  },
  {
  "id": "O'Higgins Region",
  "description": "O'Higgins Region"
  },
  {
  "id": "Region of Magallanes",
  "description": "Region of Magallanes"
  },
  {
  "id": "Santiago Metropolitan",
  "description": "Santiago Metropolitan"
  },
  {
  "id": "Tarapacá",
  "description": "Tarapacá"
  },
  {
  "id": "Valparaíso",
  "description": "Valparaíso"
  }
  ]
  },
  {
  "code": "CN",
  "description": "China",
  "regions": [
  {
  "id": "Anhui",
  "description": "Anhui"
  },
  {
  "id": "Beijing",
  "description": "Beijing"
  },
  {
  "id": "Chongqing",
  "description": "Chongqing"
  },
  {
  "id": "Fujian",
  "description": "Fujian"
  },
  {
  "id": "Gansu",
  "description": "Gansu"
  },
  {
  "id": "Guangdong",
  "description": "Guangdong"
  },
  {
  "id": "Guangxi",
  "description": "Guangxi"
  },
  {
  "id": "Guizhou",
  "description": "Guizhou"
  },
  {
  "id": "Hainan",
  "description": "Hainan"
  },
  {
  "id": "Hebei",
  "description": "Hebei"
  },
  {
  "id": "Heilongjiang",
  "description": "Heilongjiang"
  },
  {
  "id": "Henan",
  "description": "Henan"
  },
  {
  "id": "Hubei",
  "description": "Hubei"
  },
  {
  "id": "Hunan",
  "description": "Hunan"
  },
  {
  "id": "Inner Mongolia",
  "description": "Inner Mongolia"
  },
  {
  "id": "Jiangsu",
  "description": "Jiangsu"
  },
  {
  "id": "Jiangxi",
  "description": "Jiangxi"
  },
  {
  "id": "Jilin",
  "description": "Jilin"
  },
  {
  "id": "Liaoning",
  "description": "Liaoning"
  },
  {
  "id": "Ningxia",
  "description": "Ningxia"
  },
  {
  "id": "Qinghai",
  "description": "Qinghai"
  },
  {
  "id": "Shaanxi",
  "description": "Shaanxi"
  },
  {
  "id": "Shandong",
  "description": "Shandong"
  },
  {
  "id": "Shanghai",
  "description": "Shanghai"
  },
  {
  "id": "Shanxi",
  "description": "Shanxi"
  },
  {
  "id": "Sichuan",
  "description": "Sichuan"
  },
  {
  "id": "Tianjin",
  "description": "Tianjin"
  },
  {
  "id": "Tibet",
  "description": "Tibet"
  },
  {
  "id": "Xinjiang",
  "description": "Xinjiang"
  },
  {
  "id": "Yunnan",
  "description": "Yunnan"
  },
  {
  "id": "Zhejiang",
  "description": "Zhejiang"
  }
  ]
  },
  {
  "code": "CX",
  "description": "Christmas Island",
  "regions": []
  },
  {
  "code": "CO",
  "description": "Colombia",
  "regions": [
  {
  "id": "Amazonas Department",
  "description": "Amazonas Department"
  },
  {
  "id": "Antioquia",
  "description": "Antioquia"
  },
  {
  "id": "Arauca Department",
  "description": "Arauca Department"
  },
  {
  "id": "Atlántico",
  "description": "Atlántico"
  },
  {
  "id": "Bogota D.C.",
  "description": "Bogota D.C."
  },
  {
  "id": "Bolívar",
  "description": "Bolívar"
  },
  {
  "id": "Boyacá",
  "description": "Boyacá"
  },
  {
  "id": "Caldas Department",
  "description": "Caldas Department"
  },
  {
  "id": "Caquetá",
  "description": "Caquetá"
  },
  {
  "id": "Casanare Department",
  "description": "Casanare Department"
  },
  {
  "id": "Cauca Department",
  "description": "Cauca Department"
  },
  {
  "id": "Cesar Department",
  "description": "Cesar Department"
  },
  {
  "id": "Chocó",
  "description": "Chocó"
  },
  {
  "id": "Córdoba",
  "description": "Córdoba"
  },
  {
  "id": "Cundinamarca",
  "description": "Cundinamarca"
  },
  {
  "id": "Guainía Department",
  "description": "Guainía Department"
  },
  {
  "id": "Guaviare Department",
  "description": "Guaviare Department"
  },
  {
  "id": "Huila Department",
  "description": "Huila Department"
  },
  {
  "id": "La Guajira Department",
  "description": "La Guajira Department"
  },
  {
  "id": "Magdalena Department",
  "description": "Magdalena Department"
  },
  {
  "id": "Meta Department",
  "description": "Meta Department"
  },
  {
  "id": "Nariño",
  "description": "Nariño"
  },
  {
  "id": "Norte de Santander Department",
  "description": "Norte de Santander Department"
  },
  {
  "id": "Putumayo Department",
  "description": "Putumayo Department"
  },
  {
  "id": "Quindío Department",
  "description": "Quindío Department"
  },
  {
  "id": "Risaralda Department",
  "description": "Risaralda Department"
  },
  {
  "id": "San Andres y Providencia",
  "description": "San Andres y Providencia"
  },
  {
  "id": "Santander Department",
  "description": "Santander Department"
  },
  {
  "id": "Sucre Department",
  "description": "Sucre Department"
  },
  {
  "id": "Tolima Department",
  "description": "Tolima Department"
  },
  {
  "id": "Valle del Cauca Department",
  "description": "Valle del Cauca Department"
  },
  {
  "id": "Vaupés",
  "description": "Vaupés"
  },
  {
  "id": "Vichada Department",
  "description": "Vichada Department"
  }
  ]
  },
  {
  "code": "KM",
  "description": "Comoros",
  "regions": [
  {
  "id": "Anjouan",
  "description": "Anjouan"
  },
  {
  "id": "Grande Comore",
  "description": "Grande Comore"
  },
  {
  "id": "Mohéli",
  "description": "Mohéli"
  }
  ]
  },
  {
  "code": "CG",
  "description": "Congo, Republic of ",
  "regions": [
  {
  "id": "Bouenza",
  "description": "Bouenza"
  },
  {
  "id": "Brazzaville",
  "description": "Brazzaville"
  },
  {
  "id": "Cuvette",
  "description": "Cuvette"
  },
  {
  "id": "Cuvette-Ouest",
  "description": "Cuvette-Ouest"
  },
  {
  "id": "Kouilou",
  "description": "Kouilou"
  },
  {
  "id": "Lékoumou",
  "description": "Lékoumou"
  },
  {
  "id": "Likouala",
  "description": "Likouala"
  },
  {
  "id": "Niari",
  "description": "Niari"
  },
  {
  "id": "Plateaux",
  "description": "Plateaux"
  },
  {
  "id": "Pointe-Noire",
  "description": "Pointe-Noire"
  },
  {
  "id": "Pool",
  "description": "Pool"
  },
  {
  "id": "Sangha",
  "description": "Sangha"
  }
  ]
  },
  {
  "code": "CK",
  "description": "Cook Islands",
  "regions": [
  {
  "id": "Aitutaki",
  "description": "Aitutaki"
  },
  {
  "id": "Atiu",
  "description": "Atiu"
  },
  {
  "id": "Mangaia",
  "description": "Mangaia"
  },
  {
  "id": "Manihiki",
  "description": "Manihiki"
  },
  {
  "id": "Ma'uke",
  "description": "Ma'uke"
  },
  {
  "id": "Mitiaro",
  "description": "Mitiaro"
  },
  {
  "id": "Palmerston",
  "description": "Palmerston"
  },
  {
  "id": "Penrhyn",
  "description": "Penrhyn"
  },
  {
  "id": "Pukapuka",
  "description": "Pukapuka"
  },
  {
  "id": "Rakahanga",
  "description": "Rakahanga"
  },
  {
  "id": "Rarotonga",
  "description": "Rarotonga"
  }
  ]
  },
  {
  "code": "CR",
  "description": "Costa Rica",
  "regions": [
  {
  "id": "Alajuela Province",
  "description": "Alajuela Province"
  },
  {
  "id": "Cartago Province",
  "description": "Cartago Province"
  },
  {
  "id": "Guanacaste Province",
  "description": "Guanacaste Province"
  },
  {
  "id": "Heredia Province",
  "description": "Heredia Province"
  },
  {
  "id": "Limón Province",
  "description": "Limón Province"
  },
  {
  "id": "Puntarenas Province",
  "description": "Puntarenas Province"
  },
  {
  "id": "San José",
  "description": "San José"
  }
  ]
  },
  {
  "code": "CI",
  "description": "Cote d'Ivoire (Ivory Coast)",
  "regions": [
  {
  "id": "Abidjan",
  "description": "Abidjan"
  },
  {
  "id": "Bas-Sassandra District",
  "description": "Bas-Sassandra District"
  },
  {
  "id": "Comoé",
  "description": "Comoé"
  },
  {
  "id": "Denguélé District",
  "description": "Denguélé District"
  },
  {
  "id": "Gôh-Djiboua",
  "description": "Gôh-Djiboua"
  },
  {
  "id": "Lacs District",
  "description": "Lacs District"
  },
  {
  "id": "Lagunes District",
  "description": "Lagunes District"
  },
  {
  "id": "Montagnes",
  "description": "Montagnes"
  },
  {
  "id": "Sassandra-Marahoué",
  "description": "Sassandra-Marahoué"
  },
  {
  "id": "Savanes District",
  "description": "Savanes District"
  },
  {
  "id": "Vallée du Bandama District",
  "description": "Vallée du Bandama District"
  },
  {
  "id": "Woroba",
  "description": "Woroba"
  },
  {
  "id": "Yamoussoukro",
  "description": "Yamoussoukro"
  },
  {
  "id": "Zanzan District",
  "description": "Zanzan District"
  }
  ]
  },
  {
  "code": "HR",
  "description": "Croatia (Hrvatska)",
  "regions": [
  {
  "id": "Bjelovar-Bilogora",
  "description": "Bjelovar-Bilogora"
  },
  {
  "id": "Brod-Posavina",
  "description": "Brod-Posavina"
  },
  {
  "id": "County of Osijek-Baranja",
  "description": "County of Osijek-Baranja"
  },
  {
  "id": "Dubrovnik-Neretva",
  "description": "Dubrovnik-Neretva"
  },
  {
  "id": "Istria",
  "description": "Istria"
  },
  {
  "id": "Karlovac",
  "description": "Karlovac"
  },
  {
  "id": "Koprivnica-Križevci",
  "description": "Koprivnica-Križevci"
  },
  {
  "id": "Krapina-Zagorje",
  "description": "Krapina-Zagorje"
  },
  {
  "id": "Lika-Senj",
  "description": "Lika-Senj"
  },
  {
  "id": "Međimurje",
  "description": "Međimurje"
  },
  {
  "id": "Požega-Slavonia",
  "description": "Požega-Slavonia"
  },
  {
  "id": "Primorje-Gorski Kotar",
  "description": "Primorje-Gorski Kotar"
  },
  {
  "id": "Šibenik-Knin",
  "description": "Šibenik-Knin"
  },
  {
  "id": "Sisak-Moslavina",
  "description": "Sisak-Moslavina"
  },
  {
  "id": "Split-Dalmatia",
  "description": "Split-Dalmatia"
  },
  {
  "id": "Varaždin",
  "description": "Varaždin"
  },
  {
  "id": "Virovitica-Podravina",
  "description": "Virovitica-Podravina"
  },
  {
  "id": "Vukovar-Srijem",
  "description": "Vukovar-Srijem"
  },
  {
  "id": "Zadar",
  "description": "Zadar"
  },
  {
  "id": "Zagreb",
  "description": "Zagreb"
  },
  {
  "id": "Zagreb County",
  "description": "Zagreb County"
  }
  ]
  },
  {
  "code": "CU",
  "description": "Cuba",
  "regions": [
  {
  "id": "Artemisa",
  "description": "Artemisa"
  },
  {
  "id": "Camagüey",
  "description": "Camagüey"
  },
  {
  "id": "Ciego de Ávila Province",
  "description": "Ciego de Ávila Province"
  },
  {
  "id": "Cienfuegos Province",
  "description": "Cienfuegos Province"
  },
  {
  "id": "Granma Province",
  "description": "Granma Province"
  },
  {
  "id": "Guantánamo Province",
  "description": "Guantánamo Province"
  },
  {
  "id": "Havana",
  "description": "Havana"
  },
  {
  "id": "Holguín Province",
  "description": "Holguín Province"
  },
  {
  "id": "Isla de la Juventud",
  "description": "Isla de la Juventud"
  },
  {
  "id": "Las Tunas Province",
  "description": "Las Tunas Province"
  },
  {
  "id": "Matanzas Province",
  "description": "Matanzas Province"
  },
  {
  "id": "Mayabeque",
  "description": "Mayabeque"
  },
  {
  "id": "Pinar del Río",
  "description": "Pinar del Río"
  },
  {
  "id": "Sancti Spíritus Province",
  "description": "Sancti Spíritus Province"
  },
  {
  "id": "Santiago de Cuba Province",
  "description": "Santiago de Cuba Province"
  },
  {
  "id": "Villa Clara Province",
  "description": "Villa Clara Province"
  }
  ]
  },
  {
  "code": "CW",
  "description": "Curacao",
  "regions": []
  },
  {
  "code": "CY",
  "description": "Cyprus",
  "regions": [
  {
  "id": "Ammochostos",
  "description": "Ammochostos"
  },
  {
  "id": "Keryneia",
  "description": "Keryneia"
  },
  {
  "id": "Larnaka",
  "description": "Larnaka"
  },
  {
  "id": "Limassol",
  "description": "Limassol"
  },
  {
  "id": "Nicosia",
  "description": "Nicosia"
  },
  {
  "id": "Pafos",
  "description": "Pafos"
  }
  ]
  },
  {
  "code": "CZ",
  "description": "Czech Republic",
  "regions": [
  {
  "id": "Central Bohemia",
  "description": "Central Bohemia"
  },
  {
  "id": "Jihočeský kraj",
  "description": "Jihočeský kraj"
  },
  {
  "id": "Karlovarský kraj",
  "description": "Karlovarský kraj"
  },
  {
  "id": "Královéhradecký kraj",
  "description": "Královéhradecký kraj"
  },
  {
  "id": "Liberecký kraj",
  "description": "Liberecký kraj"
  },
  {
  "id": "Moravskoslezský",
  "description": "Moravskoslezský"
  },
  {
  "id": "Olomoucký",
  "description": "Olomoucký"
  },
  {
  "id": "Pardubický",
  "description": "Pardubický"
  },
  {
  "id": "Plzeň Region",
  "description": "Plzeň Region"
  },
  {
  "id": "Prague",
  "description": "Prague"
  },
  {
  "id": "South Moravian",
  "description": "South Moravian"
  },
  {
  "id": "Ústecký kraj",
  "description": "Ústecký kraj"
  },
  {
  "id": "Vysočina",
  "description": "Vysočina"
  },
  {
  "id": "Zlín",
  "description": "Zlín"
  }
  ]
  },
  {
  "code": "CD",
  "description": "Democratic Republic of the Congo",
  "regions": [
  {
  "id": "Bas-Congo",
  "description": "Bas-Congo"
  },
  {
  "id": "Bas-Uele",
  "description": "Bas-Uele"
  },
  {
  "id": "Équateur",
  "description": "Équateur"
  },
  {
  "id": "Haut-Katanga",
  "description": "Haut-Katanga"
  },
  {
  "id": "Haut-Lomami",
  "description": "Haut-Lomami"
  },
  {
  "id": "Haut-Uele",
  "description": "Haut-Uele"
  },
  {
  "id": "Ituri",
  "description": "Ituri"
  },
  {
  "id": "Kasai",
  "description": "Kasai"
  },
  {
  "id": "Kasai-Central",
  "description": "Kasai-Central"
  },
  {
  "id": "Kasaï-Oriental",
  "description": "Kasaï-Oriental"
  },
  {
  "id": "Kinshasa",
  "description": "Kinshasa"
  },
  {
  "id": "Kwango",
  "description": "Kwango"
  },
  {
  "id": "Kwilu",
  "description": "Kwilu"
  },
  {
  "id": "Lomami",
  "description": "Lomami"
  },
  {
  "id": "Lualaba",
  "description": "Lualaba"
  },
  {
  "id": "Mai-Ndombe",
  "description": "Mai-Ndombe"
  },
  {
  "id": "Maniema",
  "description": "Maniema"
  },
  {
  "id": "Mongala",
  "description": "Mongala"
  },
  {
  "id": "Nord Kivu",
  "description": "Nord Kivu"
  },
  {
  "id": "Nord-Ubangi",
  "description": "Nord-Ubangi"
  },
  {
  "id": "Sankuru",
  "description": "Sankuru"
  },
  {
  "id": "South Kivu",
  "description": "South Kivu"
  },
  {
  "id": "Sud-Ubangi",
  "description": "Sud-Ubangi"
  },
  {
  "id": "Tanganyika",
  "description": "Tanganyika"
  },
  {
  "id": "Tshopo",
  "description": "Tshopo"
  },
  {
  "id": "Tshuapa",
  "description": "Tshuapa"
  }
  ]
  },
  {
  "code": "DK",
  "description": "Denmark",
  "regions": [
  {
  "id": "Capital Region",
  "description": "Capital Region"
  },
  {
  "id": "Central Jutland",
  "description": "Central Jutland"
  },
  {
  "id": "North Denmark",
  "description": "North Denmark"
  },
  {
  "id": "South Denmark",
  "description": "South Denmark"
  },
  {
  "id": "Zealand",
  "description": "Zealand"
  }
  ]
  },
  {
  "code": "DJ",
  "description": "Djibouti",
  "regions": [
  {
  "id": "Ali Sabieh",
  "description": "Ali Sabieh"
  },
  {
  "id": "Arta",
  "description": "Arta"
  },
  {
  "id": "Dikhil",
  "description": "Dikhil"
  },
  {
  "id": "Djibouti",
  "description": "Djibouti"
  },
  {
  "id": "Obock",
  "description": "Obock"
  },
  {
  "id": "Tadjourah",
  "description": "Tadjourah"
  }
  ]
  },
  {
  "code": "DM",
  "description": "Dominica",
  "regions": [
  {
  "id": "Saint Andrew Parish",
  "description": "Saint Andrew Parish"
  },
  {
  "id": "Saint David Parish",
  "description": "Saint David Parish"
  },
  {
  "id": "Saint George Parish",
  "description": "Saint George Parish"
  },
  {
  "id": "Saint John Parish",
  "description": "Saint John Parish"
  },
  {
  "id": "Saint Joseph Parish",
  "description": "Saint Joseph Parish"
  },
  {
  "id": "Saint Luke Parish",
  "description": "Saint Luke Parish"
  },
  {
  "id": "Saint Mark Parish",
  "description": "Saint Mark Parish"
  },
  {
  "id": "Saint Patrick Parish",
  "description": "Saint Patrick Parish"
  },
  {
  "id": "Saint Paul Parish",
  "description": "Saint Paul Parish"
  },
  {
  "id": "Saint Peter Parish",
  "description": "Saint Peter Parish"
  }
  ]
  },
  {
  "code": "DO",
  "description": "Dominican Republic",
  "regions": [
  {
  "id": "Azua Province",
  "description": "Azua Province"
  },
  {
  "id": "Baoruco Province",
  "description": "Baoruco Province"
  },
  {
  "id": "Barahona Province",
  "description": "Barahona Province"
  },
  {
  "id": "Dajabón",
  "description": "Dajabón"
  },
  {
  "id": "Duarte Province",
  "description": "Duarte Province"
  },
  {
  "id": "Elías Piña",
  "description": "Elías Piña"
  },
  {
  "id": "El Seíbo",
  "description": "El Seíbo"
  },
  {
  "id": "Espaillat Province",
  "description": "Espaillat Province"
  },
  {
  "id": "Hato Mayor Province",
  "description": "Hato Mayor Province"
  },
  {
  "id": "Hermanas Mirabal",
  "description": "Hermanas Mirabal"
  },
  {
  "id": "Independencia",
  "description": "Independencia"
  },
  {
  "id": "La Altagracia Province",
  "description": "La Altagracia Province"
  },
  {
  "id": "La Romana",
  "description": "La Romana"
  },
  {
  "id": "La Vega",
  "description": "La Vega"
  },
  {
  "id": "María Trinidad Sánchez",
  "description": "María Trinidad Sánchez"
  },
  {
  "id": "Monseñor Nouel",
  "description": "Monseñor Nouel"
  },
  {
  "id": "Monte Cristi Province",
  "description": "Monte Cristi Province"
  },
  {
  "id": "Monte Plata Province",
  "description": "Monte Plata Province"
  },
  {
  "id": "Nacional",
  "description": "Nacional"
  },
  {
  "id": "Pedernales Province",
  "description": "Pedernales Province"
  },
  {
  "id": "Peravia",
  "description": "Peravia"
  },
  {
  "id": "Puerto Plata",
  "description": "Puerto Plata"
  },
  {
  "id": "Samaná",
  "description": "Samaná"
  },
  {
  "id": "Sánchez Ramírez",
  "description": "Sánchez Ramírez"
  },
  {
  "id": "San Cristóbal",
  "description": "San Cristóbal"
  },
  {
  "id": "San José de Ocoa",
  "description": "San José de Ocoa"
  },
  {
  "id": "San Juan Province",
  "description": "San Juan Province"
  },
  {
  "id": "San Pedro de Macorís",
  "description": "San Pedro de Macorís"
  },
  {
  "id": "Santiago Province",
  "description": "Santiago Province"
  },
  {
  "id": "Santiago Rodríguez",
  "description": "Santiago Rodríguez"
  },
  {
  "id": "Santo Domingo Province",
  "description": "Santo Domingo Province"
  },
  {
  "id": "Valverde Province",
  "description": "Valverde Province"
  }
  ]
  },
  {
  "code": "EC",
  "description": "Ecuador",
  "regions": [
  {
  "id": "Azuay",
  "description": "Azuay"
  },
  {
  "id": "Bolívar",
  "description": "Bolívar"
  },
  {
  "id": "Cañar",
  "description": "Cañar"
  },
  {
  "id": "Carchi",
  "description": "Carchi"
  },
  {
  "id": "Chimborazo Province",
  "description": "Chimborazo Province"
  },
  {
  "id": "Cotopaxi",
  "description": "Cotopaxi"
  },
  {
  "id": "El Oro",
  "description": "El Oro"
  },
  {
  "id": "Esmeraldas",
  "description": "Esmeraldas"
  },
  {
  "id": "Galápagos",
  "description": "Galápagos"
  },
  {
  "id": "Guayas",
  "description": "Guayas"
  },
  {
  "id": "Imbabura",
  "description": "Imbabura"
  },
  {
  "id": "Loja",
  "description": "Loja"
  },
  {
  "id": "Los Ríos",
  "description": "Los Ríos"
  },
  {
  "id": "Manabí",
  "description": "Manabí"
  },
  {
  "id": "Morona-Santiago Province",
  "description": "Morona-Santiago Province"
  },
  {
  "id": "Napo",
  "description": "Napo"
  },
  {
  "id": "Orellana Province",
  "description": "Orellana Province"
  },
  {
  "id": "Pastaza Province",
  "description": "Pastaza Province"
  },
  {
  "id": "Pichincha",
  "description": "Pichincha"
  },
  {
  "id": "Santa Elena",
  "description": "Santa Elena"
  },
  {
  "id": "Santo Domingo de los Tsáchilas",
  "description": "Santo Domingo de los Tsáchilas"
  },
  {
  "id": "Sucumbíos",
  "description": "Sucumbíos"
  },
  {
  "id": "Tungurahua Province",
  "description": "Tungurahua Province"
  },
  {
  "id": "Zamora Chinchipe",
  "description": "Zamora Chinchipe"
  }
  ]
  },
  {
  "code": "EG",
  "description": "Egypt",
  "regions": [
  {
  "id": "Alexandria",
  "description": "Alexandria"
  },
  {
  "id": "Aswan",
  "description": "Aswan"
  },
  {
  "id": "Asyut",
  "description": "Asyut"
  },
  {
  "id": "Beheira",
  "description": "Beheira"
  },
  {
  "id": "Beni Suweif",
  "description": "Beni Suweif"
  },
  {
  "id": "Cairo",
  "description": "Cairo"
  },
  {
  "id": "Dakahlia",
  "description": "Dakahlia"
  },
  {
  "id": "Damietta",
  "description": "Damietta"
  },
  {
  "id": "Faiyum",
  "description": "Faiyum"
  },
  {
  "id": "Gharbia",
  "description": "Gharbia"
  },
  {
  "id": "Giza",
  "description": "Giza"
  },
  {
  "id": "Ismailia",
  "description": "Ismailia"
  },
  {
  "id": "Kafr el-Sheikh",
  "description": "Kafr el-Sheikh"
  },
  {
  "id": "Luxor",
  "description": "Luxor"
  },
  {
  "id": "Matruh",
  "description": "Matruh"
  },
  {
  "id": "Minya",
  "description": "Minya"
  },
  {
  "id": "Monufia",
  "description": "Monufia"
  },
  {
  "id": "New Valley",
  "description": "New Valley"
  },
  {
  "id": "North Sinai",
  "description": "North Sinai"
  },
  {
  "id": "Port Said",
  "description": "Port Said"
  },
  {
  "id": "Qalyubia",
  "description": "Qalyubia"
  },
  {
  "id": "Qena",
  "description": "Qena"
  },
  {
  "id": "Red Sea",
  "description": "Red Sea"
  },
  {
  "id": "Sharqia",
  "description": "Sharqia"
  },
  {
  "id": "Sohag",
  "description": "Sohag"
  },
  {
  "id": "South Sinai",
  "description": "South Sinai"
  },
  {
  "id": "Suez",
  "description": "Suez"
  }
  ]
  },
  {
  "code": "SV",
  "description": "El Salvador",
  "regions": [
  {
  "id": "Ahuachapán",
  "description": "Ahuachapán"
  },
  {
  "id": "Cabañas",
  "description": "Cabañas"
  },
  {
  "id": "Chalatenango Department",
  "description": "Chalatenango Department"
  },
  {
  "id": "Cuscatlán",
  "description": "Cuscatlán"
  },
  {
  "id": "La Libertad Department",
  "description": "La Libertad Department"
  },
  {
  "id": "La Paz Department",
  "description": "La Paz Department"
  },
  {
  "id": "La Unión",
  "description": "La Unión"
  },
  {
  "id": "Morazán",
  "description": "Morazán"
  },
  {
  "id": "San Miguel Department",
  "description": "San Miguel Department"
  },
  {
  "id": "San Salvador Department",
  "description": "San Salvador Department"
  },
  {
  "id": "Santa Ana Department",
  "description": "Santa Ana Department"
  },
  {
  "id": "San Vicente Department",
  "description": "San Vicente Department"
  },
  {
  "id": "Sonsonate Department",
  "description": "Sonsonate Department"
  },
  {
  "id": "Usulután",
  "description": "Usulután"
  }
  ]
  },
  {
  "code": "GQ",
  "description": "Equatorial Guinea",
  "regions": [
  {
  "id": "Annobon",
  "description": "Annobon"
  },
  {
  "id": "Bioko Norte",
  "description": "Bioko Norte"
  },
  {
  "id": "Bioko Sur",
  "description": "Bioko Sur"
  },
  {
  "id": "Centro Sur",
  "description": "Centro Sur"
  },
  {
  "id": "Djibloho",
  "description": "Djibloho"
  },
  {
  "id": "Kié-Ntem",
  "description": "Kié-Ntem"
  },
  {
  "id": "Litoral",
  "description": "Litoral"
  },
  {
  "id": "Wele-Nzas",
  "description": "Wele-Nzas"
  }
  ]
  },
  {
  "code": "ER",
  "description": "Eritrea",
  "regions": [
  {
  "id": "Anseba",
  "description": "Anseba"
  },
  {
  "id": "Debub",
  "description": "Debub"
  },
  {
  "id": "Gash-Barka",
  "description": "Gash-Barka"
  },
  {
  "id": "Maekel",
  "description": "Maekel"
  },
  {
  "id": "Northern Red Sea",
  "description": "Northern Red Sea"
  },
  {
  "id": "Southern Red Sea",
  "description": "Southern Red Sea"
  }
  ]
  },
  {
  "code": "EE",
  "description": "Estonia",
  "regions": [
  {
  "id": "Harjumaa",
  "description": "Harjumaa"
  },
  {
  "id": "Hiiumaa",
  "description": "Hiiumaa"
  },
  {
  "id": "Ida-Virumaa",
  "description": "Ida-Virumaa"
  },
  {
  "id": "Järvamaa",
  "description": "Järvamaa"
  },
  {
  "id": "Jõgevamaa",
  "description": "Jõgevamaa"
  },
  {
  "id": "Lääne",
  "description": "Lääne"
  },
  {
  "id": "Lääne-Virumaa",
  "description": "Lääne-Virumaa"
  },
  {
  "id": "Pärnumaa",
  "description": "Pärnumaa"
  },
  {
  "id": "Põlvamaa",
  "description": "Põlvamaa"
  },
  {
  "id": "Raplamaa",
  "description": "Raplamaa"
  },
  {
  "id": "Saare",
  "description": "Saare"
  },
  {
  "id": "Tartu",
  "description": "Tartu"
  },
  {
  "id": "Valgamaa",
  "description": "Valgamaa"
  },
  {
  "id": "Viljandimaa",
  "description": "Viljandimaa"
  },
  {
  "id": "Võrumaa",
  "description": "Võrumaa"
  }
  ]
  },
  {
  "code": "ET",
  "description": "Ethiopia",
  "regions": [
  {
  "id": "Addis Ababa",
  "description": "Addis Ababa"
  },
  {
  "id": "Āfar",
  "description": "Āfar"
  },
  {
  "id": "Amhara",
  "description": "Amhara"
  },
  {
  "id": "Bīnshangul Gumuz",
  "description": "Bīnshangul Gumuz"
  },
  {
  "id": "Central Ethiopia Regional State",
  "description": "Central Ethiopia Regional State"
  },
  {
  "id": "Dire Dawa",
  "description": "Dire Dawa"
  },
  {
  "id": "Gambela",
  "description": "Gambela"
  },
  {
  "id": "Harari",
  "description": "Harari"
  },
  {
  "id": "Oromiya",
  "description": "Oromiya"
  },
  {
  "id": "Sidama Region",
  "description": "Sidama Region"
  },
  {
  "id": "SNNPR",
  "description": "SNNPR"
  },
  {
  "id": "Somali",
  "description": "Somali"
  },
  {
  "id": "South Ethiopia Regional State",
  "description": "South Ethiopia Regional State"
  },
  {
  "id": "South West Ethiopia Peoples' Region",
  "description": "South West Ethiopia Peoples' Region"
  },
  {
  "id": "Tigray",
  "description": "Tigray"
  }
  ]
  },
  {
  "code": "FK",
  "description": "Falkland Islands",
  "regions": []
  },
  {
  "code": "FO",
  "description": "Faroe Islands",
  "regions": [
  {
  "id": "Eysturoy",
  "description": "Eysturoy"
  },
  {
  "id": "Norðoyar",
  "description": "Norðoyar"
  },
  {
  "id": "Sandoy",
  "description": "Sandoy"
  },
  {
  "id": "Streymoy",
  "description": "Streymoy"
  },
  {
  "id": "Suðuroy",
  "description": "Suðuroy"
  },
  {
  "id": "Vágar",
  "description": "Vágar"
  }
  ]
  },
  {
  "code": "FM",
  "description": "Federated States of Micronesia",
  "regions": [
  {
  "id": "Chuuk",
  "description": "Chuuk"
  },
  {
  "id": "Kosrae",
  "description": "Kosrae"
  },
  {
  "id": "Pohnpei State",
  "description": "Pohnpei State"
  },
  {
  "id": "Yap State",
  "description": "Yap State"
  }
  ]
  },
  {
  "code": "FJ",
  "description": "Fiji",
  "regions": [
  {
  "id": "Central",
  "description": "Central"
  },
  {
  "id": "Eastern",
  "description": "Eastern"
  },
  {
  "id": "Northern",
  "description": "Northern"
  },
  {
  "id": "Rotuma",
  "description": "Rotuma"
  },
  {
  "id": "Western",
  "description": "Western"
  }
  ]
  },
  {
  "code": "FI",
  "description": "Finland",
  "regions": [
  {
  "id": "Central Finland",
  "description": "Central Finland"
  },
  {
  "id": "Central Ostrobothnia",
  "description": "Central Ostrobothnia"
  },
  {
  "id": "Kainuu",
  "description": "Kainuu"
  },
  {
  "id": "Kanta-Häme",
  "description": "Kanta-Häme"
  },
  {
  "id": "Kymenlaakso",
  "description": "Kymenlaakso"
  },
  {
  "id": "Lapland",
  "description": "Lapland"
  },
  {
  "id": "North Karelia",
  "description": "North Karelia"
  },
  {
  "id": "North Ostrobothnia",
  "description": "North Ostrobothnia"
  },
  {
  "id": "North Savo",
  "description": "North Savo"
  },
  {
  "id": "Ostrobothnia",
  "description": "Ostrobothnia"
  },
  {
  "id": "Paijat-Hame",
  "description": "Paijat-Hame"
  },
  {
  "id": "Pirkanmaa",
  "description": "Pirkanmaa"
  },
  {
  "id": "Satakunta",
  "description": "Satakunta"
  },
  {
  "id": "South Karelia",
  "description": "South Karelia"
  },
  {
  "id": "South Ostrobothnia",
  "description": "South Ostrobothnia"
  },
  {
  "id": "South Savo",
  "description": "South Savo"
  },
  {
  "id": "Southwest Finland",
  "description": "Southwest Finland"
  },
  {
  "id": "Uusimaa",
  "description": "Uusimaa"
  }
  ]
  },
  {
  "code": "FR",
  "description": "France",
  "regions": [
  {
  "id": "Auvergne-Rhône-Alpes",
  "description": "Auvergne-Rhône-Alpes"
  },
  {
  "id": "Bourgogne-Franche-Comté",
  "description": "Bourgogne-Franche-Comté"
  },
  {
  "id": "Brittany",
  "description": "Brittany"
  },
  {
  "id": "Centre",
  "description": "Centre"
  },
  {
  "id": "Corsica",
  "description": "Corsica"
  },
  {
  "id": "Grand Est",
  "description": "Grand Est"
  },
  {
  "id": "Hauts-de-France",
  "description": "Hauts-de-France"
  },
  {
  "id": "Île-de-France",
  "description": "Île-de-France"
  },
  {
  "id": "Normandy",
  "description": "Normandy"
  },
  {
  "id": "Nouvelle-Aquitaine",
  "description": "Nouvelle-Aquitaine"
  },
  {
  "id": "Occitanie",
  "description": "Occitanie"
  },
  {
  "id": "Pays de la Loire",
  "description": "Pays de la Loire"
  },
  {
  "id": "Provence-Alpes-Côte d'Azur",
  "description": "Provence-Alpes-Côte d'Azur"
  }
  ]
  },
  {
  "code": "GF",
  "description": "French Guiana",
  "regions": [
  {
  "id": "Guyane",
  "description": "Guyane"
  }
  ]
  },
  {
  "code": "GA",
  "description": "Gabon",
  "regions": [
  {
  "id": "Estuaire",
  "description": "Estuaire"
  },
  {
  "id": "Haut-Ogooué",
  "description": "Haut-Ogooué"
  },
  {
  "id": "Moyen-Ogooué",
  "description": "Moyen-Ogooué"
  },
  {
  "id": "Ngouni",
  "description": "Ngouni"
  },
  {
  "id": "Nyanga",
  "description": "Nyanga"
  },
  {
  "id": "Ogooué-Ivindo",
  "description": "Ogooué-Ivindo"
  },
  {
  "id": "Ogooué-Lolo",
  "description": "Ogooué-Lolo"
  },
  {
  "id": "Ogooué-Maritime",
  "description": "Ogooué-Maritime"
  },
  {
  "id": "Woleu-Ntem",
  "description": "Woleu-Ntem"
  }
  ]
  },
  {
  "code": "GM",
  "description": "Gambia",
  "regions": [
  {
  "id": "Banjul",
  "description": "Banjul"
  },
  {
  "id": "Central River",
  "description": "Central River"
  },
  {
  "id": "Lower River",
  "description": "Lower River"
  },
  {
  "id": "North Bank",
  "description": "North Bank"
  },
  {
  "id": "Upper River",
  "description": "Upper River"
  },
  {
  "id": "Western",
  "description": "Western"
  }
  ]
  },
  {
  "code": "GE",
  "description": "Georgia",
  "regions": [
  {
  "id": "Abkhazia",
  "description": "Abkhazia"
  },
  {
  "id": "Adjara",
  "description": "Adjara"
  },
  {
  "id": "Guria",
  "description": "Guria"
  },
  {
  "id": "Imereti",
  "description": "Imereti"
  },
  {
  "id": "Kakheti",
  "description": "Kakheti"
  },
  {
  "id": "Kvemo Kartli",
  "description": "Kvemo Kartli"
  },
  {
  "id": "Mtskheta-Mtianeti",
  "description": "Mtskheta-Mtianeti"
  },
  {
  "id": "Racha-Lechkhumi and Kvemo Svaneti",
  "description": "Racha-Lechkhumi and Kvemo Svaneti"
  },
  {
  "id": "Samegrelo and Zemo Svaneti",
  "description": "Samegrelo and Zemo Svaneti"
  },
  {
  "id": "Samtskhe-Javakheti",
  "description": "Samtskhe-Javakheti"
  },
  {
  "id": "Shida Kartli",
  "description": "Shida Kartli"
  },
  {
  "id": "Tbilisi",
  "description": "Tbilisi"
  }
  ]
  },
  {
  "code": "DE",
  "description": "Germany",
  "regions": [
  {
  "id": "Baden-Wurttemberg",
  "description": "Baden-Wurttemberg"
  },
  {
  "id": "Bavaria",
  "description": "Bavaria"
  },
  {
  "id": "Berlin",
  "description": "Berlin"
  },
  {
  "id": "Brandenburg",
  "description": "Brandenburg"
  },
  {
  "id": "Bremen",
  "description": "Bremen"
  },
  {
  "id": "Hamburg",
  "description": "Hamburg"
  },
  {
  "id": "Hesse",
  "description": "Hesse"
  },
  {
  "id": "Lower Saxony",
  "description": "Lower Saxony"
  },
  {
  "id": "Mecklenburg-Vorpommern",
  "description": "Mecklenburg-Vorpommern"
  },
  {
  "id": "North Rhine-Westphalia",
  "description": "North Rhine-Westphalia"
  },
  {
  "id": "Rheinland-Pfalz",
  "description": "Rheinland-Pfalz"
  },
  {
  "id": "Saarland",
  "description": "Saarland"
  },
  {
  "id": "Saxony",
  "description": "Saxony"
  },
  {
  "id": "Saxony-Anhalt",
  "description": "Saxony-Anhalt"
  },
  {
  "id": "Schleswig-Holstein",
  "description": "Schleswig-Holstein"
  },
  {
  "id": "Thuringia",
  "description": "Thuringia"
  }
  ]
  },
  {
  "code": "GH",
  "description": "Ghana",
  "regions": [
  {
  "id": "Ahafo",
  "description": "Ahafo"
  },
  {
  "id": "Ashanti",
  "description": "Ashanti"
  },
  {
  "id": "Bono",
  "description": "Bono"
  },
  {
  "id": "Bono East",
  "description": "Bono East"
  },
  {
  "id": "Brong-Ahafo",
  "description": "Brong-Ahafo"
  },
  {
  "id": "Central",
  "description": "Central"
  },
  {
  "id": "Eastern",
  "description": "Eastern"
  },
  {
  "id": "Greater Accra",
  "description": "Greater Accra"
  },
  {
  "id": "North East",
  "description": "North East"
  },
  {
  "id": "Northern",
  "description": "Northern"
  },
  {
  "id": "Oti",
  "description": "Oti"
  },
  {
  "id": "Savannah",
  "description": "Savannah"
  },
  {
  "id": "Upper East",
  "description": "Upper East"
  },
  {
  "id": "Upper West",
  "description": "Upper West"
  },
  {
  "id": "Volta",
  "description": "Volta"
  },
  {
  "id": "Western",
  "description": "Western"
  },
  {
  "id": "Western North",
  "description": "Western North"
  }
  ]
  },
  {
  "code": "GR",
  "description": "Greece",
  "regions": [
  {
  "id": "Attica",
  "description": "Attica"
  },
  {
  "id": "Central Greece",
  "description": "Central Greece"
  },
  {
  "id": "Central Macedonia",
  "description": "Central Macedonia"
  },
  {
  "id": "Crete",
  "description": "Crete"
  },
  {
  "id": "East Macedonia and Thrace",
  "description": "East Macedonia and Thrace"
  },
  {
  "id": "Epirus",
  "description": "Epirus"
  },
  {
  "id": "Ionian Islands",
  "description": "Ionian Islands"
  },
  {
  "id": "Mount Athos",
  "description": "Mount Athos"
  },
  {
  "id": "North Aegean",
  "description": "North Aegean"
  },
  {
  "id": "Peloponnese",
  "description": "Peloponnese"
  },
  {
  "id": "South Aegean",
  "description": "South Aegean"
  },
  {
  "id": "Thessaly",
  "description": "Thessaly"
  },
  {
  "id": "West Greece",
  "description": "West Greece"
  },
  {
  "id": "West Macedonia",
  "description": "West Macedonia"
  }
  ]
  },
  {
  "code": "GL",
  "description": "Greenland",
  "regions": [
  {
  "id": "Avannaata",
  "description": "Avannaata"
  },
  {
  "id": "Kujalleq",
  "description": "Kujalleq"
  },
  {
  "id": "Qaasuitsup",
  "description": "Qaasuitsup"
  },
  {
  "id": "Qeqertalik",
  "description": "Qeqertalik"
  },
  {
  "id": "Qeqqata",
  "description": "Qeqqata"
  },
  {
  "id": "Sermersooq",
  "description": "Sermersooq"
  }
  ]
  },
  {
  "code": "GD",
  "description": "Grenada",
  "regions": [
  {
  "id": "Carriacou and Petite Martinique",
  "description": "Carriacou and Petite Martinique"
  },
  {
  "id": "Saint Andrew Parish",
  "description": "Saint Andrew Parish"
  },
  {
  "id": "Saint David Parish",
  "description": "Saint David Parish"
  },
  {
  "id": "Saint George Parish",
  "description": "Saint George Parish"
  },
  {
  "id": "Saint John Parish",
  "description": "Saint John Parish"
  },
  {
  "id": "Saint Mark Parish",
  "description": "Saint Mark Parish"
  },
  {
  "id": "Saint Patrick Parish",
  "description": "Saint Patrick Parish"
  }
  ]
  },
  {
  "code": "GP",
  "description": "Guadeloupe",
  "regions": [
  {
  "id": "Guadeloupe",
  "description": "Guadeloupe"
  }
  ]
  },
  {
  "code": "GU",
  "description": "Guam",
  "regions": [
  {
  "id": "Agana Heights",
  "description": "Agana Heights"
  },
  {
  "id": "Agat",
  "description": "Agat"
  },
  {
  "id": "Asan",
  "description": "Asan"
  },
  {
  "id": "Barrigada",
  "description": "Barrigada"
  },
  {
  "id": "Chalan Pago-Ordot",
  "description": "Chalan Pago-Ordot"
  },
  {
  "id": "Dededo",
  "description": "Dededo"
  },
  {
  "id": "Hagatna",
  "description": "Hagatna"
  },
  {
  "id": "Inarajan",
  "description": "Inarajan"
  },
  {
  "id": "Mangilao",
  "description": "Mangilao"
  },
  {
  "id": "Merizo",
  "description": "Merizo"
  },
  {
  "id": "Mongmong-Toto-Maite",
  "description": "Mongmong-Toto-Maite"
  },
  {
  "id": "Piti",
  "description": "Piti"
  },
  {
  "id": "Santa Rita",
  "description": "Santa Rita"
  },
  {
  "id": "Sinajana",
  "description": "Sinajana"
  },
  {
  "id": "Talofofo",
  "description": "Talofofo"
  },
  {
  "id": "Tamuning",
  "description": "Tamuning"
  },
  {
  "id": "Umatac",
  "description": "Umatac"
  },
  {
  "id": "Yigo",
  "description": "Yigo"
  },
  {
  "id": "Yona",
  "description": "Yona"
  }
  ]
  },
  {
  "code": "GT",
  "description": "Guatemala",
  "regions": [
  {
  "id": "Alta Verapaz",
  "description": "Alta Verapaz"
  },
  {
  "id": "Baja Verapaz",
  "description": "Baja Verapaz"
  },
  {
  "id": "Chimaltenango",
  "description": "Chimaltenango"
  },
  {
  "id": "Chiquimula",
  "description": "Chiquimula"
  },
  {
  "id": "El Progreso",
  "description": "El Progreso"
  },
  {
  "id": "Escuintla",
  "description": "Escuintla"
  },
  {
  "id": "Guatemala",
  "description": "Guatemala"
  },
  {
  "id": "Huehuetenango",
  "description": "Huehuetenango"
  },
  {
  "id": "Izabal Department",
  "description": "Izabal Department"
  },
  {
  "id": "Jalapa",
  "description": "Jalapa"
  },
  {
  "id": "Jutiapa",
  "description": "Jutiapa"
  },
  {
  "id": "Petén",
  "description": "Petén"
  },
  {
  "id": "Quetzaltenango",
  "description": "Quetzaltenango"
  },
  {
  "id": "Quiché",
  "description": "Quiché"
  },
  {
  "id": "Retalhuleu",
  "description": "Retalhuleu"
  },
  {
  "id": "Sacatepéquez",
  "description": "Sacatepéquez"
  },
  {
  "id": "San Marcos",
  "description": "San Marcos"
  },
  {
  "id": "Santa Rosa Department",
  "description": "Santa Rosa Department"
  },
  {
  "id": "Sololá",
  "description": "Sololá"
  },
  {
  "id": "Suchitepeque",
  "description": "Suchitepeque"
  },
  {
  "id": "Totonicapán",
  "description": "Totonicapán"
  },
  {
  "id": "Zacapa",
  "description": "Zacapa"
  }
  ]
  },
  {
  "code": "GN",
  "description": "Guinea",
  "regions": [
  {
  "id": "Boké Region",
  "description": "Boké Region"
  },
  {
  "id": "Conakry",
  "description": "Conakry"
  },
  {
  "id": "Faranah",
  "description": "Faranah"
  },
  {
  "id": "Kankan Region",
  "description": "Kankan Region"
  },
  {
  "id": "Kindia",
  "description": "Kindia"
  },
  {
  "id": "Labé Region",
  "description": "Labé Region"
  },
  {
  "id": "Mamou Region",
  "description": "Mamou Region"
  },
  {
  "id": "Nzérékoré Region",
  "description": "Nzérékoré Region"
  }
  ]
  },
  {
  "code": "GW",
  "description": "Guinea-Bissau",
  "regions": [
  {
  "id": "Bafatá",
  "description": "Bafatá"
  },
  {
  "id": "Biombo",
  "description": "Biombo"
  },
  {
  "id": "Bissau",
  "description": "Bissau"
  },
  {
  "id": "Bolama",
  "description": "Bolama"
  },
  {
  "id": "Cacheu",
  "description": "Cacheu"
  },
  {
  "id": "Gabú",
  "description": "Gabú"
  },
  {
  "id": "Oio",
  "description": "Oio"
  },
  {
  "id": "Quinara",
  "description": "Quinara"
  },
  {
  "id": "Tombali",
  "description": "Tombali"
  }
  ]
  },
  {
  "code": "GY",
  "description": "Guyana",
  "regions": [
  {
  "id": "Barima-Waini",
  "description": "Barima-Waini"
  },
  {
  "id": "Cuyuni-Mazaruni",
  "description": "Cuyuni-Mazaruni"
  },
  {
  "id": "Demerara-Mahaica",
  "description": "Demerara-Mahaica"
  },
  {
  "id": "East Berbice-Corentyne",
  "description": "East Berbice-Corentyne"
  },
  {
  "id": "Essequibo Islands-West Demerara",
  "description": "Essequibo Islands-West Demerara"
  },
  {
  "id": "Mahaica-Berbice",
  "description": "Mahaica-Berbice"
  },
  {
  "id": "Pomeroon-Supenaam",
  "description": "Pomeroon-Supenaam"
  },
  {
  "id": "Potaro-Siparuni",
  "description": "Potaro-Siparuni"
  },
  {
  "id": "Upper Demerara-Berbice",
  "description": "Upper Demerara-Berbice"
  },
  {
  "id": "Upper Takutu-Upper Essequibo",
  "description": "Upper Takutu-Upper Essequibo"
  }
  ]
  },
  {
  "code": "HT",
  "description": "Haiti",
  "regions": [
  {
  "id": "Artibonite",
  "description": "Artibonite"
  },
  {
  "id": "Centre",
  "description": "Centre"
  },
  {
  "id": "Grand'Anse",
  "description": "Grand'Anse"
  },
  {
  "id": "Nippes",
  "description": "Nippes"
  },
  {
  "id": "Nord",
  "description": "Nord"
  },
  {
  "id": "Nord-Est",
  "description": "Nord-Est"
  },
  {
  "id": "Nord-Ouest",
  "description": "Nord-Ouest"
  },
  {
  "id": "Ouest",
  "description": "Ouest"
  },
  {
  "id": "Sud",
  "description": "Sud"
  },
  {
  "id": "Sud-Est",
  "description": "Sud-Est"
  }
  ]
  },
  {
  "code": "HN",
  "description": "Honduras",
  "regions": [
  {
  "id": "Atlántida Department",
  "description": "Atlántida Department"
  },
  {
  "id": "Bay Islands",
  "description": "Bay Islands"
  },
  {
  "id": "Choluteca Department",
  "description": "Choluteca Department"
  },
  {
  "id": "Colón Department",
  "description": "Colón Department"
  },
  {
  "id": "Comayagua Department",
  "description": "Comayagua Department"
  },
  {
  "id": "Copán Department",
  "description": "Copán Department"
  },
  {
  "id": "Cortés Department",
  "description": "Cortés Department"
  },
  {
  "id": "El Paraíso Department",
  "description": "El Paraíso Department"
  },
  {
  "id": "Francisco Morazán Department",
  "description": "Francisco Morazán Department"
  },
  {
  "id": "Gracias a Dios Department",
  "description": "Gracias a Dios Department"
  },
  {
  "id": "Intibucá Department",
  "description": "Intibucá Department"
  },
  {
  "id": "La Paz Department",
  "description": "La Paz Department"
  },
  {
  "id": "Lempira Department",
  "description": "Lempira Department"
  },
  {
  "id": "Ocotepeque Department",
  "description": "Ocotepeque Department"
  },
  {
  "id": "Olancho Department",
  "description": "Olancho Department"
  },
  {
  "id": "Santa Bárbara Department",
  "description": "Santa Bárbara Department"
  },
  {
  "id": "Valle Department",
  "description": "Valle Department"
  },
  {
  "id": "Yoro Department",
  "description": "Yoro Department"
  }
  ]
  },
  {
  "code": "HK",
  "description": "Hong Kong",
  "regions": [
  {
  "id": "Central and Western",
  "description": "Central and Western"
  },
  {
  "id": "Eastern",
  "description": "Eastern"
  },
  {
  "id": "Islands",
  "description": "Islands"
  },
  {
  "id": "Kowloon City",
  "description": "Kowloon City"
  },
  {
  "id": "Kwai Tsing",
  "description": "Kwai Tsing"
  },
  {
  "id": "Kwun Tong",
  "description": "Kwun Tong"
  },
  {
  "id": "North",
  "description": "North"
  },
  {
  "id": "Sai Kung",
  "description": "Sai Kung"
  },
  {
  "id": "Sham Shui Po",
  "description": "Sham Shui Po"
  },
  {
  "id": "Sha Tin",
  "description": "Sha Tin"
  },
  {
  "id": "Southern",
  "description": "Southern"
  },
  {
  "id": "Tai Po",
  "description": "Tai Po"
  },
  {
  "id": "Tsuen Wan",
  "description": "Tsuen Wan"
  },
  {
  "id": "Tuen Mun",
  "description": "Tuen Mun"
  },
  {
  "id": "Wan Chai",
  "description": "Wan Chai"
  },
  {
  "id": "Wong Tai Sin",
  "description": "Wong Tai Sin"
  },
  {
  "id": "Yau Tsim Mong",
  "description": "Yau Tsim Mong"
  },
  {
  "id": "Yuen Long",
  "description": "Yuen Long"
  }
  ]
  },
  {
  "code": "HU",
  "description": "Hungary",
  "regions": [
  {
  "id": "Bács-Kiskun",
  "description": "Bács-Kiskun"
  },
  {
  "id": "Baranya",
  "description": "Baranya"
  },
  {
  "id": "Bekes County",
  "description": "Bekes County"
  },
  {
  "id": "Borsod-Abaúj-Zemplén",
  "description": "Borsod-Abaúj-Zemplén"
  },
  {
  "id": "Budapest",
  "description": "Budapest"
  },
  {
  "id": "Csongrád",
  "description": "Csongrád"
  },
  {
  "id": "Fejér",
  "description": "Fejér"
  },
  {
  "id": "Győr-Moson-Sopron",
  "description": "Győr-Moson-Sopron"
  },
  {
  "id": "Hajdú-Bihar",
  "description": "Hajdú-Bihar"
  },
  {
  "id": "Heves County",
  "description": "Heves County"
  },
  {
  "id": "Jász-Nagykun-Szolnok",
  "description": "Jász-Nagykun-Szolnok"
  },
  {
  "id": "Komárom-Esztergom",
  "description": "Komárom-Esztergom"
  },
  {
  "id": "Nógrád",
  "description": "Nógrád"
  },
  {
  "id": "Pest County",
  "description": "Pest County"
  },
  {
  "id": "Somogy County",
  "description": "Somogy County"
  },
  {
  "id": "Szabolcs-Szatmár-Bereg",
  "description": "Szabolcs-Szatmár-Bereg"
  },
  {
  "id": "Tolna County",
  "description": "Tolna County"
  },
  {
  "id": "Vas County",
  "description": "Vas County"
  },
  {
  "id": "Veszprém",
  "description": "Veszprém"
  },
  {
  "id": "Zala County",
  "description": "Zala County"
  }
  ]
  },
  {
  "code": "IS",
  "description": "Iceland",
  "regions": [
  {
  "id": "Capital Region",
  "description": "Capital Region"
  },
  {
  "id": "East",
  "description": "East"
  },
  {
  "id": "Northeast",
  "description": "Northeast"
  },
  {
  "id": "Northwest",
  "description": "Northwest"
  },
  {
  "id": "South",
  "description": "South"
  },
  {
  "id": "Southern Peninsula",
  "description": "Southern Peninsula"
  },
  {
  "id": "West",
  "description": "West"
  },
  {
  "id": "Westfjords",
  "description": "Westfjords"
  }
  ]
  },
  {
  "code": "IN",
  "description": "India",
  "regions": [
  {
  "id": "Andaman and Nicobar",
  "description": "Andaman and Nicobar"
  },
  {
  "id": "Andhra Pradesh",
  "description": "Andhra Pradesh"
  },
  {
  "id": "Arunachal Pradesh",
  "description": "Arunachal Pradesh"
  },
  {
  "id": "Assam",
  "description": "Assam"
  },
  {
  "id": "Bihar",
  "description": "Bihar"
  },
  {
  "id": "Chandigarh",
  "description": "Chandigarh"
  },
  {
  "id": "Chhattisgarh",
  "description": "Chhattisgarh"
  },
  {
  "id": "Dadra and Nagar Haveli",
  "description": "Dadra and Nagar Haveli"
  },
  {
  "id": "Dadra and Nagar Haveli and Daman and Diu",
  "description": "Dadra and Nagar Haveli and Daman and Diu"
  },
  {
  "id": "Daman and Diu",
  "description": "Daman and Diu"
  },
  {
  "id": "Delhi",
  "description": "Delhi"
  },
  {
  "id": "Goa",
  "description": "Goa"
  },
  {
  "id": "Gujarat",
  "description": "Gujarat"
  },
  {
  "id": "Haryana",
  "description": "Haryana"
  },
  {
  "id": "Himachal Pradesh",
  "description": "Himachal Pradesh"
  },
  {
  "id": "Jammu and Kashmir",
  "description": "Jammu and Kashmir"
  },
  {
  "id": "Jharkhand",
  "description": "Jharkhand"
  },
  {
  "id": "Karnataka",
  "description": "Karnataka"
  },
  {
  "id": "Kerala",
  "description": "Kerala"
  },
  {
  "id": "Laccadives",
  "description": "Laccadives"
  },
  {
  "id": "Ladakh",
  "description": "Ladakh"
  },
  {
  "id": "Madhya Pradesh",
  "description": "Madhya Pradesh"
  },
  {
  "id": "Maharashtra",
  "description": "Maharashtra"
  },
  {
  "id": "Manipur",
  "description": "Manipur"
  },
  {
  "id": "Meghalaya",
  "description": "Meghalaya"
  },
  {
  "id": "Mizoram",
  "description": "Mizoram"
  },
  {
  "id": "Nagaland",
  "description": "Nagaland"
  },
  {
  "id": "Odisha",
  "description": "Odisha"
  },
  {
  "id": "Puducherry",
  "description": "Puducherry"
  },
  {
  "id": "Punjab",
  "description": "Punjab"
  },
  {
  "id": "Rajasthan",
  "description": "Rajasthan"
  },
  {
  "id": "Sikkim",
  "description": "Sikkim"
  },
  {
  "id": "Tamil Nadu",
  "description": "Tamil Nadu"
  },
  {
  "id": "Telangana",
  "description": "Telangana"
  },
  {
  "id": "Tripura",
  "description": "Tripura"
  },
  {
  "id": "Uttarakhand",
  "description": "Uttarakhand"
  },
  {
  "id": "Uttar Pradesh",
  "description": "Uttar Pradesh"
  },
  {
  "id": "West Bengal",
  "description": "West Bengal"
  }
  ]
  },
  {
  "code": "ID",
  "description": "Indonesia",
  "regions": [
  {
  "id": "Aceh",
  "description": "Aceh"
  },
  {
  "id": "Bali",
  "description": "Bali"
  },
  {
  "id": "Bangka–Belitung Islands",
  "description": "Bangka–Belitung Islands"
  },
  {
  "id": "Banten",
  "description": "Banten"
  },
  {
  "id": "Bengkulu",
  "description": "Bengkulu"
  },
  {
  "id": "Central Java",
  "description": "Central Java"
  },
  {
  "id": "Central Kalimantan",
  "description": "Central Kalimantan"
  },
  {
  "id": "Central Papua",
  "description": "Central Papua"
  },
  {
  "id": "Central Sulawesi",
  "description": "Central Sulawesi"
  },
  {
  "id": "East Java",
  "description": "East Java"
  },
  {
  "id": "East Kalimantan",
  "description": "East Kalimantan"
  },
  {
  "id": "East Nusa Tenggara",
  "description": "East Nusa Tenggara"
  },
  {
  "id": "Gorontalo",
  "description": "Gorontalo"
  },
  {
  "id": "Highland Papua",
  "description": "Highland Papua"
  },
  {
  "id": "Jakarta",
  "description": "Jakarta"
  },
  {
  "id": "Jambi",
  "description": "Jambi"
  },
  {
  "id": "Lampung",
  "description": "Lampung"
  },
  {
  "id": "Maluku",
  "description": "Maluku"
  },
  {
  "id": "North Kalimantan",
  "description": "North Kalimantan"
  },
  {
  "id": "North Maluku",
  "description": "North Maluku"
  },
  {
  "id": "North Sulawesi",
  "description": "North Sulawesi"
  },
  {
  "id": "North Sumatra",
  "description": "North Sumatra"
  },
  {
  "id": "Papua",
  "description": "Papua"
  },
  {
  "id": "Riau",
  "description": "Riau"
  },
  {
  "id": "Riau Islands",
  "description": "Riau Islands"
  },
  {
  "id": "Southeast Sulawesi",
  "description": "Southeast Sulawesi"
  },
  {
  "id": "South Kalimantan",
  "description": "South Kalimantan"
  },
  {
  "id": "South Papua",
  "description": "South Papua"
  },
  {
  "id": "South Sulawesi",
  "description": "South Sulawesi"
  },
  {
  "id": "South Sumatra",
  "description": "South Sumatra"
  },
  {
  "id": "Southwest Papua",
  "description": "Southwest Papua"
  },
  {
  "id": "West Java",
  "description": "West Java"
  },
  {
  "id": "West Kalimantan",
  "description": "West Kalimantan"
  },
  {
  "id": "West Nusa Tenggara",
  "description": "West Nusa Tenggara"
  },
  {
  "id": "West Papua",
  "description": "West Papua"
  },
  {
  "id": "West Sulawesi",
  "description": "West Sulawesi"
  },
  {
  "id": "West Sumatra",
  "description": "West Sumatra"
  },
  {
  "id": "Yogyakarta",
  "description": "Yogyakarta"
  }
  ]
  },
  {
  "code": "IR",
  "description": "Iran",
  "regions": [
  {
  "id": "Alborz Province",
  "description": "Alborz Province"
  },
  {
  "id": "Ardabil Province",
  "description": "Ardabil Province"
  },
  {
  "id": "Bushehr",
  "description": "Bushehr"
  },
  {
  "id": "Chaharmahal and Bakhtiari",
  "description": "Chaharmahal and Bakhtiari"
  },
  {
  "id": "East Azerbaijan",
  "description": "East Azerbaijan"
  },
  {
  "id": "Fars",
  "description": "Fars"
  },
  {
  "id": "Gilan Province",
  "description": "Gilan Province"
  },
  {
  "id": "Golestan",
  "description": "Golestan"
  },
  {
  "id": "Hamadan Province",
  "description": "Hamadan Province"
  },
  {
  "id": "Hormozgan",
  "description": "Hormozgan"
  },
  {
  "id": "Ilam Province",
  "description": "Ilam Province"
  },
  {
  "id": "Isfahan",
  "description": "Isfahan"
  },
  {
  "id": "Kerman",
  "description": "Kerman"
  },
  {
  "id": "Kermanshah Province",
  "description": "Kermanshah Province"
  },
  {
  "id": "Khuzestan",
  "description": "Khuzestan"
  },
  {
  "id": "Kohgiluyeh and Boyer-Ahmad",
  "description": "Kohgiluyeh and Boyer-Ahmad"
  },
  {
  "id": "Kurdistan Province",
  "description": "Kurdistan Province"
  },
  {
  "id": "Lorestan Province",
  "description": "Lorestan Province"
  },
  {
  "id": "Markazi",
  "description": "Markazi"
  },
  {
  "id": "Māzandarān",
  "description": "Māzandarān"
  },
  {
  "id": "North Khorasan",
  "description": "North Khorasan"
  },
  {
  "id": "Qazvin Province",
  "description": "Qazvin Province"
  },
  {
  "id": "Qom Province",
  "description": "Qom Province"
  },
  {
  "id": "Razavi Khorasan",
  "description": "Razavi Khorasan"
  },
  {
  "id": "Semnan",
  "description": "Semnan"
  },
  {
  "id": "Sistan and Baluchestan",
  "description": "Sistan and Baluchestan"
  },
  {
  "id": "South Khorasan Province",
  "description": "South Khorasan Province"
  },
  {
  "id": "Tehran",
  "description": "Tehran"
  },
  {
  "id": "West Azerbaijan",
  "description": "West Azerbaijan"
  },
  {
  "id": "Yazd Province",
  "description": "Yazd Province"
  },
  {
  "id": "Zanjan",
  "description": "Zanjan"
  }
  ]
  },
  {
  "code": "IQ",
  "description": "Iraq",
  "regions": [
  {
  "id": "Al Anbar",
  "description": "Al Anbar"
  },
  {
  "id": "Al Muthanna Governorate",
  "description": "Al Muthanna Governorate"
  },
  {
  "id": "Al Qādisīyah",
  "description": "Al Qādisīyah"
  },
  {
  "id": "An Najaf",
  "description": "An Najaf"
  },
  {
  "id": "Bābil",
  "description": "Bābil"
  },
  {
  "id": "Baghdad",
  "description": "Baghdad"
  },
  {
  "id": "Basra",
  "description": "Basra"
  },
  {
  "id": "Dhi Qar",
  "description": "Dhi Qar"
  },
  {
  "id": "Diyālá",
  "description": "Diyālá"
  },
  {
  "id": "Duhok",
  "description": "Duhok"
  },
  {
  "id": "Erbil",
  "description": "Erbil"
  },
  {
  "id": "Halabja Governorate",
  "description": "Halabja Governorate"
  },
  {
  "id": "Karbalāʼ",
  "description": "Karbalāʼ"
  },
  {
  "id": "Kirkuk",
  "description": "Kirkuk"
  },
  {
  "id": "Maysan",
  "description": "Maysan"
  },
  {
  "id": "Nineveh",
  "description": "Nineveh"
  },
  {
  "id": "Salah ad Din",
  "description": "Salah ad Din"
  },
  {
  "id": "Sulaymaniyah",
  "description": "Sulaymaniyah"
  },
  {
  "id": "Wāsiţ",
  "description": "Wāsiţ"
  }
  ]
  },
  {
  "code": "IE",
  "description": "Ireland",
  "regions": [
  {
  "id": "Connacht",
  "description": "Connacht"
  },
  {
  "id": "Leinster",
  "description": "Leinster"
  },
  {
  "id": "Munster",
  "description": "Munster"
  },
  {
  "id": "Ulster",
  "description": "Ulster"
  }
  ]
  },
  {
  "code": "IL",
  "description": "Israel",
  "regions": [
  {
  "id": "Central District",
  "description": "Central District"
  },
  {
  "id": "Haifa",
  "description": "Haifa"
  },
  {
  "id": "Jerusalem",
  "description": "Jerusalem"
  },
  {
  "id": "Judea and Samaria Area",
  "description": "Judea and Samaria Area"
  },
  {
  "id": "Northern District",
  "description": "Northern District"
  },
  {
  "id": "Southern District",
  "description": "Southern District"
  },
  {
  "id": "Tel Aviv",
  "description": "Tel Aviv"
  }
  ]
  },
  {
  "code": "IT",
  "description": "Italy",
  "regions": [
  {
  "id": "Abruzzo",
  "description": "Abruzzo"
  },
  {
  "id": "Aosta Valley",
  "description": "Aosta Valley"
  },
  {
  "id": "Apulia",
  "description": "Apulia"
  },
  {
  "id": "Basilicate",
  "description": "Basilicate"
  },
  {
  "id": "Calabria",
  "description": "Calabria"
  },
  {
  "id": "Campania",
  "description": "Campania"
  },
  {
  "id": "Emilia-Romagna",
  "description": "Emilia-Romagna"
  },
  {
  "id": "Friuli Venezia Giulia",
  "description": "Friuli Venezia Giulia"
  },
  {
  "id": "Lazio",
  "description": "Lazio"
  },
  {
  "id": "Liguria",
  "description": "Liguria"
  },
  {
  "id": "Lombardy",
  "description": "Lombardy"
  },
  {
  "id": "Molise",
  "description": "Molise"
  },
  {
  "id": "Piedmont",
  "description": "Piedmont"
  },
  {
  "id": "Sardinia",
  "description": "Sardinia"
  },
  {
  "id": "Sicily",
  "description": "Sicily"
  },
  {
  "id": "The Marches",
  "description": "The Marches"
  },
  {
  "id": "Trentino-Alto Adige",
  "description": "Trentino-Alto Adige"
  },
  {
  "id": "Tuscany",
  "description": "Tuscany"
  },
  {
  "id": "Umbria",
  "description": "Umbria"
  },
  {
  "id": "Veneto",
  "description": "Veneto"
  }
  ]
  },
  {
  "code": "JM",
  "description": "Jamaica",
  "regions": [
  {
  "id": "Clarendon",
  "description": "Clarendon"
  },
  {
  "id": "Hanover",
  "description": "Hanover"
  },
  {
  "id": "Kingston",
  "description": "Kingston"
  },
  {
  "id": "Manchester",
  "description": "Manchester"
  },
  {
  "id": "Portland Parish",
  "description": "Portland Parish"
  },
  {
  "id": "Saint Andrew Parish",
  "description": "Saint Andrew Parish"
  },
  {
  "id": "Saint Ann Parish",
  "description": "Saint Ann Parish"
  },
  {
  "id": "Saint Catherine Parish",
  "description": "Saint Catherine Parish"
  },
  {
  "id": "Saint James Parish",
  "description": "Saint James Parish"
  },
  {
  "id": "Saint Mary Parish",
  "description": "Saint Mary Parish"
  },
  {
  "id": "Saint Thomas Parish",
  "description": "Saint Thomas Parish"
  },
  {
  "id": "St. Elizabeth",
  "description": "St. Elizabeth"
  },
  {
  "id": "Trelawny Parish",
  "description": "Trelawny Parish"
  },
  {
  "id": "Westmoreland",
  "description": "Westmoreland"
  }
  ]
  },
  {
  "code": "JP",
  "description": "Japan",
  "regions": [
  {
  "id": "Aichi",
  "description": "Aichi"
  },
  {
  "id": "Akita",
  "description": "Akita"
  },
  {
  "id": "Aomori",
  "description": "Aomori"
  },
  {
  "id": "Chiba",
  "description": "Chiba"
  },
  {
  "id": "Ehime",
  "description": "Ehime"
  },
  {
  "id": "Fukui",
  "description": "Fukui"
  },
  {
  "id": "Fukuoka",
  "description": "Fukuoka"
  },
  {
  "id": "Fukushima",
  "description": "Fukushima"
  },
  {
  "id": "Gifu",
  "description": "Gifu"
  },
  {
  "id": "Gunma",
  "description": "Gunma"
  },
  {
  "id": "Hiroshima",
  "description": "Hiroshima"
  },
  {
  "id": "Hokkaido",
  "description": "Hokkaido"
  },
  {
  "id": "Hyōgo",
  "description": "Hyōgo"
  },
  {
  "id": "Ibaraki",
  "description": "Ibaraki"
  },
  {
  "id": "Ishikawa",
  "description": "Ishikawa"
  },
  {
  "id": "Iwate",
  "description": "Iwate"
  },
  {
  "id": "Kagawa",
  "description": "Kagawa"
  },
  {
  "id": "Kagoshima",
  "description": "Kagoshima"
  },
  {
  "id": "Kanagawa",
  "description": "Kanagawa"
  },
  {
  "id": "Kochi",
  "description": "Kochi"
  },
  {
  "id": "Kumamoto",
  "description": "Kumamoto"
  },
  {
  "id": "Kyoto",
  "description": "Kyoto"
  },
  {
  "id": "Mie",
  "description": "Mie"
  },
  {
  "id": "Miyagi",
  "description": "Miyagi"
  },
  {
  "id": "Miyazaki",
  "description": "Miyazaki"
  },
  {
  "id": "Nagano",
  "description": "Nagano"
  },
  {
  "id": "Nagasaki",
  "description": "Nagasaki"
  },
  {
  "id": "Nara",
  "description": "Nara"
  },
  {
  "id": "Niigata",
  "description": "Niigata"
  },
  {
  "id": "Oita",
  "description": "Oita"
  },
  {
  "id": "Okayama",
  "description": "Okayama"
  },
  {
  "id": "Okinawa",
  "description": "Okinawa"
  },
  {
  "id": "Osaka",
  "description": "Osaka"
  },
  {
  "id": "Saga",
  "description": "Saga"
  },
  {
  "id": "Saitama",
  "description": "Saitama"
  },
  {
  "id": "Shiga",
  "description": "Shiga"
  },
  {
  "id": "Shimane",
  "description": "Shimane"
  },
  {
  "id": "Shizuoka",
  "description": "Shizuoka"
  },
  {
  "id": "Tochigi",
  "description": "Tochigi"
  },
  {
  "id": "Tokushima",
  "description": "Tokushima"
  },
  {
  "id": "Tokyo",
  "description": "Tokyo"
  },
  {
  "id": "Tottori",
  "description": "Tottori"
  },
  {
  "id": "Toyama",
  "description": "Toyama"
  },
  {
  "id": "Wakayama",
  "description": "Wakayama"
  },
  {
  "id": "Yamagata",
  "description": "Yamagata"
  },
  {
  "id": "Yamaguchi",
  "description": "Yamaguchi"
  },
  {
  "id": "Yamanashi",
  "description": "Yamanashi"
  }
  ]
  },
  {
  "code": "JO",
  "description": "Jordan",
  "regions": [
  {
  "id": "Ajlun",
  "description": "Ajlun"
  },
  {
  "id": "Amman",
  "description": "Amman"
  },
  {
  "id": "Aqaba",
  "description": "Aqaba"
  },
  {
  "id": "Balqa",
  "description": "Balqa"
  },
  {
  "id": "Irbid",
  "description": "Irbid"
  },
  {
  "id": "Jerash",
  "description": "Jerash"
  },
  {
  "id": "Karak",
  "description": "Karak"
  },
  {
  "id": "Ma’an",
  "description": "Ma’an"
  },
  {
  "id": "Madaba",
  "description": "Madaba"
  },
  {
  "id": "Mafraq",
  "description": "Mafraq"
  },
  {
  "id": "Tafielah",
  "description": "Tafielah"
  },
  {
  "id": "Zarqa",
  "description": "Zarqa"
  }
  ]
  },
  {
  "code": "KZ",
  "description": "Kazakhstan",
  "regions": [
  {
  "id": "Abai Region",
  "description": "Abai Region"
  },
  {
  "id": "Almaty",
  "description": "Almaty"
  },
  {
  "id": "Almaty Oblysy",
  "description": "Almaty Oblysy"
  },
  {
  "id": "Aqmola",
  "description": "Aqmola"
  },
  {
  "id": "Aqtöbe",
  "description": "Aqtöbe"
  },
  {
  "id": "Astana",
  "description": "Astana"
  },
  {
  "id": "Atyraū",
  "description": "Atyraū"
  },
  {
  "id": "Baikonur",
  "description": "Baikonur"
  },
  {
  "id": "Batys Qazaqstan",
  "description": "Batys Qazaqstan"
  },
  {
  "id": "East Kazakhstan",
  "description": "East Kazakhstan"
  },
  {
  "id": "Jetisu Region",
  "description": "Jetisu Region"
  },
  {
  "id": "Karaganda",
  "description": "Karaganda"
  },
  {
  "id": "Mangghystaū",
  "description": "Mangghystaū"
  },
  {
  "id": "North Kazakhstan",
  "description": "North Kazakhstan"
  },
  {
  "id": "Pavlodar Region",
  "description": "Pavlodar Region"
  },
  {
  "id": "Qostanay",
  "description": "Qostanay"
  },
  {
  "id": "Qyzylorda",
  "description": "Qyzylorda"
  },
  {
  "id": "Shymkent",
  "description": "Shymkent"
  },
  {
  "id": "South Kazakhstan",
  "description": "South Kazakhstan"
  },
  {
  "id": "Ulytau Region",
  "description": "Ulytau Region"
  },
  {
  "id": "Zhambyl",
  "description": "Zhambyl"
  }
  ]
  },
  {
  "code": "KE",
  "description": "Kenya",
  "regions": [
  {
  "id": "Baringo",
  "description": "Baringo"
  },
  {
  "id": "Bomet County",
  "description": "Bomet County"
  },
  {
  "id": "Bungoma County",
  "description": "Bungoma County"
  },
  {
  "id": "Busia County",
  "description": "Busia County"
  },
  {
  "id": "Elegeyo-Marakwet",
  "description": "Elegeyo-Marakwet"
  },
  {
  "id": "Embu County",
  "description": "Embu County"
  },
  {
  "id": "Garissa County",
  "description": "Garissa County"
  },
  {
  "id": "Homa Bay County",
  "description": "Homa Bay County"
  },
  {
  "id": "Isiolo County",
  "description": "Isiolo County"
  },
  {
  "id": "Kajiado County",
  "description": "Kajiado County"
  },
  {
  "id": "Kakamega County",
  "description": "Kakamega County"
  },
  {
  "id": "Kericho County",
  "description": "Kericho County"
  },
  {
  "id": "Kiambu County",
  "description": "Kiambu County"
  },
  {
  "id": "Kilifi County",
  "description": "Kilifi County"
  },
  {
  "id": "Kirinyaga County",
  "description": "Kirinyaga County"
  },
  {
  "id": "Kisii County",
  "description": "Kisii County"
  },
  {
  "id": "Kisumu County",
  "description": "Kisumu County"
  },
  {
  "id": "Kitui County",
  "description": "Kitui County"
  },
  {
  "id": "Kwale County",
  "description": "Kwale County"
  },
  {
  "id": "Laikipia",
  "description": "Laikipia"
  },
  {
  "id": "Lamu",
  "description": "Lamu"
  },
  {
  "id": "Machakos County",
  "description": "Machakos County"
  },
  {
  "id": "Makueni County",
  "description": "Makueni County"
  },
  {
  "id": "Mandera County",
  "description": "Mandera County"
  },
  {
  "id": "Marsabit County",
  "description": "Marsabit County"
  },
  {
  "id": "Meru County",
  "description": "Meru County"
  },
  {
  "id": "Migori County",
  "description": "Migori County"
  },
  {
  "id": "Mombasa County",
  "description": "Mombasa County"
  },
  {
  "id": "Murang'A",
  "description": "Murang'A"
  },
  {
  "id": "Nairobi County",
  "description": "Nairobi County"
  },
  {
  "id": "Nakuru County",
  "description": "Nakuru County"
  },
  {
  "id": "Nandi",
  "description": "Nandi"
  },
  {
  "id": "Narok County",
  "description": "Narok County"
  },
  {
  "id": "Nyamira county",
  "description": "Nyamira county"
  },
  {
  "id": "Nyandarua County",
  "description": "Nyandarua County"
  },
  {
  "id": "Nyeri County",
  "description": "Nyeri County"
  },
  {
  "id": "Samburu County",
  "description": "Samburu County"
  },
  {
  "id": "Siaya County",
  "description": "Siaya County"
  },
  {
  "id": "Taita Taveta",
  "description": "Taita Taveta"
  },
  {
  "id": "Tana River County",
  "description": "Tana River County"
  },
  {
  "id": "Tharaka - Nithi",
  "description": "Tharaka - Nithi"
  },
  {
  "id": "Trans Nzoia",
  "description": "Trans Nzoia"
  },
  {
  "id": "Turkana County",
  "description": "Turkana County"
  },
  {
  "id": "Uasin Gishu County",
  "description": "Uasin Gishu County"
  },
  {
  "id": "Vihiga County",
  "description": "Vihiga County"
  },
  {
  "id": "Wajir County",
  "description": "Wajir County"
  },
  {
  "id": "West Pokot County",
  "description": "West Pokot County"
  }
  ]
  },
  {
  "code": "KI",
  "description": "Kiribati",
  "regions": [
  {
  "id": "Gilbert Islands",
  "description": "Gilbert Islands"
  },
  {
  "id": "Line Islands",
  "description": "Line Islands"
  },
  {
  "id": "Phoenix Islands",
  "description": "Phoenix Islands"
  }
  ]
  },
  {
  "code": "XK",
  "description": "Kosovo",
  "regions": [
  {
  "id": "Ferizaj",
  "description": "Ferizaj"
  },
  {
  "id": "Gjakova",
  "description": "Gjakova"
  },
  {
  "id": "Gjilan",
  "description": "Gjilan"
  },
  {
  "id": "Mitrovica",
  "description": "Mitrovica"
  },
  {
  "id": "Pec",
  "description": "Pec"
  },
  {
  "id": "Pristina",
  "description": "Pristina"
  },
  {
  "id": "Prizren",
  "description": "Prizren"
  }
  ]
  },
  {
  "code": "KW",
  "description": "Kuwait",
  "regions": [
  {
  "id": "Al Aḩmadī",
  "description": "Al Aḩmadī"
  },
  {
  "id": "Al Asimah",
  "description": "Al Asimah"
  },
  {
  "id": "Al Farwaniyah",
  "description": "Al Farwaniyah"
  },
  {
  "id": "Al Jahra Governorate",
  "description": "Al Jahra Governorate"
  },
  {
  "id": "Hawalli",
  "description": "Hawalli"
  },
  {
  "id": "Mubārak al Kabīr",
  "description": "Mubārak al Kabīr"
  }
  ]
  },
  {
  "code": "KG",
  "description": "Kyrgyzstan",
  "regions": [
  {
  "id": "Batken",
  "description": "Batken"
  },
  {
  "id": "Bishkek",
  "description": "Bishkek"
  },
  {
  "id": "Chuy Region",
  "description": "Chuy Region"
  },
  {
  "id": "Issyk-Kul",
  "description": "Issyk-Kul"
  },
  {
  "id": "Jalal-Abad Region",
  "description": "Jalal-Abad Region"
  },
  {
  "id": "Naryn Region",
  "description": "Naryn Region"
  },
  {
  "id": "Osh City",
  "description": "Osh City"
  },
  {
  "id": "Osh Region",
  "description": "Osh Region"
  },
  {
  "id": "Talas Region",
  "description": "Talas Region"
  }
  ]
  },
  {
  "code": "LA",
  "description": "Laos",
  "regions": [
  {
  "id": "Attapu",
  "description": "Attapu"
  },
  {
  "id": "Bokeo",
  "description": "Bokeo"
  },
  {
  "id": "Bolikhamsai",
  "description": "Bolikhamsai"
  },
  {
  "id": "Champasak Province",
  "description": "Champasak Province"
  },
  {
  "id": "Houaphan",
  "description": "Houaphan"
  },
  {
  "id": "Khammouane Province",
  "description": "Khammouane Province"
  },
  {
  "id": "Loungnamtha",
  "description": "Loungnamtha"
  },
  {
  "id": "Luang Prabang Province",
  "description": "Luang Prabang Province"
  },
  {
  "id": "Oudômxai",
  "description": "Oudômxai"
  },
  {
  "id": "Phôngsali",
  "description": "Phôngsali"
  },
  {
  "id": "Salavan Province",
  "description": "Salavan Province"
  },
  {
  "id": "Savannakhet Province",
  "description": "Savannakhet Province"
  },
  {
  "id": "Vientiane",
  "description": "Vientiane"
  },
  {
  "id": "Vientiane Prefecture",
  "description": "Vientiane Prefecture"
  },
  {
  "id": "Xaisomboun",
  "description": "Xaisomboun"
  },
  {
  "id": "Xékong",
  "description": "Xékong"
  },
  {
  "id": "Xiagnabouli",
  "description": "Xiagnabouli"
  },
  {
  "id": "Xiangkhoang",
  "description": "Xiangkhoang"
  }
  ]
  },
  {
  "code": "LV",
  "description": "Latvia",
  "regions": [
  {
  "id": "Ādaži",
  "description": "Ādaži"
  },
  {
  "id": "Aglona",
  "description": "Aglona"
  },
  {
  "id": "Aizkraukle Municipality",
  "description": "Aizkraukle Municipality"
  },
  {
  "id": "Aizpute",
  "description": "Aizpute"
  },
  {
  "id": "Aknīste",
  "description": "Aknīste"
  },
  {
  "id": "Aloja",
  "description": "Aloja"
  },
  {
  "id": "Alsunga",
  "description": "Alsunga"
  },
  {
  "id": "Alūksne Municipality",
  "description": "Alūksne Municipality"
  },
  {
  "id": "Amatas",
  "description": "Amatas"
  },
  {
  "id": "Apes",
  "description": "Apes"
  },
  {
  "id": "Auces",
  "description": "Auces"
  },
  {
  "id": "Augšdaugava Municipality",
  "description": "Augšdaugava Municipality"
  },
  {
  "id": "Babīte",
  "description": "Babīte"
  },
  {
  "id": "Baldone",
  "description": "Baldone"
  },
  {
  "id": "Baltinava",
  "description": "Baltinava"
  },
  {
  "id": "Balvi Municipality",
  "description": "Balvi Municipality"
  },
  {
  "id": "Bauska Municipality",
  "description": "Bauska Municipality"
  },
  {
  "id": "Beverīna",
  "description": "Beverīna"
  },
  {
  "id": "Brocēni",
  "description": "Brocēni"
  },
  {
  "id": "Burtnieki",
  "description": "Burtnieki"
  },
  {
  "id": "Carnikava",
  "description": "Carnikava"
  },
  {
  "id": "Cēsis Municipality",
  "description": "Cēsis Municipality"
  },
  {
  "id": "Cesvaine",
  "description": "Cesvaine"
  },
  {
  "id": "Cibla",
  "description": "Cibla"
  },
  {
  "id": "Dagda",
  "description": "Dagda"
  },
  {
  "id": "Daugavpils",
  "description": "Daugavpils"
  },
  {
  "id": "Daugavpils municipality",
  "description": "Daugavpils municipality"
  },
  {
  "id": "Dobele Municipality",
  "description": "Dobele Municipality"
  },
  {
  "id": "Dundaga",
  "description": "Dundaga"
  },
  {
  "id": "Durbe",
  "description": "Durbe"
  },
  {
  "id": "Engure",
  "description": "Engure"
  },
  {
  "id": "Ērgļi",
  "description": "Ērgļi"
  },
  {
  "id": "Garkalne",
  "description": "Garkalne"
  },
  {
  "id": "Grobiņa",
  "description": "Grobiņa"
  },
  {
  "id": "Gulbene Municipality",
  "description": "Gulbene Municipality"
  },
  {
  "id": "Ikšķile",
  "description": "Ikšķile"
  },
  {
  "id": "Ilūkste",
  "description": "Ilūkste"
  },
  {
  "id": "Inčukalns",
  "description": "Inčukalns"
  },
  {
  "id": "Jaunjelgava",
  "description": "Jaunjelgava"
  },
  {
  "id": "Jaunpiebalga",
  "description": "Jaunpiebalga"
  },
  {
  "id": "Jaunpils",
  "description": "Jaunpils"
  },
  {
  "id": "Jēkabpils",
  "description": "Jēkabpils"
  },
  {
  "id": "Jēkabpils Municipality",
  "description": "Jēkabpils Municipality"
  },
  {
  "id": "Jelgava",
  "description": "Jelgava"
  },
  {
  "id": "Jelgava Municipality",
  "description": "Jelgava Municipality"
  },
  {
  "id": "Jūrmala",
  "description": "Jūrmala"
  },
  {
  "id": "Kandava",
  "description": "Kandava"
  },
  {
  "id": "Karsava",
  "description": "Karsava"
  },
  {
  "id": "Ķegums",
  "description": "Ķegums"
  },
  {
  "id": "Ķekava",
  "description": "Ķekava"
  },
  {
  "id": "Kocēni",
  "description": "Kocēni"
  },
  {
  "id": "Koknese",
  "description": "Koknese"
  },
  {
  "id": "Krāslava Municipality",
  "description": "Krāslava Municipality"
  },
  {
  "id": "Krimulda",
  "description": "Krimulda"
  },
  {
  "id": "Krustpils",
  "description": "Krustpils"
  },
  {
  "id": "Kuldīga Municipality",
  "description": "Kuldīga Municipality"
  },
  {
  "id": "Lecava",
  "description": "Lecava"
  },
  {
  "id": "Lielvārde",
  "description": "Lielvārde"
  },
  {
  "id": "Liepāja",
  "description": "Liepāja"
  },
  {
  "id": "Līgatne",
  "description": "Līgatne"
  },
  {
  "id": "Limbaži Municipality",
  "description": "Limbaži Municipality"
  },
  {
  "id": "Līvāni",
  "description": "Līvāni"
  },
  {
  "id": "Lubāna",
  "description": "Lubāna"
  },
  {
  "id": "Ludza Municipality",
  "description": "Ludza Municipality"
  },
  {
  "id": "Madona Municipality",
  "description": "Madona Municipality"
  },
  {
  "id": "Mālpils",
  "description": "Mālpils"
  },
  {
  "id": "Mārupe",
  "description": "Mārupe"
  },
  {
  "id": "Mazsalaca",
  "description": "Mazsalaca"
  },
  {
  "id": "Mesraga",
  "description": "Mesraga"
  },
  {
  "id": "Naukšēni",
  "description": "Naukšēni"
  },
  {
  "id": "Nereta",
  "description": "Nereta"
  },
  {
  "id": "Nīca",
  "description": "Nīca"
  },
  {
  "id": "Ogre",
  "description": "Ogre"
  },
  {
  "id": "Olaine",
  "description": "Olaine"
  },
  {
  "id": "Ozolnieku",
  "description": "Ozolnieku"
  },
  {
  "id": "Pārgaujas",
  "description": "Pārgaujas"
  },
  {
  "id": "Pāvilostas",
  "description": "Pāvilostas"
  },
  {
  "id": "Pļaviņu",
  "description": "Pļaviņu"
  },
  {
  "id": "Preiļu novads",
  "description": "Preiļu novads"
  },
  {
  "id": "Priekule",
  "description": "Priekule"
  },
  {
  "id": "Priekuļi",
  "description": "Priekuļi"
  },
  {
  "id": "Raunas",
  "description": "Raunas"
  },
  {
  "id": "Rēzekne",
  "description": "Rēzekne"
  },
  {
  "id": "Rēzekne Municipality",
  "description": "Rēzekne Municipality"
  },
  {
  "id": "Riebiņu",
  "description": "Riebiņu"
  },
  {
  "id": "Riga",
  "description": "Riga"
  },
  {
  "id": "Rojas",
  "description": "Rojas"
  },
  {
  "id": "Ropaži Municipality",
  "description": "Ropaži Municipality"
  },
  {
  "id": "Rucavas",
  "description": "Rucavas"
  },
  {
  "id": "Rugāju",
  "description": "Rugāju"
  },
  {
  "id": "Rūjienas",
  "description": "Rūjienas"
  },
  {
  "id": "Rundāles",
  "description": "Rundāles"
  },
  {
  "id": "Salacgrīvas",
  "description": "Salacgrīvas"
  },
  {
  "id": "Salas",
  "description": "Salas"
  },
  {
  "id": "Salaspils Municipality",
  "description": "Salaspils Municipality"
  },
  {
  "id": "Saldus Rajons",
  "description": "Saldus Rajons"
  },
  {
  "id": "Saulkrasti Municipality",
  "description": "Saulkrasti Municipality"
  },
  {
  "id": "Sēja",
  "description": "Sēja"
  },
  {
  "id": "Sigulda Municipality",
  "description": "Sigulda Municipality"
  },
  {
  "id": "Skrīveri",
  "description": "Skrīveri"
  },
  {
  "id": "Skrunda",
  "description": "Skrunda"
  },
  {
  "id": "Smiltene Municipality",
  "description": "Smiltene Municipality"
  },
  {
  "id": "South Kurzeme Municipality",
  "description": "South Kurzeme Municipality"
  },
  {
  "id": "Stopiņi",
  "description": "Stopiņi"
  },
  {
  "id": "Strenči",
  "description": "Strenči"
  },
  {
  "id": "Talsi Municipality",
  "description": "Talsi Municipality"
  },
  {
  "id": "Tērvete",
  "description": "Tērvete"
  },
  {
  "id": "Tukums Municipality",
  "description": "Tukums Municipality"
  },
  {
  "id": "Vaiņode",
  "description": "Vaiņode"
  },
  {
  "id": "Valka",
  "description": "Valka"
  },
  {
  "id": "Valmiera",
  "description": "Valmiera"
  },
  {
  "id": "Varakļāni Municipality",
  "description": "Varakļāni Municipality"
  },
  {
  "id": "Vārkava",
  "description": "Vārkava"
  },
  {
  "id": "Vecpiebalga",
  "description": "Vecpiebalga"
  },
  {
  "id": "Vecumnieki",
  "description": "Vecumnieki"
  },
  {
  "id": "Ventspils",
  "description": "Ventspils"
  },
  {
  "id": "Ventspils Municipality",
  "description": "Ventspils Municipality"
  },
  {
  "id": "Viesīte",
  "description": "Viesīte"
  },
  {
  "id": "Viļaka",
  "description": "Viļaka"
  },
  {
  "id": "Vilanu",
  "description": "Vilanu"
  },
  {
  "id": "Zilupes",
  "description": "Zilupes"
  }
  ]
  },
  {
  "code": "LB",
  "description": "Lebanon",
  "regions": [
  {
  "id": "Aakkâr",
  "description": "Aakkâr"
  },
  {
  "id": "Baalbek-Hermel Governorate",
  "description": "Baalbek-Hermel Governorate"
  },
  {
  "id": "Béqaa",
  "description": "Béqaa"
  },
  {
  "id": "Beyrouth",
  "description": "Beyrouth"
  },
  {
  "id": "Liban-Nord",
  "description": "Liban-Nord"
  },
  {
  "id": "Mont-Liban",
  "description": "Mont-Liban"
  },
  {
  "id": "Nabatîyé",
  "description": "Nabatîyé"
  },
  {
  "id": "South Governorate",
  "description": "South Governorate"
  }
  ]
  },
  {
  "code": "LS",
  "description": "Lesotho",
  "regions": [
  {
  "id": "Berea",
  "description": "Berea"
  },
  {
  "id": "Butha-Buthe",
  "description": "Butha-Buthe"
  },
  {
  "id": "Leribe",
  "description": "Leribe"
  },
  {
  "id": "Mafeteng District",
  "description": "Mafeteng District"
  },
  {
  "id": "Maseru District",
  "description": "Maseru District"
  },
  {
  "id": "Mohale's Hoek District",
  "description": "Mohale's Hoek District"
  },
  {
  "id": "Mokhotlong District",
  "description": "Mokhotlong District"
  },
  {
  "id": "Qacha's Nek District",
  "description": "Qacha's Nek District"
  },
  {
  "id": "Quthing",
  "description": "Quthing"
  },
  {
  "id": "Thaba-Tseka",
  "description": "Thaba-Tseka"
  }
  ]
  },
  {
  "code": "LR",
  "description": "Liberia",
  "regions": [
  {
  "id": "Bomi County",
  "description": "Bomi County"
  },
  {
  "id": "Bong County",
  "description": "Bong County"
  },
  {
  "id": "Gbarpolu County",
  "description": "Gbarpolu County"
  },
  {
  "id": "Grand Bassa County",
  "description": "Grand Bassa County"
  },
  {
  "id": "Grand Cape Mount County",
  "description": "Grand Cape Mount County"
  },
  {
  "id": "Grand Gedeh County",
  "description": "Grand Gedeh County"
  },
  {
  "id": "Grand Kru County",
  "description": "Grand Kru County"
  },
  {
  "id": "Lofa County",
  "description": "Lofa County"
  },
  {
  "id": "Margibi County",
  "description": "Margibi County"
  },
  {
  "id": "Maryland County",
  "description": "Maryland County"
  },
  {
  "id": "Montserrado County",
  "description": "Montserrado County"
  },
  {
  "id": "Nimba",
  "description": "Nimba"
  },
  {
  "id": "River Cess County",
  "description": "River Cess County"
  },
  {
  "id": "River Gee County",
  "description": "River Gee County"
  },
  {
  "id": "Sinoe County",
  "description": "Sinoe County"
  }
  ]
  },
  {
  "code": "LY",
  "description": "Libya",
  "regions": [
  {
  "id": "Al Buţnān",
  "description": "Al Buţnān"
  },
  {
  "id": "Al Jabal al Akhḑar",
  "description": "Al Jabal al Akhḑar"
  },
  {
  "id": "Al Jafārah",
  "description": "Al Jafārah"
  },
  {
  "id": "Al Jufrah",
  "description": "Al Jufrah"
  },
  {
  "id": "Al Kufrah",
  "description": "Al Kufrah"
  },
  {
  "id": "Al Marj",
  "description": "Al Marj"
  },
  {
  "id": "Al Marqab",
  "description": "Al Marqab"
  },
  {
  "id": "Al Wāḩāt",
  "description": "Al Wāḩāt"
  },
  {
  "id": "An Nuqāţ al Khams",
  "description": "An Nuqāţ al Khams"
  },
  {
  "id": "Ash Shāţiʼ",
  "description": "Ash Shāţiʼ"
  },
  {
  "id": "Az Zāwiyah",
  "description": "Az Zāwiyah"
  },
  {
  "id": "Banghāzī",
  "description": "Banghāzī"
  },
  {
  "id": "Darnah",
  "description": "Darnah"
  },
  {
  "id": "Ghāt",
  "description": "Ghāt"
  },
  {
  "id": "Jabal al Gharbi",
  "description": "Jabal al Gharbi"
  },
  {
  "id": "Mişrātah",
  "description": "Mişrātah"
  },
  {
  "id": "Murzuq District",
  "description": "Murzuq District"
  },
  {
  "id": "Nālūt",
  "description": "Nālūt"
  },
  {
  "id": "Sabha District",
  "description": "Sabha District"
  },
  {
  "id": "Surt",
  "description": "Surt"
  },
  {
  "id": "Tripoli",
  "description": "Tripoli"
  },
  {
  "id": "Wādī al Ḩayāt",
  "description": "Wādī al Ḩayāt"
  }
  ]
  },
  {
  "code": "LI",
  "description": "Liechtenstein",
  "regions": [
  {
  "id": "Balzers",
  "description": "Balzers"
  },
  {
  "id": "Eschen",
  "description": "Eschen"
  },
  {
  "id": "Gamprin",
  "description": "Gamprin"
  },
  {
  "id": "Mauren",
  "description": "Mauren"
  },
  {
  "id": "Planken",
  "description": "Planken"
  },
  {
  "id": "Ruggell",
  "description": "Ruggell"
  },
  {
  "id": "Schaan",
  "description": "Schaan"
  },
  {
  "id": "Schellenberg",
  "description": "Schellenberg"
  },
  {
  "id": "Triesen",
  "description": "Triesen"
  },
  {
  "id": "Triesenberg",
  "description": "Triesenberg"
  },
  {
  "id": "Vaduz",
  "description": "Vaduz"
  }
  ]
  },
  {
  "code": "LT",
  "description": "Lithuania",
  "regions": [
  {
  "id": "Alytus",
  "description": "Alytus"
  },
  {
  "id": "Kaunas",
  "description": "Kaunas"
  },
  {
  "id": "Klaipėda County",
  "description": "Klaipėda County"
  },
  {
  "id": "Marijampolė County",
  "description": "Marijampolė County"
  },
  {
  "id": "Panevėžys",
  "description": "Panevėžys"
  },
  {
  "id": "Siauliai",
  "description": "Siauliai"
  },
  {
  "id": "Tauragė County",
  "description": "Tauragė County"
  },
  {
  "id": "Telsiai",
  "description": "Telsiai"
  },
  {
  "id": "Utena",
  "description": "Utena"
  },
  {
  "id": "Vilnius",
  "description": "Vilnius"
  }
  ]
  },
  {
  "code": "LU",
  "description": "Luxembourg",
  "regions": [
  {
  "id": "Capellen",
  "description": "Capellen"
  },
  {
  "id": "Clervaux",
  "description": "Clervaux"
  },
  {
  "id": "Diekirch",
  "description": "Diekirch"
  },
  {
  "id": "Echternach",
  "description": "Echternach"
  },
  {
  "id": "Esch-sur-Alzette",
  "description": "Esch-sur-Alzette"
  },
  {
  "id": "Grevenmacher",
  "description": "Grevenmacher"
  },
  {
  "id": "Luxembourg",
  "description": "Luxembourg"
  },
  {
  "id": "Mersch",
  "description": "Mersch"
  },
  {
  "id": "Redange",
  "description": "Redange"
  },
  {
  "id": "Remich",
  "description": "Remich"
  },
  {
  "id": "Vianden",
  "description": "Vianden"
  },
  {
  "id": "Wiltz",
  "description": "Wiltz"
  }
  ]
  },
  {
  "code": "MO",
  "description": "Macao",
  "regions": [
  {
  "id": "Cotai",
  "description": "Cotai"
  },
  {
  "id": "Nossa Senhora de Fátima",
  "description": "Nossa Senhora de Fátima"
  },
  {
  "id": "Nossa Senhora do Carmo",
  "description": "Nossa Senhora do Carmo"
  },
  {
  "id": "Santo António",
  "description": "Santo António"
  },
  {
  "id": "São Francisco Xavier",
  "description": "São Francisco Xavier"
  },
  {
  "id": "São Lázaro",
  "description": "São Lázaro"
  },
  {
  "id": "São Lourenço",
  "description": "São Lourenço"
  },
  {
  "id": "Sé",
  "description": "Sé"
  }
  ]
  },
  {
  "code": "MK",
  "description": "Macedonia",
  "regions": [
  {
  "id": "Aerodrom",
  "description": "Aerodrom"
  },
  {
  "id": "Arachinovo",
  "description": "Arachinovo"
  },
  {
  "id": "Berovo",
  "description": "Berovo"
  },
  {
  "id": "Bitola",
  "description": "Bitola"
  },
  {
  "id": "Bogdanci",
  "description": "Bogdanci"
  },
  {
  "id": "Bogovinje",
  "description": "Bogovinje"
  },
  {
  "id": "Bosilovo",
  "description": "Bosilovo"
  },
  {
  "id": "Brvenica",
  "description": "Brvenica"
  },
  {
  "id": "Butel",
  "description": "Butel"
  },
  {
  "id": "Čair",
  "description": "Čair"
  },
  {
  "id": "Centar",
  "description": "Centar"
  },
  {
  "id": "Centar Zhupa",
  "description": "Centar Zhupa"
  },
  {
  "id": "Češinovo-Obleševo",
  "description": "Češinovo-Obleševo"
  },
  {
  "id": "Chashka",
  "description": "Chashka"
  },
  {
  "id": "Chucher Sandevo",
  "description": "Chucher Sandevo"
  },
  {
  "id": "Debar",
  "description": "Debar"
  },
  {
  "id": "Debarca",
  "description": "Debarca"
  },
  {
  "id": "Delchevo",
  "description": "Delchevo"
  },
  {
  "id": "Demir Hisar",
  "description": "Demir Hisar"
  },
  {
  "id": "Demir Kapija",
  "description": "Demir Kapija"
  },
  {
  "id": "Dojran",
  "description": "Dojran"
  },
  {
  "id": "Dolneni",
  "description": "Dolneni"
  },
  {
  "id": "Drugovo",
  "description": "Drugovo"
  },
  {
  "id": "Gazi Baba",
  "description": "Gazi Baba"
  },
  {
  "id": "Gevgelija",
  "description": "Gevgelija"
  },
  {
  "id": "Gostivar",
  "description": "Gostivar"
  },
  {
  "id": "Gradsko",
  "description": "Gradsko"
  },
  {
  "id": "Grad Skopje",
  "description": "Grad Skopje"
  },
  {
  "id": "Ilinden",
  "description": "Ilinden"
  },
  {
  "id": "Jegunovce",
  "description": "Jegunovce"
  },
  {
  "id": "Karbinci",
  "description": "Karbinci"
  },
  {
  "id": "Karpoš",
  "description": "Karpoš"
  },
  {
  "id": "Kavadarci",
  "description": "Kavadarci"
  },
  {
  "id": "Kichevo",
  "description": "Kichevo"
  },
  {
  "id": "Kisela Voda",
  "description": "Kisela Voda"
  },
  {
  "id": "Kochani",
  "description": "Kochani"
  },
  {
  "id": "Konche",
  "description": "Konche"
  },
  {
  "id": "Kratovo",
  "description": "Kratovo"
  },
  {
  "id": "Kriva Palanka",
  "description": "Kriva Palanka"
  },
  {
  "id": "Krivogashtani",
  "description": "Krivogashtani"
  },
  {
  "id": "Krushevo",
  "description": "Krushevo"
  },
  {
  "id": "Kumanovo",
  "description": "Kumanovo"
  },
  {
  "id": "Lipkovo",
  "description": "Lipkovo"
  },
  {
  "id": "Lozovo",
  "description": "Lozovo"
  },
  {
  "id": "Makedonska Kamenica",
  "description": "Makedonska Kamenica"
  },
  {
  "id": "Makedonski Brod",
  "description": "Makedonski Brod"
  },
  {
  "id": "Mavrovo and Rostuša",
  "description": "Mavrovo and Rostuša"
  },
  {
  "id": "Mogila",
  "description": "Mogila"
  },
  {
  "id": "Negotino",
  "description": "Negotino"
  },
  {
  "id": "Novaci",
  "description": "Novaci"
  },
  {
  "id": "Novo Selo",
  "description": "Novo Selo"
  },
  {
  "id": "Ohrid",
  "description": "Ohrid"
  },
  {
  "id": "Opstina Gjorce Petrov",
  "description": "Opstina Gjorce Petrov"
  },
  {
  "id": "Oslomej",
  "description": "Oslomej"
  },
  {
  "id": "Pehchevo",
  "description": "Pehchevo"
  },
  {
  "id": "Petrovec",
  "description": "Petrovec"
  },
  {
  "id": "Plasnica",
  "description": "Plasnica"
  },
  {
  "id": "Prilep",
  "description": "Prilep"
  },
  {
  "id": "Probishtip",
  "description": "Probishtip"
  },
  {
  "id": "Radovish",
  "description": "Radovish"
  },
  {
  "id": "Rankovce",
  "description": "Rankovce"
  },
  {
  "id": "Resen",
  "description": "Resen"
  },
  {
  "id": "Rosoman",
  "description": "Rosoman"
  },
  {
  "id": "Saraj",
  "description": "Saraj"
  },
  {
  "id": "Shtip",
  "description": "Shtip"
  },
  {
  "id": "Sopište",
  "description": "Sopište"
  },
  {
  "id": "Staro Nagorichane",
  "description": "Staro Nagorichane"
  },
  {
  "id": "Struga",
  "description": "Struga"
  },
  {
  "id": "Strumica",
  "description": "Strumica"
  },
  {
  "id": "Studenichani",
  "description": "Studenichani"
  },
  {
  "id": "Šuto Orizari",
  "description": "Šuto Orizari"
  },
  {
  "id": "Sveti Nikole",
  "description": "Sveti Nikole"
  },
  {
  "id": "Tearce",
  "description": "Tearce"
  },
  {
  "id": "Tetovo",
  "description": "Tetovo"
  },
  {
  "id": "Valandovo",
  "description": "Valandovo"
  },
  {
  "id": "Vasilevo",
  "description": "Vasilevo"
  },
  {
  "id": "Veles",
  "description": "Veles"
  },
  {
  "id": "Vevchani",
  "description": "Vevchani"
  },
  {
  "id": "Vinica",
  "description": "Vinica"
  },
  {
  "id": "Vraneštica",
  "description": "Vraneštica"
  },
  {
  "id": "Vrapchishte",
  "description": "Vrapchishte"
  },
  {
  "id": "Zajas",
  "description": "Zajas"
  },
  {
  "id": "Zelenikovo",
  "description": "Zelenikovo"
  },
  {
  "id": "Zhelino",
  "description": "Zhelino"
  },
  {
  "id": "Zrnovci",
  "description": "Zrnovci"
  }
  ]
  },
  {
  "code": "MG",
  "description": "Madagascar",
  "regions": [
  {
  "id": "Alaotra Mangoro",
  "description": "Alaotra Mangoro"
  },
  {
  "id": "Amoron'i Mania",
  "description": "Amoron'i Mania"
  },
  {
  "id": "Analamanga",
  "description": "Analamanga"
  },
  {
  "id": "Analanjirofo",
  "description": "Analanjirofo"
  },
  {
  "id": "Androy",
  "description": "Androy"
  },
  {
  "id": "Anosy",
  "description": "Anosy"
  },
  {
  "id": "Atsimo-Andrefana",
  "description": "Atsimo-Andrefana"
  },
  {
  "id": "Atsimo-Atsinanana",
  "description": "Atsimo-Atsinanana"
  },
  {
  "id": "Atsinanana",
  "description": "Atsinanana"
  },
  {
  "id": "Betsiboka",
  "description": "Betsiboka"
  },
  {
  "id": "Boeny",
  "description": "Boeny"
  },
  {
  "id": "Bongolava",
  "description": "Bongolava"
  },
  {
  "id": "Diana",
  "description": "Diana"
  },
  {
  "id": "Fitovinany Region",
  "description": "Fitovinany Region"
  },
  {
  "id": "Ihorombe",
  "description": "Ihorombe"
  },
  {
  "id": "Itasy",
  "description": "Itasy"
  },
  {
  "id": "Melaky",
  "description": "Melaky"
  },
  {
  "id": "Menabe",
  "description": "Menabe"
  },
  {
  "id": "Sava",
  "description": "Sava"
  },
  {
  "id": "Sofia",
  "description": "Sofia"
  },
  {
  "id": "Upper Matsiatra",
  "description": "Upper Matsiatra"
  },
  {
  "id": "Vakinankaratra",
  "description": "Vakinankaratra"
  },
  {
  "id": "Vatovavy Fitovinany",
  "description": "Vatovavy Fitovinany"
  },
  {
  "id": "Vatovavy Region",
  "description": "Vatovavy Region"
  }
  ]
  },
  {
  "code": "MW",
  "description": "Malawi",
  "regions": [
  {
  "id": "Central Region",
  "description": "Central Region"
  },
  {
  "id": "Northern Region",
  "description": "Northern Region"
  },
  {
  "id": "Southern Region",
  "description": "Southern Region"
  }
  ]
  },
  {
  "code": "MY",
  "description": "Malaysia",
  "regions": [
  {
  "id": "Johor",
  "description": "Johor"
  },
  {
  "id": "Kedah",
  "description": "Kedah"
  },
  {
  "id": "Kelantan",
  "description": "Kelantan"
  },
  {
  "id": "Kuala Lumpur",
  "description": "Kuala Lumpur"
  },
  {
  "id": "Labuan",
  "description": "Labuan"
  },
  {
  "id": "Melaka",
  "description": "Melaka"
  },
  {
  "id": "Negeri Sembilan",
  "description": "Negeri Sembilan"
  },
  {
  "id": "Pahang",
  "description": "Pahang"
  },
  {
  "id": "Penang",
  "description": "Penang"
  },
  {
  "id": "Perak",
  "description": "Perak"
  },
  {
  "id": "Perlis",
  "description": "Perlis"
  },
  {
  "id": "Putrajaya",
  "description": "Putrajaya"
  },
  {
  "id": "Sabah",
  "description": "Sabah"
  },
  {
  "id": "Sarawak",
  "description": "Sarawak"
  },
  {
  "id": "Selangor",
  "description": "Selangor"
  },
  {
  "id": "Terengganu",
  "description": "Terengganu"
  }
  ]
  },
  {
  "code": "MV",
  "description": "Maldives",
  "regions": [
  {
  "id": "Baa Atholhu",
  "description": "Baa Atholhu"
  },
  {
  "id": "Dhaalu Atholhu",
  "description": "Dhaalu Atholhu"
  },
  {
  "id": "Faadhippolhu Atoll",
  "description": "Faadhippolhu Atoll"
  },
  {
  "id": "Faafu Atholhu",
  "description": "Faafu Atholhu"
  },
  {
  "id": "Gaafu Alif Atoll",
  "description": "Gaafu Alif Atoll"
  },
  {
  "id": "Gaafu Dhaalu Atoll",
  "description": "Gaafu Dhaalu Atoll"
  },
  {
  "id": "Gnyaviyani Atoll",
  "description": "Gnyaviyani Atoll"
  },
  {
  "id": "Haa Alifu Atholhu",
  "description": "Haa Alifu Atholhu"
  },
  {
  "id": "Haa Dhaalu Atholhu",
  "description": "Haa Dhaalu Atholhu"
  },
  {
  "id": "Kaafu Atoll",
  "description": "Kaafu Atoll"
  },
  {
  "id": "Laamu",
  "description": "Laamu"
  },
  {
  "id": "Male",
  "description": "Male"
  },
  {
  "id": "Meemu Atholhu",
  "description": "Meemu Atholhu"
  },
  {
  "id": "Noonu Atoll",
  "description": "Noonu Atoll"
  },
  {
  "id": "Northern Ari Atoll",
  "description": "Northern Ari Atoll"
  },
  {
  "id": "Raa Atoll",
  "description": "Raa Atoll"
  },
  {
  "id": "Seenu",
  "description": "Seenu"
  },
  {
  "id": "Shaviyani Atholhu",
  "description": "Shaviyani Atholhu"
  },
  {
  "id": "Southern Ari Atoll",
  "description": "Southern Ari Atoll"
  },
  {
  "id": "Thaa Atholhu",
  "description": "Thaa Atholhu"
  },
  {
  "id": "Vaavu Atholhu",
  "description": "Vaavu Atholhu"
  }
  ]
  },
  {
  "code": "ML",
  "description": "Mali",
  "regions": [
  {
  "id": "Bamako",
  "description": "Bamako"
  },
  {
  "id": "Gao",
  "description": "Gao"
  },
  {
  "id": "Kayes",
  "description": "Kayes"
  },
  {
  "id": "Kidal",
  "description": "Kidal"
  },
  {
  "id": "Koulikoro",
  "description": "Koulikoro"
  },
  {
  "id": "Ménaka",
  "description": "Ménaka"
  },
  {
  "id": "Mopti",
  "description": "Mopti"
  },
  {
  "id": "Ségou",
  "description": "Ségou"
  },
  {
  "id": "Sikasso",
  "description": "Sikasso"
  },
  {
  "id": "Taoudénit",
  "description": "Taoudénit"
  },
  {
  "id": "Tombouctou",
  "description": "Tombouctou"
  }
  ]
  },
  {
  "code": "MT",
  "description": "Malta",
  "regions": [
  {
  "id": "Attard",
  "description": "Attard"
  },
  {
  "id": "Balzan",
  "description": "Balzan"
  },
  {
  "id": "Birkirkara",
  "description": "Birkirkara"
  },
  {
  "id": "Birżebbuġa",
  "description": "Birżebbuġa"
  },
  {
  "id": "Bormla",
  "description": "Bormla"
  },
  {
  "id": "Dingli",
  "description": "Dingli"
  },
  {
  "id": "Floriana",
  "description": "Floriana"
  },
  {
  "id": "Għajnsielem",
  "description": "Għajnsielem"
  },
  {
  "id": "Ħal Għargħur",
  "description": "Ħal Għargħur"
  },
  {
  "id": "Ħal Għaxaq",
  "description": "Ħal Għaxaq"
  },
  {
  "id": "Ħaż-Żabbar",
  "description": "Ħaż-Żabbar"
  },
  {
  "id": "Ħaż-Żebbuġ",
  "description": "Ħaż-Żebbuġ"
  },
  {
  "id": "Il-Birgu",
  "description": "Il-Birgu"
  },
  {
  "id": "Il-Fgura",
  "description": "Il-Fgura"
  },
  {
  "id": "Il-Fontana",
  "description": "Il-Fontana"
  },
  {
  "id": "Il-Gudja",
  "description": "Il-Gudja"
  },
  {
  "id": "Il-Gżira",
  "description": "Il-Gżira"
  },
  {
  "id": "Il-Ħamrun",
  "description": "Il-Ħamrun"
  },
  {
  "id": "Il-Kalkara",
  "description": "Il-Kalkara"
  },
  {
  "id": "Il-Marsa",
  "description": "Il-Marsa"
  },
  {
  "id": "Il-Mellieħa",
  "description": "Il-Mellieħa"
  },
  {
  "id": "Il-Mosta",
  "description": "Il-Mosta"
  },
  {
  "id": "Il-Munxar",
  "description": "Il-Munxar"
  },
  {
  "id": "Il-Qala",
  "description": "Il-Qala"
  },
  {
  "id": "Il-Qrendi",
  "description": "Il-Qrendi"
  },
  {
  "id": "In-Nadur",
  "description": "In-Nadur"
  },
  {
  "id": "In-Naxxar",
  "description": "In-Naxxar"
  },
  {
  "id": "Ir-Rabat",
  "description": "Ir-Rabat"
  },
  {
  "id": "Is-Siġġiewi",
  "description": "Is-Siġġiewi"
  },
  {
  "id": "Is-Swieqi",
  "description": "Is-Swieqi"
  },
  {
  "id": "Ix-Xagħra",
  "description": "Ix-Xagħra"
  },
  {
  "id": "Ix-Xewkija",
  "description": "Ix-Xewkija"
  },
  {
  "id": "Ix-Xgħajra",
  "description": "Ix-Xgħajra"
  },
  {
  "id": "Iż-Żebbuġ",
  "description": "Iż-Żebbuġ"
  },
  {
  "id": "Iż-Żejtun",
  "description": "Iż-Żejtun"
  },
  {
  "id": "Iż-Żurrieq",
  "description": "Iż-Żurrieq"
  },
  {
  "id": "Kirkop",
  "description": "Kirkop"
  },
  {
  "id": "L-Għarb",
  "description": "L-Għarb"
  },
  {
  "id": "L-Għasri",
  "description": "L-Għasri"
  },
  {
  "id": "Lija",
  "description": "Lija"
  },
  {
  "id": "L-Iklin",
  "description": "L-Iklin"
  },
  {
  "id": "L-Imdina",
  "description": "L-Imdina"
  },
  {
  "id": "L-Imġarr",
  "description": "L-Imġarr"
  },
  {
  "id": "L-Imqabba",
  "description": "L-Imqabba"
  },
  {
  "id": "L-Imsida",
  "description": "L-Imsida"
  },
  {
  "id": "Luqa",
  "description": "Luqa"
  },
  {
  "id": "Marsaskala",
  "description": "Marsaskala"
  },
  {
  "id": "Marsaxlokk",
  "description": "Marsaxlokk"
  },
  {
  "id": "Mtarfa",
  "description": "Mtarfa"
  },
  {
  "id": "Paola",
  "description": "Paola"
  },
  {
  "id": "Pembroke",
  "description": "Pembroke"
  },
  {
  "id": "Qormi",
  "description": "Qormi"
  },
  {
  "id": "Safi",
  "description": "Safi"
  },
  {
  "id": "Saint John",
  "description": "Saint John"
  },
  {
  "id": "Saint Julian",
  "description": "Saint Julian"
  },
  {
  "id": "Saint Lawrence",
  "description": "Saint Lawrence"
  },
  {
  "id": "Saint Lucia",
  "description": "Saint Lucia"
  },
  {
  "id": "Saint Paul’s Bay",
  "description": "Saint Paul’s Bay"
  },
  {
  "id": "Saint Venera",
  "description": "Saint Venera"
  },
  {
  "id": "Sannat",
  "description": "Sannat"
  },
  {
  "id": "Senglea",
  "description": "Senglea"
  },
  {
  "id": "Ta’ Kerċem",
  "description": "Ta’ Kerċem"
  },
  {
  "id": "Tal-Pietà",
  "description": "Tal-Pietà"
  },
  {
  "id": "Tarxien",
  "description": "Tarxien"
  },
  {
  "id": "Tas-Sliema",
  "description": "Tas-Sliema"
  },
  {
  "id": "Ta’ Xbiex",
  "description": "Ta’ Xbiex"
  },
  {
  "id": "Valletta",
  "description": "Valletta"
  },
  {
  "id": "Victoria",
  "description": "Victoria"
  }
  ]
  },
  {
  "code": "MH",
  "description": "Marshall Islands",
  "regions": [
  {
  "id": "Ailinginae Atoll",
  "description": "Ailinginae Atoll"
  },
  {
  "id": "Ailinglaplap Atoll",
  "description": "Ailinglaplap Atoll"
  },
  {
  "id": "Ailuk Atoll",
  "description": "Ailuk Atoll"
  },
  {
  "id": "Arno Atoll",
  "description": "Arno Atoll"
  },
  {
  "id": "Aur Atoll",
  "description": "Aur Atoll"
  },
  {
  "id": "Bikar Atoll",
  "description": "Bikar Atoll"
  },
  {
  "id": "Bikini Atoll",
  "description": "Bikini Atoll"
  },
  {
  "id": "Bokak Atoll",
  "description": "Bokak Atoll"
  },
  {
  "id": "Ebon Atoll",
  "description": "Ebon Atoll"
  },
  {
  "id": "Enewetak Atoll",
  "description": "Enewetak Atoll"
  },
  {
  "id": "Erikub Atoll",
  "description": "Erikub Atoll"
  },
  {
  "id": "Jabat Island",
  "description": "Jabat Island"
  },
  {
  "id": "Jaluit Atoll",
  "description": "Jaluit Atoll"
  },
  {
  "id": "Jemo Island",
  "description": "Jemo Island"
  },
  {
  "id": "Kili Island",
  "description": "Kili Island"
  },
  {
  "id": "Kwajalein Atoll",
  "description": "Kwajalein Atoll"
  },
  {
  "id": "Lae Atoll",
  "description": "Lae Atoll"
  },
  {
  "id": "Lib Island",
  "description": "Lib Island"
  },
  {
  "id": "Likiep Atoll",
  "description": "Likiep Atoll"
  },
  {
  "id": "Majuro Atoll",
  "description": "Majuro Atoll"
  },
  {
  "id": "Maloelap Atoll",
  "description": "Maloelap Atoll"
  },
  {
  "id": "Mejit Island",
  "description": "Mejit Island"
  },
  {
  "id": "Mili Atoll",
  "description": "Mili Atoll"
  },
  {
  "id": "Namdrik Atoll",
  "description": "Namdrik Atoll"
  },
  {
  "id": "Namu Atoll",
  "description": "Namu Atoll"
  },
  {
  "id": "Rongelap Atoll",
  "description": "Rongelap Atoll"
  },
  {
  "id": "Rongrik Atoll",
  "description": "Rongrik Atoll"
  },
  {
  "id": "Taka Atoll",
  "description": "Taka Atoll"
  },
  {
  "id": "Ujae Atoll",
  "description": "Ujae Atoll"
  },
  {
  "id": "Ujelang",
  "description": "Ujelang"
  },
  {
  "id": "Utrik Atoll",
  "description": "Utrik Atoll"
  },
  {
  "id": "Wotho Atoll",
  "description": "Wotho Atoll"
  },
  {
  "id": "Wotje Atoll",
  "description": "Wotje Atoll"
  }
  ]
  },
  {
  "code": "MQ",
  "description": "Martinique",
  "regions": [
  {
  "id": "Martinique",
  "description": "Martinique"
  }
  ]
  },
  {
  "code": "MR",
  "description": "Mauritania",
  "regions": [
  {
  "id": "Adrar",
  "description": "Adrar"
  },
  {
  "id": "Assaba",
  "description": "Assaba"
  },
  {
  "id": "Brakna",
  "description": "Brakna"
  },
  {
  "id": "Dakhlet Nouadhibou",
  "description": "Dakhlet Nouadhibou"
  },
  {
  "id": "Gorgol",
  "description": "Gorgol"
  },
  {
  "id": "Guidimaka",
  "description": "Guidimaka"
  },
  {
  "id": "Hodh Ech Chargi",
  "description": "Hodh Ech Chargi"
  },
  {
  "id": "Hodh El Gharbi",
  "description": "Hodh El Gharbi"
  },
  {
  "id": "Inchiri",
  "description": "Inchiri"
  },
  {
  "id": "Nouakchott Nord",
  "description": "Nouakchott Nord"
  },
  {
  "id": "Nouakchott Ouest",
  "description": "Nouakchott Ouest"
  },
  {
  "id": "Nouakchott Sud",
  "description": "Nouakchott Sud"
  },
  {
  "id": "Tagant",
  "description": "Tagant"
  },
  {
  "id": "Tiris Zemmour",
  "description": "Tiris Zemmour"
  },
  {
  "id": "Trarza",
  "description": "Trarza"
  }
  ]
  },
  {
  "code": "MU",
  "description": "Mauritius",
  "regions": [
  {
  "id": "Agalega Islands",
  "description": "Agalega Islands"
  },
  {
  "id": "Black River",
  "description": "Black River"
  },
  {
  "id": "Cargados Carajos",
  "description": "Cargados Carajos"
  },
  {
  "id": "Flacq",
  "description": "Flacq"
  },
  {
  "id": "Grand Port",
  "description": "Grand Port"
  },
  {
  "id": "Moka",
  "description": "Moka"
  },
  {
  "id": "Pamplemousses",
  "description": "Pamplemousses"
  },
  {
  "id": "Plaines Wilhems",
  "description": "Plaines Wilhems"
  },
  {
  "id": "Port Louis",
  "description": "Port Louis"
  },
  {
  "id": "Rivière du Rempart",
  "description": "Rivière du Rempart"
  },
  {
  "id": "Rodrigues",
  "description": "Rodrigues"
  },
  {
  "id": "Savanne",
  "description": "Savanne"
  }
  ]
  },
  {
  "code": "YT",
  "description": "Mayotte",
  "regions": [
  {
  "id": "Acoua",
  "description": "Acoua"
  },
  {
  "id": "Bandraboua",
  "description": "Bandraboua"
  },
  {
  "id": "Bandrele",
  "description": "Bandrele"
  },
  {
  "id": "Bouéni",
  "description": "Bouéni"
  },
  {
  "id": "Chiconi",
  "description": "Chiconi"
  },
  {
  "id": "Chirongui",
  "description": "Chirongui"
  },
  {
  "id": "Dembeni",
  "description": "Dembeni"
  },
  {
  "id": "Dzaoudzi",
  "description": "Dzaoudzi"
  },
  {
  "id": "Kani-Kéli",
  "description": "Kani-Kéli"
  },
  {
  "id": "Koungou",
  "description": "Koungou"
  },
  {
  "id": "Mamoudzou",
  "description": "Mamoudzou"
  },
  {
  "id": "Mtsamboro",
  "description": "Mtsamboro"
  },
  {
  "id": "M'Tsangamouji",
  "description": "M'Tsangamouji"
  },
  {
  "id": "Ouangani",
  "description": "Ouangani"
  },
  {
  "id": "Pamandzi",
  "description": "Pamandzi"
  },
  {
  "id": "Sada",
  "description": "Sada"
  },
  {
  "id": "Tsingoni",
  "description": "Tsingoni"
  }
  ]
  },
  {
  "code": "MX",
  "description": "Mexico",
  "regions": [
  {
  "id": "",
  "description": ""
  },
  {
  "id": "AGU",
  "description": "Aguascalientes"
  },
  {
  "id": "BCN",
  "description": "Baja California"
  },
  {
  "id": "BCS",
  "description": "Baja California Sur"
  },
  {
  "id": "CAM",
  "description": "Campeche"
  },
  {
  "id": "CHH",
  "description": "Chihuahua"
  },
  {
  "id": "CHP",
  "description": "Chiapas"
  },
  {
  "id": "CMX",
  "description": "Ciudad de México"
  },
  {
  "id": "COA",
  "description": "Coahuila"
  },
  {
  "id": "COL",
  "description": "Colima"
  },
  {
  "id": "DUR",
  "description": "Durango"
  },
  {
  "id": "GRO",
  "description": "Guerrero"
  },
  {
  "id": "GUA",
  "description": "Guanajuato"
  },
  {
  "id": "HID",
  "description": "Hidalgo"
  },
  {
  "id": "JAL",
  "description": "Jalisco"
  },
  {
  "id": "MEX",
  "description": "México"
  },
  {
  "id": "MIC",
  "description": "Michoacán"
  },
  {
  "id": "MOR",
  "description": "Morelos"
  },
  {
  "id": "NAY",
  "description": "Nayarit"
  },
  {
  "id": "NLE",
  "description": "Nuevo León"
  },
  {
  "id": "OAX",
  "description": "Oaxaca"
  },
  {
  "id": "PUE",
  "description": "Puebla"
  },
  {
  "id": "QUE",
  "description": "Querétaro"
  },
  {
  "id": "ROO",
  "description": "Quintana Roo"
  },
  {
  "id": "SIN",
  "description": "Sinaloa"
  },
  {
  "id": "SLP",
  "description": "San Luis Potosí"
  },
  {
  "id": "SON",
  "description": "Sonora"
  },
  {
  "id": "TAB",
  "description": "Tabasco"
  },
  {
  "id": "TAM",
  "description": "Tamaulipas"
  },
  {
  "id": "TLA",
  "description": "Tlaxcala"
  },
  {
  "id": "VER",
  "description": "Veracruz"
  },
  {
  "id": "YUC",
  "description": "Yucatán"
  },
  {
  "id": "ZAC",
  "description": "Zacatecas"
  }
  ]
  },
  {
  "code": "MD",
  "description": "Moldova",
  "regions": [
  {
  "id": "Anenii Noi",
  "description": "Anenii Noi"
  },
  {
  "id": "Bălţi",
  "description": "Bălţi"
  },
  {
  "id": "Basarabeasca",
  "description": "Basarabeasca"
  },
  {
  "id": "Bender Municipality",
  "description": "Bender Municipality"
  },
  {
  "id": "Briceni",
  "description": "Briceni"
  },
  {
  "id": "Cahul",
  "description": "Cahul"
  },
  {
  "id": "Călăraşi",
  "description": "Călăraşi"
  },
  {
  "id": "Cantemir",
  "description": "Cantemir"
  },
  {
  "id": "Căuşeni",
  "description": "Căuşeni"
  },
  {
  "id": "Chișinău Municipality",
  "description": "Chișinău Municipality"
  },
  {
  "id": "Cimişlia",
  "description": "Cimişlia"
  },
  {
  "id": "Criuleni",
  "description": "Criuleni"
  },
  {
  "id": "Donduşeni",
  "description": "Donduşeni"
  },
  {
  "id": "Drochia",
  "description": "Drochia"
  },
  {
  "id": "Dubăsari District",
  "description": "Dubăsari District"
  },
  {
  "id": "Fălești",
  "description": "Fălești"
  },
  {
  "id": "Floreşti",
  "description": "Floreşti"
  },
  {
  "id": "Gagauzia",
  "description": "Gagauzia"
  },
  {
  "id": "Glodeni",
  "description": "Glodeni"
  },
  {
  "id": "Hînceşti",
  "description": "Hînceşti"
  },
  {
  "id": "Ialoveni",
  "description": "Ialoveni"
  },
  {
  "id": "Leova",
  "description": "Leova"
  },
  {
  "id": "Nisporeni",
  "description": "Nisporeni"
  },
  {
  "id": "Orhei",
  "description": "Orhei"
  },
  {
  "id": "Raionul Edineţ",
  "description": "Raionul Edineţ"
  },
  {
  "id": "Raionul Ocniţa",
  "description": "Raionul Ocniţa"
  },
  {
  "id": "Rezina",
  "description": "Rezina"
  },
  {
  "id": "Rîşcani",
  "description": "Rîşcani"
  },
  {
  "id": "Sîngerei",
  "description": "Sîngerei"
  },
  {
  "id": "Şoldăneşti",
  "description": "Şoldăneşti"
  },
  {
  "id": "Soroca District",
  "description": "Soroca District"
  },
  {
  "id": "Ştefan-Vodă",
  "description": "Ştefan-Vodă"
  },
  {
  "id": "Strășeni",
  "description": "Strășeni"
  },
  {
  "id": "Taraclia",
  "description": "Taraclia"
  },
  {
  "id": "Teleneşti",
  "description": "Teleneşti"
  },
  {
  "id": "Transnistria",
  "description": "Transnistria"
  },
  {
  "id": "Ungheni",
  "description": "Ungheni"
  }
  ]
  },
  {
  "code": "MC",
  "description": "Monaco",
  "regions": [
  {
  "id": "Municipality of Monaco",
  "description": "Municipality of Monaco"
  }
  ]
  },
  {
  "code": "MN",
  "description": "Mongolia",
  "regions": [
  {
  "id": "Arkhangai Province",
  "description": "Arkhangai Province"
  },
  {
  "id": "Bayanhongor",
  "description": "Bayanhongor"
  },
  {
  "id": "Bayan-Ölgiy",
  "description": "Bayan-Ölgiy"
  },
  {
  "id": "Bulgan",
  "description": "Bulgan"
  },
  {
  "id": "Central Aimak",
  "description": "Central Aimak"
  },
  {
  "id": "Darhan Uul",
  "description": "Darhan Uul"
  },
  {
  "id": "Dzabkhan",
  "description": "Dzabkhan"
  },
  {
  "id": "East Aimak",
  "description": "East Aimak"
  },
  {
  "id": "East Gobi Aymag",
  "description": "East Gobi Aymag"
  },
  {
  "id": "Govi-Altai Province",
  "description": "Govi-Altai Province"
  },
  {
  "id": "Govĭ-Sumber",
  "description": "Govĭ-Sumber"
  },
  {
  "id": "Hentiy",
  "description": "Hentiy"
  },
  {
  "id": "Hovd",
  "description": "Hovd"
  },
  {
  "id": "Khövsgöl Province",
  "description": "Khövsgöl Province"
  },
  {
  "id": "Middle Govĭ",
  "description": "Middle Govĭ"
  },
  {
  "id": "Ömnögovĭ",
  "description": "Ömnögovĭ"
  },
  {
  "id": "Orhon",
  "description": "Orhon"
  },
  {
  "id": "Övörhangay",
  "description": "Övörhangay"
  },
  {
  "id": "Selenge Province",
  "description": "Selenge Province"
  },
  {
  "id": "Sühbaatar",
  "description": "Sühbaatar"
  },
  {
  "id": "Ulaanbaatar",
  "description": "Ulaanbaatar"
  },
  {
  "id": "Uvs Province",
  "description": "Uvs Province"
  }
  ]
  },
  {
  "code": "ME",
  "description": "Montenegro",
  "regions": [
  {
  "id": "Andrijevica",
  "description": "Andrijevica"
  },
  {
  "id": "Bar",
  "description": "Bar"
  },
  {
  "id": "Berane",
  "description": "Berane"
  },
  {
  "id": "Bijelo Polje",
  "description": "Bijelo Polje"
  },
  {
  "id": "Budva",
  "description": "Budva"
  },
  {
  "id": "Cetinje",
  "description": "Cetinje"
  },
  {
  "id": "Danilovgrad",
  "description": "Danilovgrad"
  },
  {
  "id": "Gusinje Municipality",
  "description": "Gusinje Municipality"
  },
  {
  "id": "Herceg Novi",
  "description": "Herceg Novi"
  },
  {
  "id": "Kotor",
  "description": "Kotor"
  },
  {
  "id": "Mojkovac",
  "description": "Mojkovac"
  },
  {
  "id": "Opština Kolašin",
  "description": "Opština Kolašin"
  },
  {
  "id": "Opština Nikšić",
  "description": "Opština Nikšić"
  },
  {
  "id": "Opština Plav",
  "description": "Opština Plav"
  },
  {
  "id": "Opština Plužine",
  "description": "Opština Plužine"
  },
  {
  "id": "Opština Šavnik",
  "description": "Opština Šavnik"
  },
  {
  "id": "Opština Žabljak",
  "description": "Opština Žabljak"
  },
  {
  "id": "Petnjica Municipality",
  "description": "Petnjica Municipality"
  },
  {
  "id": "Pljevlja",
  "description": "Pljevlja"
  },
  {
  "id": "Podgorica",
  "description": "Podgorica"
  },
  {
  "id": "Rožaje Municipality",
  "description": "Rožaje Municipality"
  },
  {
  "id": "Tivat",
  "description": "Tivat"
  },
  {
  "id": "Tuzi Municipality",
  "description": "Tuzi Municipality"
  },
  {
  "id": "Ulcinj",
  "description": "Ulcinj"
  },
  {
  "id": "Zeta",
  "description": "Zeta"
  }
  ]
  },
  {
  "code": "MS",
  "description": "Montserrat",
  "regions": [
  {
  "id": "Saint Anthony",
  "description": "Saint Anthony"
  },
  {
  "id": "Saint Georges",
  "description": "Saint Georges"
  },
  {
  "id": "Saint Peter",
  "description": "Saint Peter"
  }
  ]
  },
  {
  "code": "MA",
  "description": "Morocco",
  "regions": [
  {
  "id": "Béni Mellal-Khénifra",
  "description": "Béni Mellal-Khénifra"
  },
  {
  "id": "Casablanca-Settat",
  "description": "Casablanca-Settat"
  },
  {
  "id": "Dakhla-Oued Ed-Dahab",
  "description": "Dakhla-Oued Ed-Dahab"
  },
  {
  "id": "Drâa-Tafilalet",
  "description": "Drâa-Tafilalet"
  },
  {
  "id": "Fès-Meknès",
  "description": "Fès-Meknès"
  },
  {
  "id": "Guelmim-Oued Noun",
  "description": "Guelmim-Oued Noun"
  },
  {
  "id": "Laâyoune-Sakia El Hamra",
  "description": "Laâyoune-Sakia El Hamra"
  },
  {
  "id": "Marrakesh-Safi",
  "description": "Marrakesh-Safi"
  },
  {
  "id": "Oriental",
  "description": "Oriental"
  },
  {
  "id": "Rabat-Salé-Kénitra",
  "description": "Rabat-Salé-Kénitra"
  },
  {
  "id": "Souss-Massa",
  "description": "Souss-Massa"
  },
  {
  "id": "Tanger-Tetouan-Al Hoceima",
  "description": "Tanger-Tetouan-Al Hoceima"
  }
  ]
  },
  {
  "code": "MZ",
  "description": "Mozambique",
  "regions": [
  {
  "id": "Cabo Delgado Province",
  "description": "Cabo Delgado Province"
  },
  {
  "id": "Gaza Province",
  "description": "Gaza Province"
  },
  {
  "id": "Inhambane Province",
  "description": "Inhambane Province"
  },
  {
  "id": "Manica",
  "description": "Manica"
  },
  {
  "id": "Maputo City",
  "description": "Maputo City"
  },
  {
  "id": "Maputo Province",
  "description": "Maputo Province"
  },
  {
  "id": "Nampula",
  "description": "Nampula"
  },
  {
  "id": "Niassa Province",
  "description": "Niassa Province"
  },
  {
  "id": "Sofala",
  "description": "Sofala"
  },
  {
  "id": "Tete",
  "description": "Tete"
  },
  {
  "id": "Zambezia Province",
  "description": "Zambezia Province"
  }
  ]
  },
  {
  "code": "MM",
  "description": "Myanmar",
  "regions": [
  {
  "id": "Ayeyarwady",
  "description": "Ayeyarwady"
  },
  {
  "id": "Bago Region",
  "description": "Bago Region"
  },
  {
  "id": "Chin State",
  "description": "Chin State"
  },
  {
  "id": "Kachin State",
  "description": "Kachin State"
  },
  {
  "id": "Kayah State",
  "description": "Kayah State"
  },
  {
  "id": "Kayin State",
  "description": "Kayin State"
  },
  {
  "id": "Magway",
  "description": "Magway"
  },
  {
  "id": "Mandalay Region",
  "description": "Mandalay Region"
  },
  {
  "id": "Mon",
  "description": "Mon"
  },
  {
  "id": "Nay Pyi Taw",
  "description": "Nay Pyi Taw"
  },
  {
  "id": "Rakhine",
  "description": "Rakhine"
  },
  {
  "id": "Sagaing Region",
  "description": "Sagaing Region"
  },
  {
  "id": "Shan State",
  "description": "Shan State"
  },
  {
  "id": "Tanintharyi Region",
  "description": "Tanintharyi Region"
  },
  {
  "id": "Yangon",
  "description": "Yangon"
  }
  ]
  },
  {
  "code": "NA",
  "description": "Namibia",
  "regions": [
  {
  "id": "Erongo Region",
  "description": "Erongo Region"
  },
  {
  "id": "Hardap Region",
  "description": "Hardap Region"
  },
  {
  "id": "Karas Region",
  "description": "Karas Region"
  },
  {
  "id": "Kavango East",
  "description": "Kavango East"
  },
  {
  "id": "Kavango West",
  "description": "Kavango West"
  },
  {
  "id": "Khomas Region",
  "description": "Khomas Region"
  },
  {
  "id": "Kunene Region",
  "description": "Kunene Region"
  },
  {
  "id": "Ohangwena Region",
  "description": "Ohangwena Region"
  },
  {
  "id": "Omaheke Region",
  "description": "Omaheke Region"
  },
  {
  "id": "Omusati Region",
  "description": "Omusati Region"
  },
  {
  "id": "Oshana Region",
  "description": "Oshana Region"
  },
  {
  "id": "Oshikoto Region",
  "description": "Oshikoto Region"
  },
  {
  "id": "Otjozondjupa Region",
  "description": "Otjozondjupa Region"
  },
  {
  "id": "Zambezi Region",
  "description": "Zambezi Region"
  }
  ]
  },
  {
  "code": "NR",
  "description": "Nauru",
  "regions": [
  {
  "id": "Aiwo District",
  "description": "Aiwo District"
  },
  {
  "id": "Anabar District",
  "description": "Anabar District"
  },
  {
  "id": "Anetan District",
  "description": "Anetan District"
  },
  {
  "id": "Anibare District",
  "description": "Anibare District"
  },
  {
  "id": "Baiti District",
  "description": "Baiti District"
  },
  {
  "id": "Boe District",
  "description": "Boe District"
  },
  {
  "id": "Buada District",
  "description": "Buada District"
  },
  {
  "id": "Denigomodu District",
  "description": "Denigomodu District"
  },
  {
  "id": "Ewa District",
  "description": "Ewa District"
  },
  {
  "id": "Ijuw District",
  "description": "Ijuw District"
  },
  {
  "id": "Meneng District",
  "description": "Meneng District"
  },
  {
  "id": "Nibok District",
  "description": "Nibok District"
  },
  {
  "id": "Uaboe District",
  "description": "Uaboe District"
  },
  {
  "id": "Yaren District",
  "description": "Yaren District"
  }
  ]
  },
  {
  "code": "NP",
  "description": "Nepal",
  "regions": [
  {
  "id": "Bagmati Province",
  "description": "Bagmati Province"
  },
  {
  "id": "Central Region",
  "description": "Central Region"
  },
  {
  "id": "Eastern Region",
  "description": "Eastern Region"
  },
  {
  "id": "Far Western",
  "description": "Far Western"
  },
  {
  "id": "Karnali Pradesh",
  "description": "Karnali Pradesh"
  },
  {
  "id": "Koshi",
  "description": "Koshi"
  },
  {
  "id": "Lumbini Province",
  "description": "Lumbini Province"
  },
  {
  "id": "Madhesh",
  "description": "Madhesh"
  },
  {
  "id": "Mid Western",
  "description": "Mid Western"
  },
  {
  "id": "Patheka",
  "description": "Patheka"
  },
  {
  "id": "Province 4",
  "description": "Province 4"
  },
  {
  "id": "Sudurpashchim Pradesh",
  "description": "Sudurpashchim Pradesh"
  },
  {
  "id": "Western Region",
  "description": "Western Region"
  }
  ]
  },
  {
  "code": "NL",
  "description": "Netherlands",
  "regions": [
  {
  "id": "Drenthe",
  "description": "Drenthe"
  },
  {
  "id": "Flevoland",
  "description": "Flevoland"
  },
  {
  "id": "Friesland",
  "description": "Friesland"
  },
  {
  "id": "Gelderland",
  "description": "Gelderland"
  },
  {
  "id": "Groningen",
  "description": "Groningen"
  },
  {
  "id": "Limburg",
  "description": "Limburg"
  },
  {
  "id": "North Brabant",
  "description": "North Brabant"
  },
  {
  "id": "North Holland",
  "description": "North Holland"
  },
  {
  "id": "Overijssel",
  "description": "Overijssel"
  },
  {
  "id": "South Holland",
  "description": "South Holland"
  },
  {
  "id": "Utrecht",
  "description": "Utrecht"
  },
  {
  "id": "Zeeland",
  "description": "Zeeland"
  }
  ]
  },
  {
  "code": "AN",
  "description": "Netherlands Antilles",
  "regions": []
  },
  {
  "code": "NC",
  "description": "New Caledonia",
  "regions": [
  {
  "id": "Loyalty Islands",
  "description": "Loyalty Islands"
  },
  {
  "id": "North Province",
  "description": "North Province"
  },
  {
  "id": "South Province",
  "description": "South Province"
  }
  ]
  },
  {
  "code": "NZ",
  "description": "New Zealand (Aotearoa)",
  "regions": [
  {
  "id": "Auckland",
  "description": "Auckland"
  },
  {
  "id": "Bay of Plenty",
  "description": "Bay of Plenty"
  },
  {
  "id": "Canterbury",
  "description": "Canterbury"
  },
  {
  "id": "Chatham Islands",
  "description": "Chatham Islands"
  },
  {
  "id": "Gisborne",
  "description": "Gisborne"
  },
  {
  "id": "Hawke's Bay Region",
  "description": "Hawke's Bay Region"
  },
  {
  "id": "Manawatu-Wanganui",
  "description": "Manawatu-Wanganui"
  },
  {
  "id": "Marlborough",
  "description": "Marlborough"
  },
  {
  "id": "Nelson Region",
  "description": "Nelson Region"
  },
  {
  "id": "Northland",
  "description": "Northland"
  },
  {
  "id": "Otago",
  "description": "Otago"
  },
  {
  "id": "Southland",
  "description": "Southland"
  },
  {
  "id": "Taranaki Region",
  "description": "Taranaki Region"
  },
  {
  "id": "Tasman District",
  "description": "Tasman District"
  },
  {
  "id": "Waikato Region",
  "description": "Waikato Region"
  },
  {
  "id": "Wellington Region",
  "description": "Wellington Region"
  },
  {
  "id": "West Coast",
  "description": "West Coast"
  }
  ]
  },
  {
  "code": "NI",
  "description": "Nicaragua",
  "regions": [
  {
  "id": "Boaco Department",
  "description": "Boaco Department"
  },
  {
  "id": "Carazo Department",
  "description": "Carazo Department"
  },
  {
  "id": "Chinandega Department",
  "description": "Chinandega Department"
  },
  {
  "id": "Chontales Department",
  "description": "Chontales Department"
  },
  {
  "id": "Estelí Department",
  "description": "Estelí Department"
  },
  {
  "id": "Granada Department",
  "description": "Granada Department"
  },
  {
  "id": "Jinotega Department",
  "description": "Jinotega Department"
  },
  {
  "id": "León Department",
  "description": "León Department"
  },
  {
  "id": "Madriz Department",
  "description": "Madriz Department"
  },
  {
  "id": "Managua Department",
  "description": "Managua Department"
  },
  {
  "id": "Masaya Department",
  "description": "Masaya Department"
  },
  {
  "id": "Matagalpa Department",
  "description": "Matagalpa Department"
  },
  {
  "id": "North Caribbean Coast",
  "description": "North Caribbean Coast"
  },
  {
  "id": "Nueva Segovia Department",
  "description": "Nueva Segovia Department"
  },
  {
  "id": "Río San Juan Department",
  "description": "Río San Juan Department"
  },
  {
  "id": "Rivas Department",
  "description": "Rivas Department"
  },
  {
  "id": "South Caribbean Coast",
  "description": "South Caribbean Coast"
  }
  ]
  },
  {
  "code": "NE",
  "description": "Niger",
  "regions": [
  {
  "id": "Agadez",
  "description": "Agadez"
  },
  {
  "id": "Diffa",
  "description": "Diffa"
  },
  {
  "id": "Dosso Region",
  "description": "Dosso Region"
  },
  {
  "id": "Maradi Region",
  "description": "Maradi Region"
  },
  {
  "id": "Niamey",
  "description": "Niamey"
  },
  {
  "id": "Tahoua Region",
  "description": "Tahoua Region"
  },
  {
  "id": "Tillabéri Region",
  "description": "Tillabéri Region"
  },
  {
  "id": "Zinder Region",
  "description": "Zinder Region"
  }
  ]
  },
  {
  "code": "NG",
  "description": "Nigeria",
  "regions": [
  {
  "id": "Abia State",
  "description": "Abia State"
  },
  {
  "id": "Adamawa",
  "description": "Adamawa"
  },
  {
  "id": "Akwa Ibom State",
  "description": "Akwa Ibom State"
  },
  {
  "id": "Anambra",
  "description": "Anambra"
  },
  {
  "id": "Bauchi",
  "description": "Bauchi"
  },
  {
  "id": "Bayelsa State",
  "description": "Bayelsa State"
  },
  {
  "id": "Benue State",
  "description": "Benue State"
  },
  {
  "id": "Borno State",
  "description": "Borno State"
  },
  {
  "id": "Cross River State",
  "description": "Cross River State"
  },
  {
  "id": "Delta",
  "description": "Delta"
  },
  {
  "id": "Ebonyi State",
  "description": "Ebonyi State"
  },
  {
  "id": "Edo State",
  "description": "Edo State"
  },
  {
  "id": "Ekiti State",
  "description": "Ekiti State"
  },
  {
  "id": "Enugu State",
  "description": "Enugu State"
  },
  {
  "id": "FCT",
  "description": "FCT"
  },
  {
  "id": "Gombe State",
  "description": "Gombe State"
  },
  {
  "id": "Imo State",
  "description": "Imo State"
  },
  {
  "id": "Jigawa State",
  "description": "Jigawa State"
  },
  {
  "id": "Kaduna State",
  "description": "Kaduna State"
  },
  {
  "id": "Kano State",
  "description": "Kano State"
  },
  {
  "id": "Katsina State",
  "description": "Katsina State"
  },
  {
  "id": "Kebbi",
  "description": "Kebbi"
  },
  {
  "id": "Kogi State",
  "description": "Kogi State"
  },
  {
  "id": "Kwara State",
  "description": "Kwara State"
  },
  {
  "id": "Lagos",
  "description": "Lagos"
  },
  {
  "id": "Nasarawa State",
  "description": "Nasarawa State"
  },
  {
  "id": "Niger State",
  "description": "Niger State"
  },
  {
  "id": "Ogun State",
  "description": "Ogun State"
  },
  {
  "id": "Ondo State",
  "description": "Ondo State"
  },
  {
  "id": "Osun State",
  "description": "Osun State"
  },
  {
  "id": "Oyo State",
  "description": "Oyo State"
  },
  {
  "id": "Plateau State",
  "description": "Plateau State"
  },
  {
  "id": "Rivers State",
  "description": "Rivers State"
  },
  {
  "id": "Sokoto",
  "description": "Sokoto"
  },
  {
  "id": "Taraba State",
  "description": "Taraba State"
  },
  {
  "id": "Yobe State",
  "description": "Yobe State"
  },
  {
  "id": "Zamfara State",
  "description": "Zamfara State"
  }
  ]
  },
  {
  "code": "NU",
  "description": "Niue",
  "regions": []
  },
  {
  "code": "KP",
  "description": "North Korea",
  "regions": [
  {
  "id": "Chagang",
  "description": "Chagang"
  },
  {
  "id": "Kaesong",
  "description": "Kaesong"
  },
  {
  "id": "Kangwŏn-do",
  "description": "Kangwŏn-do"
  },
  {
  "id": "Nampo",
  "description": "Nampo"
  },
  {
  "id": "North Hamgyong",
  "description": "North Hamgyong"
  },
  {
  "id": "North Hwanghae",
  "description": "North Hwanghae"
  },
  {
  "id": "P'yŏngan-bukto",
  "description": "P'yŏngan-bukto"
  },
  {
  "id": "Pyongyang",
  "description": "Pyongyang"
  },
  {
  "id": "Rason",
  "description": "Rason"
  },
  {
  "id": "South Hamgyong",
  "description": "South Hamgyong"
  },
  {
  "id": "South Hwanghae",
  "description": "South Hwanghae"
  },
  {
  "id": "South Pyongan",
  "description": "South Pyongan"
  },
  {
  "id": "Yanggang-do",
  "description": "Yanggang-do"
  }
  ]
  },
  {
  "code": "MP",
  "description": "Northern Mariana Islands",
  "regions": [
  {
  "id": "Northern Islands",
  "description": "Northern Islands"
  },
  {
  "id": "Rota",
  "description": "Rota"
  },
  {
  "id": "Saipan",
  "description": "Saipan"
  },
  {
  "id": "Tinian",
  "description": "Tinian"
  }
  ]
  },
  {
  "code": "NO",
  "description": "Norway",
  "regions": [
  {
  "id": "Agder",
  "description": "Agder"
  },
  {
  "id": "Akershus",
  "description": "Akershus"
  },
  {
  "id": "Aust-Agder",
  "description": "Aust-Agder"
  },
  {
  "id": "Buskerud",
  "description": "Buskerud"
  },
  {
  "id": "Finnmark",
  "description": "Finnmark"
  },
  {
  "id": "Hedmark",
  "description": "Hedmark"
  },
  {
  "id": "Hordaland",
  "description": "Hordaland"
  },
  {
  "id": "Innlandet",
  "description": "Innlandet"
  },
  {
  "id": "Møre og Romsdal",
  "description": "Møre og Romsdal"
  },
  {
  "id": "Nordland",
  "description": "Nordland"
  },
  {
  "id": "Nord-Trøndelag",
  "description": "Nord-Trøndelag"
  },
  {
  "id": "Oppland",
  "description": "Oppland"
  },
  {
  "id": "Oslo",
  "description": "Oslo"
  },
  {
  "id": "Østfold",
  "description": "Østfold"
  },
  {
  "id": "Rogaland",
  "description": "Rogaland"
  },
  {
  "id": "Sogn og Fjordane",
  "description": "Sogn og Fjordane"
  },
  {
  "id": "Sør-Trøndelag",
  "description": "Sør-Trøndelag"
  },
  {
  "id": "Telemark",
  "description": "Telemark"
  },
  {
  "id": "Troms",
  "description": "Troms"
  },
  {
  "id": "Trøndelag",
  "description": "Trøndelag"
  },
  {
  "id": "Vest-Agder",
  "description": "Vest-Agder"
  },
  {
  "id": "Vestfold",
  "description": "Vestfold"
  },
  {
  "id": "Vestland",
  "description": "Vestland"
  }
  ]
  },
  {
  "code": "OM",
  "description": "Oman",
  "regions": [
  {
  "id": "Ad Dakhiliyah",
  "description": "Ad Dakhiliyah"
  },
  {
  "id": "Ad Dhahirah",
  "description": "Ad Dhahirah"
  },
  {
  "id": "Al Batinah North",
  "description": "Al Batinah North"
  },
  {
  "id": "Al Batinah South",
  "description": "Al Batinah South"
  },
  {
  "id": "Al Buraimi",
  "description": "Al Buraimi"
  },
  {
  "id": "Al Wusta Governorate",
  "description": "Al Wusta Governorate"
  },
  {
  "id": "Dhofar",
  "description": "Dhofar"
  },
  {
  "id": "Musandam Governorate",
  "description": "Musandam Governorate"
  },
  {
  "id": "Muscat",
  "description": "Muscat"
  },
  {
  "id": "Northeastern Governorate",
  "description": "Northeastern Governorate"
  },
  {
  "id": "Southeastern Governorate",
  "description": "Southeastern Governorate"
  }
  ]
  },
  {
  "code": "PK",
  "description": "Pakistan",
  "regions": [
  {
  "id": "Azad Kashmir",
  "description": "Azad Kashmir"
  },
  {
  "id": "Balochistan",
  "description": "Balochistan"
  },
  {
  "id": "FATA",
  "description": "FATA"
  },
  {
  "id": "Gilgit-Baltistan",
  "description": "Gilgit-Baltistan"
  },
  {
  "id": "Islamabad",
  "description": "Islamabad"
  },
  {
  "id": "Khyber Pakhtunkhwa",
  "description": "Khyber Pakhtunkhwa"
  },
  {
  "id": "Punjab",
  "description": "Punjab"
  },
  {
  "id": "Sindh",
  "description": "Sindh"
  }
  ]
  },
  {
  "code": "PW",
  "description": "Palau",
  "regions": [
  {
  "id": "Aimeliik",
  "description": "Aimeliik"
  },
  {
  "id": "Airai",
  "description": "Airai"
  },
  {
  "id": "Angaur",
  "description": "Angaur"
  },
  {
  "id": "Hatohobei",
  "description": "Hatohobei"
  },
  {
  "id": "Kayangel",
  "description": "Kayangel"
  },
  {
  "id": "Koror",
  "description": "Koror"
  },
  {
  "id": "Melekeok",
  "description": "Melekeok"
  },
  {
  "id": "Ngaraard",
  "description": "Ngaraard"
  },
  {
  "id": "Ngarchelong",
  "description": "Ngarchelong"
  },
  {
  "id": "Ngardmau",
  "description": "Ngardmau"
  },
  {
  "id": "Ngatpang",
  "description": "Ngatpang"
  },
  {
  "id": "Ngchesar",
  "description": "Ngchesar"
  },
  {
  "id": "Ngeremlengui",
  "description": "Ngeremlengui"
  },
  {
  "id": "Ngiwal",
  "description": "Ngiwal"
  },
  {
  "id": "Peleliu",
  "description": "Peleliu"
  },
  {
  "id": "Sonsorol",
  "description": "Sonsorol"
  }
  ]
  },
  {
  "code": "PA",
  "description": "Panama",
  "regions": [
  {
  "id": "Bocas del Toro Province",
  "description": "Bocas del Toro Province"
  },
  {
  "id": "Chiriquí Province",
  "description": "Chiriquí Province"
  },
  {
  "id": "Coclé",
  "description": "Coclé"
  },
  {
  "id": "Colón",
  "description": "Colón"
  },
  {
  "id": "Darién",
  "description": "Darién"
  },
  {
  "id": "Emberá",
  "description": "Emberá"
  },
  {
  "id": "Guna Yala",
  "description": "Guna Yala"
  },
  {
  "id": "Herrera Province",
  "description": "Herrera Province"
  },
  {
  "id": "Los Santos Province",
  "description": "Los Santos Province"
  },
  {
  "id": "Naso Tjër Di",
  "description": "Naso Tjër Di"
  },
  {
  "id": "Ngöbe-Buglé Comarca",
  "description": "Ngöbe-Buglé Comarca"
  },
  {
  "id": "Panamá",
  "description": "Panamá"
  },
  {
  "id": "Panamá Oeste Province",
  "description": "Panamá Oeste Province"
  },
  {
  "id": "Veraguas Province",
  "description": "Veraguas Province"
  }
  ]
  },
  {
  "code": "PG",
  "description": "Papua New Guinea",
  "regions": [
  {
  "id": "Bougainville",
  "description": "Bougainville"
  },
  {
  "id": "Central Province",
  "description": "Central Province"
  },
  {
  "id": "Chimbu Province",
  "description": "Chimbu Province"
  },
  {
  "id": "Eastern Highlands Province",
  "description": "Eastern Highlands Province"
  },
  {
  "id": "East New Britain Province",
  "description": "East New Britain Province"
  },
  {
  "id": "East Sepik Province",
  "description": "East Sepik Province"
  },
  {
  "id": "Enga Province",
  "description": "Enga Province"
  },
  {
  "id": "Gulf Province",
  "description": "Gulf Province"
  },
  {
  "id": "Hela Province",
  "description": "Hela Province"
  },
  {
  "id": "Jiwaka Province",
  "description": "Jiwaka Province"
  },
  {
  "id": "Madang Province",
  "description": "Madang Province"
  },
  {
  "id": "Manus Province",
  "description": "Manus Province"
  },
  {
  "id": "Milne Bay Province",
  "description": "Milne Bay Province"
  },
  {
  "id": "Morobe Province",
  "description": "Morobe Province"
  },
  {
  "id": "National Capital",
  "description": "National Capital"
  },
  {
  "id": "New Ireland",
  "description": "New Ireland"
  },
  {
  "id": "Oro Province",
  "description": "Oro Province"
  },
  {
  "id": "Sandaun Province",
  "description": "Sandaun Province"
  },
  {
  "id": "Southern Highlands Province",
  "description": "Southern Highlands Province"
  },
  {
  "id": "Western Highlands Province",
  "description": "Western Highlands Province"
  },
  {
  "id": "Western Province",
  "description": "Western Province"
  },
  {
  "id": "West New Britain Province",
  "description": "West New Britain Province"
  }
  ]
  },
  {
  "code": "PY",
  "description": "Paraguay",
  "regions": [
  {
  "id": "Alto Paraguay",
  "description": "Alto Paraguay"
  },
  {
  "id": "Alto Paraná",
  "description": "Alto Paraná"
  },
  {
  "id": "Amambay Department",
  "description": "Amambay Department"
  },
  {
  "id": "Asunción",
  "description": "Asunción"
  },
  {
  "id": "Boquerón",
  "description": "Boquerón"
  },
  {
  "id": "Caaguazú",
  "description": "Caaguazú"
  },
  {
  "id": "Caazapá",
  "description": "Caazapá"
  },
  {
  "id": "Canindeyú",
  "description": "Canindeyú"
  },
  {
  "id": "Central Department",
  "description": "Central Department"
  },
  {
  "id": "Concepción",
  "description": "Concepción"
  },
  {
  "id": "Cordillera Department",
  "description": "Cordillera Department"
  },
  {
  "id": "Guairá",
  "description": "Guairá"
  },
  {
  "id": "Itapúa",
  "description": "Itapúa"
  },
  {
  "id": "Misiones Department",
  "description": "Misiones Department"
  },
  {
  "id": "Ñeembucú",
  "description": "Ñeembucú"
  },
  {
  "id": "Paraguarí",
  "description": "Paraguarí"
  },
  {
  "id": "Presidente Hayes",
  "description": "Presidente Hayes"
  },
  {
  "id": "San Pedro Department",
  "description": "San Pedro Department"
  }
  ]
  },
  {
  "code": "PE",
  "description": "Peru",
  "regions": [
  {
  "id": "Amazonas",
  "description": "Amazonas"
  },
  {
  "id": "Ancash",
  "description": "Ancash"
  },
  {
  "id": "Apurímac Department",
  "description": "Apurímac Department"
  },
  {
  "id": "Arequipa",
  "description": "Arequipa"
  },
  {
  "id": "Ayacucho",
  "description": "Ayacucho"
  },
  {
  "id": "Cajamarca Department",
  "description": "Cajamarca Department"
  },
  {
  "id": "Callao",
  "description": "Callao"
  },
  {
  "id": "Cuzco Department",
  "description": "Cuzco Department"
  },
  {
  "id": "Huancavelica",
  "description": "Huancavelica"
  },
  {
  "id": "Huánuco Department",
  "description": "Huánuco Department"
  },
  {
  "id": "Ica",
  "description": "Ica"
  },
  {
  "id": "Junin",
  "description": "Junin"
  },
  {
  "id": "La Libertad",
  "description": "La Libertad"
  },
  {
  "id": "Lambayeque",
  "description": "Lambayeque"
  },
  {
  "id": "Lima Province",
  "description": "Lima Province"
  },
  {
  "id": "Lima region",
  "description": "Lima region"
  },
  {
  "id": "Loreto",
  "description": "Loreto"
  },
  {
  "id": "Madre de Dios",
  "description": "Madre de Dios"
  },
  {
  "id": "Moquegua Department",
  "description": "Moquegua Department"
  },
  {
  "id": "Pasco",
  "description": "Pasco"
  },
  {
  "id": "Piura",
  "description": "Piura"
  },
  {
  "id": "Puno",
  "description": "Puno"
  },
  {
  "id": "San Martín Department",
  "description": "San Martín Department"
  },
  {
  "id": "Tacna",
  "description": "Tacna"
  },
  {
  "id": "Tumbes",
  "description": "Tumbes"
  },
  {
  "id": "Ucayali",
  "description": "Ucayali"
  }
  ]
  },
  {
  "code": "PH",
  "description": "Philippines",
  "regions": [
  {
  "id": "Autonomous Region in Muslim Mindanao",
  "description": "Autonomous Region in Muslim Mindanao"
  },
  {
  "id": "Bicol Region",
  "description": "Bicol Region"
  },
  {
  "id": "Cagayan Valley",
  "description": "Cagayan Valley"
  },
  {
  "id": "Calabarzon",
  "description": "Calabarzon"
  },
  {
  "id": "Caraga",
  "description": "Caraga"
  },
  {
  "id": "Central Luzon",
  "description": "Central Luzon"
  },
  {
  "id": "Central Visayas",
  "description": "Central Visayas"
  },
  {
  "id": "Cordillera",
  "description": "Cordillera"
  },
  {
  "id": "Davao Region",
  "description": "Davao Region"
  },
  {
  "id": "Eastern Visayas",
  "description": "Eastern Visayas"
  },
  {
  "id": "Ilocos",
  "description": "Ilocos"
  },
  {
  "id": "Metro Manila",
  "description": "Metro Manila"
  },
  {
  "id": "Mimaropa",
  "description": "Mimaropa"
  },
  {
  "id": "Negros Island Region",
  "description": "Negros Island Region"
  },
  {
  "id": "Northern Mindanao",
  "description": "Northern Mindanao"
  },
  {
  "id": "Soccsksargen",
  "description": "Soccsksargen"
  },
  {
  "id": "Western Visayas",
  "description": "Western Visayas"
  },
  {
  "id": "Zamboanga Peninsula",
  "description": "Zamboanga Peninsula"
  }
  ]
  },
  {
  "code": "PL",
  "description": "Poland",
  "regions": [
  {
  "id": "Greater Poland",
  "description": "Greater Poland"
  },
  {
  "id": "Kujawsko-Pomorskie",
  "description": "Kujawsko-Pomorskie"
  },
  {
  "id": "Lesser Poland",
  "description": "Lesser Poland"
  },
  {
  "id": "Łódź Voivodeship",
  "description": "Łódź Voivodeship"
  },
  {
  "id": "Lower Silesia",
  "description": "Lower Silesia"
  },
  {
  "id": "Lublin",
  "description": "Lublin"
  },
  {
  "id": "Lubusz",
  "description": "Lubusz"
  },
  {
  "id": "Mazovia",
  "description": "Mazovia"
  },
  {
  "id": "Opole Voivodeship",
  "description": "Opole Voivodeship"
  },
  {
  "id": "Podlasie",
  "description": "Podlasie"
  },
  {
  "id": "Pomerania",
  "description": "Pomerania"
  },
  {
  "id": "Silesia",
  "description": "Silesia"
  },
  {
  "id": "Subcarpathia",
  "description": "Subcarpathia"
  },
  {
  "id": "Świętokrzyskie",
  "description": "Świętokrzyskie"
  },
  {
  "id": "Warmia-Masuria",
  "description": "Warmia-Masuria"
  },
  {
  "id": "West Pomerania",
  "description": "West Pomerania"
  }
  ]
  },
  {
  "code": "PT",
  "description": "Portugal",
  "regions": [
  {
  "id": "Aveiro",
  "description": "Aveiro"
  },
  {
  "id": "Azores",
  "description": "Azores"
  },
  {
  "id": "Beja",
  "description": "Beja"
  },
  {
  "id": "Braga",
  "description": "Braga"
  },
  {
  "id": "Bragança",
  "description": "Bragança"
  },
  {
  "id": "Castelo Branco",
  "description": "Castelo Branco"
  },
  {
  "id": "Coimbra",
  "description": "Coimbra"
  },
  {
  "id": "Évora",
  "description": "Évora"
  },
  {
  "id": "Faro",
  "description": "Faro"
  },
  {
  "id": "Guarda",
  "description": "Guarda"
  },
  {
  "id": "Leiria",
  "description": "Leiria"
  },
  {
  "id": "Lisbon",
  "description": "Lisbon"
  },
  {
  "id": "Madeira",
  "description": "Madeira"
  },
  {
  "id": "Portalegre",
  "description": "Portalegre"
  },
  {
  "id": "Porto",
  "description": "Porto"
  },
  {
  "id": "Santarém",
  "description": "Santarém"
  },
  {
  "id": "Setúbal",
  "description": "Setúbal"
  },
  {
  "id": "Viana do Castelo",
  "description": "Viana do Castelo"
  },
  {
  "id": "Vila Real",
  "description": "Vila Real"
  },
  {
  "id": "Viseu",
  "description": "Viseu"
  }
  ]
  },
  {
  "code": "PR",
  "description": "Puerto Rico",
  "regions": [
  {
  "id": "Adjuntas",
  "description": "Adjuntas"
  },
  {
  "id": "Aguada",
  "description": "Aguada"
  },
  {
  "id": "Aguadilla",
  "description": "Aguadilla"
  },
  {
  "id": "Aguas Buenas",
  "description": "Aguas Buenas"
  },
  {
  "id": "Aibonito",
  "description": "Aibonito"
  },
  {
  "id": "Añasco",
  "description": "Añasco"
  },
  {
  "id": "Arecibo",
  "description": "Arecibo"
  },
  {
  "id": "Arroyo",
  "description": "Arroyo"
  },
  {
  "id": "Barceloneta",
  "description": "Barceloneta"
  },
  {
  "id": "Barranquitas",
  "description": "Barranquitas"
  },
  {
  "id": "Bayamón",
  "description": "Bayamón"
  },
  {
  "id": "Cabo Rojo",
  "description": "Cabo Rojo"
  },
  {
  "id": "Caguas",
  "description": "Caguas"
  },
  {
  "id": "Camuy",
  "description": "Camuy"
  },
  {
  "id": "Canóvanas",
  "description": "Canóvanas"
  },
  {
  "id": "Carolina",
  "description": "Carolina"
  },
  {
  "id": "Cataño",
  "description": "Cataño"
  },
  {
  "id": "Cayey",
  "description": "Cayey"
  },
  {
  "id": "Ceiba",
  "description": "Ceiba"
  },
  {
  "id": "Ciales",
  "description": "Ciales"
  },
  {
  "id": "Cidra",
  "description": "Cidra"
  },
  {
  "id": "Coamo",
  "description": "Coamo"
  },
  {
  "id": "Comerío",
  "description": "Comerío"
  },
  {
  "id": "Corozal",
  "description": "Corozal"
  },
  {
  "id": "Culebra",
  "description": "Culebra"
  },
  {
  "id": "Dorado",
  "description": "Dorado"
  },
  {
  "id": "Fajardo",
  "description": "Fajardo"
  },
  {
  "id": "Florida",
  "description": "Florida"
  },
  {
  "id": "Guánica",
  "description": "Guánica"
  },
  {
  "id": "Guayama",
  "description": "Guayama"
  },
  {
  "id": "Guayanilla",
  "description": "Guayanilla"
  },
  {
  "id": "Guaynabo",
  "description": "Guaynabo"
  },
  {
  "id": "Gurabo",
  "description": "Gurabo"
  },
  {
  "id": "Hatillo",
  "description": "Hatillo"
  },
  {
  "id": "Hormigueros",
  "description": "Hormigueros"
  },
  {
  "id": "Humacao",
  "description": "Humacao"
  },
  {
  "id": "Isabela",
  "description": "Isabela"
  },
  {
  "id": "Jayuya",
  "description": "Jayuya"
  },
  {
  "id": "Juana Díaz",
  "description": "Juana Díaz"
  },
  {
  "id": "Juncos",
  "description": "Juncos"
  },
  {
  "id": "Lajas",
  "description": "Lajas"
  },
  {
  "id": "Lares",
  "description": "Lares"
  },
  {
  "id": "Las Marías",
  "description": "Las Marías"
  },
  {
  "id": "Las Piedras",
  "description": "Las Piedras"
  },
  {
  "id": "Loíza",
  "description": "Loíza"
  },
  {
  "id": "Luquillo",
  "description": "Luquillo"
  },
  {
  "id": "Manatí",
  "description": "Manatí"
  },
  {
  "id": "Maricao",
  "description": "Maricao"
  },
  {
  "id": "Maunabo",
  "description": "Maunabo"
  },
  {
  "id": "Mayagüez",
  "description": "Mayagüez"
  },
  {
  "id": "Moca",
  "description": "Moca"
  },
  {
  "id": "Morovis",
  "description": "Morovis"
  },
  {
  "id": "Naguabo",
  "description": "Naguabo"
  },
  {
  "id": "Naranjito",
  "description": "Naranjito"
  },
  {
  "id": "Orocovis",
  "description": "Orocovis"
  },
  {
  "id": "Patillas",
  "description": "Patillas"
  },
  {
  "id": "Peñuelas",
  "description": "Peñuelas"
  },
  {
  "id": "Ponce",
  "description": "Ponce"
  },
  {
  "id": "Quebradillas",
  "description": "Quebradillas"
  },
  {
  "id": "Rincón",
  "description": "Rincón"
  },
  {
  "id": "Río Grande",
  "description": "Río Grande"
  },
  {
  "id": "Sabana Grande",
  "description": "Sabana Grande"
  },
  {
  "id": "Salinas",
  "description": "Salinas"
  },
  {
  "id": "San Germán",
  "description": "San Germán"
  },
  {
  "id": "San Juan",
  "description": "San Juan"
  },
  {
  "id": "San Lorenzo",
  "description": "San Lorenzo"
  },
  {
  "id": "San Sebastián",
  "description": "San Sebastián"
  },
  {
  "id": "Santa Isabel",
  "description": "Santa Isabel"
  },
  {
  "id": "Toa Alta",
  "description": "Toa Alta"
  },
  {
  "id": "Toa Baja",
  "description": "Toa Baja"
  },
  {
  "id": "Trujillo Alto",
  "description": "Trujillo Alto"
  },
  {
  "id": "Utuado",
  "description": "Utuado"
  },
  {
  "id": "Vega Alta",
  "description": "Vega Alta"
  },
  {
  "id": "Vega Baja",
  "description": "Vega Baja"
  },
  {
  "id": "Vieques",
  "description": "Vieques"
  },
  {
  "id": "Villalba",
  "description": "Villalba"
  },
  {
  "id": "Yabucoa",
  "description": "Yabucoa"
  },
  {
  "id": "Yauco",
  "description": "Yauco"
  }
  ]
  },
  {
  "code": "QA",
  "description": "Qatar",
  "regions": [
  {
  "id": "Al Daayen",
  "description": "Al Daayen"
  },
  {
  "id": "Al Khor",
  "description": "Al Khor"
  },
  {
  "id": "Al-Shahaniya",
  "description": "Al-Shahaniya"
  },
  {
  "id": "Al Wakrah",
  "description": "Al Wakrah"
  },
  {
  "id": "Baladīyat ad Dawḩah",
  "description": "Baladīyat ad Dawḩah"
  },
  {
  "id": "Baladīyat ar Rayyān",
  "description": "Baladīyat ar Rayyān"
  },
  {
  "id": "Madīnat ash Shamāl",
  "description": "Madīnat ash Shamāl"
  },
  {
  "id": "Umm Salal",
  "description": "Umm Salal"
  }
  ]
  },
  {
  "code": "RO",
  "description": "Romania",
  "regions": [
  {
  "id": "Alba County",
  "description": "Alba County"
  },
  {
  "id": "Arad County",
  "description": "Arad County"
  },
  {
  "id": "Arges",
  "description": "Arges"
  },
  {
  "id": "Bacău County",
  "description": "Bacău County"
  },
  {
  "id": "Bihor County",
  "description": "Bihor County"
  },
  {
  "id": "Bistrița-Năsăud County",
  "description": "Bistrița-Năsăud County"
  },
  {
  "id": "Botoșani County",
  "description": "Botoșani County"
  },
  {
  "id": "Brăila County",
  "description": "Brăila County"
  },
  {
  "id": "Brașov County",
  "description": "Brașov County"
  },
  {
  "id": "București",
  "description": "București"
  },
  {
  "id": "Buzău County",
  "description": "Buzău County"
  },
  {
  "id": "Călărași County",
  "description": "Călărași County"
  },
  {
  "id": "Caraș-Severin County",
  "description": "Caraș-Severin County"
  },
  {
  "id": "Cluj County",
  "description": "Cluj County"
  },
  {
  "id": "Constanța County",
  "description": "Constanța County"
  },
  {
  "id": "Covasna County",
  "description": "Covasna County"
  },
  {
  "id": "Dâmbovița County",
  "description": "Dâmbovița County"
  },
  {
  "id": "Dolj",
  "description": "Dolj"
  },
  {
  "id": "Galați County",
  "description": "Galați County"
  },
  {
  "id": "Giurgiu County",
  "description": "Giurgiu County"
  },
  {
  "id": "Gorj County",
  "description": "Gorj County"
  },
  {
  "id": "Harghita County",
  "description": "Harghita County"
  },
  {
  "id": "Hunedoara County",
  "description": "Hunedoara County"
  },
  {
  "id": "Ialomița County",
  "description": "Ialomița County"
  },
  {
  "id": "Iași County",
  "description": "Iași County"
  },
  {
  "id": "Ilfov",
  "description": "Ilfov"
  },
  {
  "id": "Maramureş",
  "description": "Maramureş"
  },
  {
  "id": "Mehedinți County",
  "description": "Mehedinți County"
  },
  {
  "id": "Mureș County",
  "description": "Mureș County"
  },
  {
  "id": "Neamț County",
  "description": "Neamț County"
  },
  {
  "id": "Olt",
  "description": "Olt"
  },
  {
  "id": "Prahova",
  "description": "Prahova"
  },
  {
  "id": "Sălaj County",
  "description": "Sălaj County"
  },
  {
  "id": "Satu Mare County",
  "description": "Satu Mare County"
  },
  {
  "id": "Sibiu County",
  "description": "Sibiu County"
  },
  {
  "id": "Suceava",
  "description": "Suceava"
  },
  {
  "id": "Teleorman County",
  "description": "Teleorman County"
  },
  {
  "id": "Timiș County",
  "description": "Timiș County"
  },
  {
  "id": "Tulcea County",
  "description": "Tulcea County"
  },
  {
  "id": "Vâlcea County",
  "description": "Vâlcea County"
  },
  {
  "id": "Vaslui County",
  "description": "Vaslui County"
  },
  {
  "id": "Vrancea",
  "description": "Vrancea"
  }
  ]
  },
  {
  "code": "RU",
  "description": "Russian Federation",
  "regions": [
  {
  "id": "Adygeya Republic",
  "description": "Adygeya Republic"
  },
  {
  "id": "Altai",
  "description": "Altai"
  },
  {
  "id": "Altai Krai",
  "description": "Altai Krai"
  },
  {
  "id": "Amur Oblast",
  "description": "Amur Oblast"
  },
  {
  "id": "Arkhangelskaya",
  "description": "Arkhangelskaya"
  },
  {
  "id": "Astrakhan Oblast",
  "description": "Astrakhan Oblast"
  },
  {
  "id": "Bashkortostan Republic",
  "description": "Bashkortostan Republic"
  },
  {
  "id": "Belgorod Oblast",
  "description": "Belgorod Oblast"
  },
  {
  "id": "Bryansk Oblast",
  "description": "Bryansk Oblast"
  },
  {
  "id": "Buryatiya Republic",
  "description": "Buryatiya Republic"
  },
  {
  "id": "Chechnya",
  "description": "Chechnya"
  },
  {
  "id": "Chelyabinsk",
  "description": "Chelyabinsk"
  },
  {
  "id": "Chukotka",
  "description": "Chukotka"
  },
  {
  "id": "Chuvash Republic",
  "description": "Chuvash Republic"
  },
  {
  "id": "Dagestan",
  "description": "Dagestan"
  },
  {
  "id": "Ingushetiya Republic",
  "description": "Ingushetiya Republic"
  },
  {
  "id": "Irkutsk Oblast",
  "description": "Irkutsk Oblast"
  },
  {
  "id": "Ivanovo Oblast",
  "description": "Ivanovo Oblast"
  },
  {
  "id": "Jewish Autonomous Oblast",
  "description": "Jewish Autonomous Oblast"
  },
  {
  "id": "Kabardino-Balkariya Republic",
  "description": "Kabardino-Balkariya Republic"
  },
  {
  "id": "Kaliningrad Oblast",
  "description": "Kaliningrad Oblast"
  },
  {
  "id": "Kalmykiya Republic",
  "description": "Kalmykiya Republic"
  },
  {
  "id": "Kaluga Oblast",
  "description": "Kaluga Oblast"
  },
  {
  "id": "Kamchatka",
  "description": "Kamchatka"
  },
  {
  "id": "Karachayevo-Cherkesiya Republic",
  "description": "Karachayevo-Cherkesiya Republic"
  },
  {
  "id": "Karelia",
  "description": "Karelia"
  },
  {
  "id": "Khabarovsk",
  "description": "Khabarovsk"
  },
  {
  "id": "Khakasiya Republic",
  "description": "Khakasiya Republic"
  },
  {
  "id": "Khanty-Mansia",
  "description": "Khanty-Mansia"
  },
  {
  "id": "Kirov Oblast",
  "description": "Kirov Oblast"
  },
  {
  "id": "Komi",
  "description": "Komi"
  },
  {
  "id": "Kostroma Oblast",
  "description": "Kostroma Oblast"
  },
  {
  "id": "Krasnodar Krai",
  "description": "Krasnodar Krai"
  },
  {
  "id": "Krasnoyarsk Krai",
  "description": "Krasnoyarsk Krai"
  },
  {
  "id": "Kurgan Oblast",
  "description": "Kurgan Oblast"
  },
  {
  "id": "Kursk Oblast",
  "description": "Kursk Oblast"
  },
  {
  "id": "Kuzbass",
  "description": "Kuzbass"
  },
  {
  "id": "Leningradskaya Oblast'",
  "description": "Leningradskaya Oblast'"
  },
  {
  "id": "Lipetsk Oblast",
  "description": "Lipetsk Oblast"
  },
  {
  "id": "Magadan Oblast",
  "description": "Magadan Oblast"
  },
  {
  "id": "Mariy-El Republic",
  "description": "Mariy-El Republic"
  },
  {
  "id": "Mordoviya Republic",
  "description": "Mordoviya Republic"
  },
  {
  "id": "Moscow",
  "description": "Moscow"
  },
  {
  "id": "Moscow Oblast",
  "description": "Moscow Oblast"
  },
  {
  "id": "Murmansk",
  "description": "Murmansk"
  },
  {
  "id": "Nenets",
  "description": "Nenets"
  },
  {
  "id": "Nizhny Novgorod Oblast",
  "description": "Nizhny Novgorod Oblast"
  },
  {
  "id": "North Ossetia–Alania",
  "description": "North Ossetia–Alania"
  },
  {
  "id": "Novgorod Oblast",
  "description": "Novgorod Oblast"
  },
  {
  "id": "Novosibirsk Oblast",
  "description": "Novosibirsk Oblast"
  },
  {
  "id": "Omsk Oblast",
  "description": "Omsk Oblast"
  },
  {
  "id": "Orenburg Oblast",
  "description": "Orenburg Oblast"
  },
  {
  "id": "Oryol oblast",
  "description": "Oryol oblast"
  },
  {
  "id": "Penza Oblast",
  "description": "Penza Oblast"
  },
  {
  "id": "Perm Krai",
  "description": "Perm Krai"
  },
  {
  "id": "Primorye",
  "description": "Primorye"
  },
  {
  "id": "Pskov Oblast",
  "description": "Pskov Oblast"
  },
  {
  "id": "Republic of Tyva",
  "description": "Republic of Tyva"
  },
  {
  "id": "Rostov",
  "description": "Rostov"
  },
  {
  "id": "Ryazan Oblast",
  "description": "Ryazan Oblast"
  },
  {
  "id": "Sakha",
  "description": "Sakha"
  },
  {
  "id": "Sakhalin Oblast",
  "description": "Sakhalin Oblast"
  },
  {
  "id": "Samara Oblast",
  "description": "Samara Oblast"
  },
  {
  "id": "Saratov Oblast",
  "description": "Saratov Oblast"
  },
  {
  "id": "Smolensk Oblast",
  "description": "Smolensk Oblast"
  },
  {
  "id": "Stavropol Kray",
  "description": "Stavropol Kray"
  },
  {
  "id": "St.-Petersburg",
  "description": "St.-Petersburg"
  },
  {
  "id": "Sverdlovsk Oblast",
  "description": "Sverdlovsk Oblast"
  },
  {
  "id": "Tambov Oblast",
  "description": "Tambov Oblast"
  },
  {
  "id": "Tatarstan Republic",
  "description": "Tatarstan Republic"
  },
  {
  "id": "Tomsk Oblast",
  "description": "Tomsk Oblast"
  },
  {
  "id": "Tula Oblast",
  "description": "Tula Oblast"
  },
  {
  "id": "Tver Oblast",
  "description": "Tver Oblast"
  },
  {
  "id": "Tyumen Oblast",
  "description": "Tyumen Oblast"
  },
  {
  "id": "Udmurtiya Republic",
  "description": "Udmurtiya Republic"
  },
  {
  "id": "Ulyanovsk",
  "description": "Ulyanovsk"
  },
  {
  "id": "Vladimir Oblast",
  "description": "Vladimir Oblast"
  },
  {
  "id": "Volgograd Oblast",
  "description": "Volgograd Oblast"
  },
  {
  "id": "Vologda Oblast",
  "description": "Vologda Oblast"
  },
  {
  "id": "Voronezh Oblast",
  "description": "Voronezh Oblast"
  },
  {
  "id": "Yamalo-Nenets",
  "description": "Yamalo-Nenets"
  },
  {
  "id": "Yaroslavl Oblast",
  "description": "Yaroslavl Oblast"
  },
  {
  "id": "Zabaykalskiy (Transbaikal) Kray",
  "description": "Zabaykalskiy (Transbaikal) Kray"
  }
  ]
  },
  {
  "code": "RW",
  "description": "Rwanda",
  "regions": [
  {
  "id": "Eastern Province",
  "description": "Eastern Province"
  },
  {
  "id": "Kigali",
  "description": "Kigali"
  },
  {
  "id": "Northern Province",
  "description": "Northern Province"
  },
  {
  "id": "Southern Province",
  "description": "Southern Province"
  },
  {
  "id": "Western Province",
  "description": "Western Province"
  }
  ]
  },
  {
  "code": "SH",
  "description": "Saint Helena",
  "regions": [
  {
  "id": "Ascension",
  "description": "Ascension"
  },
  {
  "id": "Saint Helena",
  "description": "Saint Helena"
  },
  {
  "id": "Tristan da Cunha",
  "description": "Tristan da Cunha"
  }
  ]
  },
  {
  "code": "KN",
  "description": "Saint Kitts and Nevis",
  "regions": [
  {
  "id": "Christ Church Nichola Town",
  "description": "Christ Church Nichola Town"
  },
  {
  "id": "Middle Island",
  "description": "Middle Island"
  },
  {
  "id": "Saint Anne Sandy Point",
  "description": "Saint Anne Sandy Point"
  },
  {
  "id": "Saint George Basseterre",
  "description": "Saint George Basseterre"
  },
  {
  "id": "Saint George Gingerland",
  "description": "Saint George Gingerland"
  },
  {
  "id": "Saint James Windwa",
  "description": "Saint James Windwa"
  },
  {
  "id": "Saint John Capesterre",
  "description": "Saint John Capesterre"
  },
  {
  "id": "Saint John Figtree",
  "description": "Saint John Figtree"
  },
  {
  "id": "Saint Mary Cayon",
  "description": "Saint Mary Cayon"
  },
  {
  "id": "Saint Paul Capesterre",
  "description": "Saint Paul Capesterre"
  },
  {
  "id": "Saint Paul Charlestown",
  "description": "Saint Paul Charlestown"
  },
  {
  "id": "Saint Peter Basseterre",
  "description": "Saint Peter Basseterre"
  },
  {
  "id": "Saint Thomas Lowland",
  "description": "Saint Thomas Lowland"
  },
  {
  "id": "Trinity Palmetto Point",
  "description": "Trinity Palmetto Point"
  }
  ]
  },
  {
  "code": "VC",
  "description": "Saint Vincent and the Grenadines",
  "regions": [
  {
  "id": "Charlotte Parish",
  "description": "Charlotte Parish"
  },
  {
  "id": "Grenadines Parish",
  "description": "Grenadines Parish"
  },
  {
  "id": "Saint Andrew Parish",
  "description": "Saint Andrew Parish"
  },
  {
  "id": "Saint David Parish",
  "description": "Saint David Parish"
  },
  {
  "id": "Saint George Parish",
  "description": "Saint George Parish"
  },
  {
  "id": "Saint Patrick Parish",
  "description": "Saint Patrick Parish"
  }
  ]
  },
  {
  "code": "SM",
  "description": "San Marino",
  "regions": [
  {
  "id": "Acquaviva",
  "description": "Acquaviva"
  },
  {
  "id": "Borgo Maggiore",
  "description": "Borgo Maggiore"
  },
  {
  "id": "Chiesanuova",
  "description": "Chiesanuova"
  },
  {
  "id": "Domagnano",
  "description": "Domagnano"
  },
  {
  "id": "Faetano",
  "description": "Faetano"
  },
  {
  "id": "Fiorentino",
  "description": "Fiorentino"
  },
  {
  "id": "Montegiardino",
  "description": "Montegiardino"
  },
  {
  "id": "San Marino",
  "description": "San Marino"
  },
  {
  "id": "Serravalle",
  "description": "Serravalle"
  }
  ]
  },
  {
  "code": "ST",
  "description": "Sao Tome and Principe",
  "regions": [
  {
  "id": "Príncipe",
  "description": "Príncipe"
  },
  {
  "id": "São Tomé Island",
  "description": "São Tomé Island"
  }
  ]
  },
  {
  "code": "SA",
  "description": "Saudi Arabia",
  "regions": [
  {
  "id": "Al Bahah Region",
  "description": "Al Bahah Region"
  },
  {
  "id": "Al Jawf Region",
  "description": "Al Jawf Region"
  },
  {
  "id": "Al-Qassim Region",
  "description": "Al-Qassim Region"
  },
  {
  "id": "'Asir Region",
  "description": "'Asir Region"
  },
  {
  "id": "Eastern Province",
  "description": "Eastern Province"
  },
  {
  "id": "Ha'il Region",
  "description": "Ha'il Region"
  },
  {
  "id": "Jazan Region",
  "description": "Jazan Region"
  },
  {
  "id": "Mecca Region",
  "description": "Mecca Region"
  },
  {
  "id": "Medina Region",
  "description": "Medina Region"
  },
  {
  "id": "Najran Region",
  "description": "Najran Region"
  },
  {
  "id": "Northern Borders Region",
  "description": "Northern Borders Region"
  },
  {
  "id": "Riyadh Region",
  "description": "Riyadh Region"
  },
  {
  "id": "Tabuk Region",
  "description": "Tabuk Region"
  }
  ]
  },
  {
  "code": "SN",
  "description": "Senegal",
  "regions": [
  {
  "id": "Dakar",
  "description": "Dakar"
  },
  {
  "id": "Diourbel Region",
  "description": "Diourbel Region"
  },
  {
  "id": "Fatick",
  "description": "Fatick"
  },
  {
  "id": "Kaffrine",
  "description": "Kaffrine"
  },
  {
  "id": "Kaolack",
  "description": "Kaolack"
  },
  {
  "id": "Kédougou",
  "description": "Kédougou"
  },
  {
  "id": "Kolda",
  "description": "Kolda"
  },
  {
  "id": "Louga",
  "description": "Louga"
  },
  {
  "id": "Matam",
  "description": "Matam"
  },
  {
  "id": "Saint-Louis",
  "description": "Saint-Louis"
  },
  {
  "id": "Sédhiou",
  "description": "Sédhiou"
  },
  {
  "id": "Tambacounda",
  "description": "Tambacounda"
  },
  {
  "id": "Thiès",
  "description": "Thiès"
  },
  {
  "id": "Ziguinchor",
  "description": "Ziguinchor"
  }
  ]
  },
  {
  "code": "RS",
  "description": "Serbia",
  "regions": [
  {
  "id": "Central Serbia",
  "description": "Central Serbia"
  },
  {
  "id": "Vojvodina",
  "description": "Vojvodina"
  }
  ]
  },
  {
  "code": "SC",
  "description": "Seychelles",
  "regions": [
  {
  "id": "Anse-aux-Pins",
  "description": "Anse-aux-Pins"
  },
  {
  "id": "Anse Boileau",
  "description": "Anse Boileau"
  },
  {
  "id": "Anse Etoile",
  "description": "Anse Etoile"
  },
  {
  "id": "Anse Royale",
  "description": "Anse Royale"
  },
  {
  "id": "Au Cap",
  "description": "Au Cap"
  },
  {
  "id": "Baie Lazare",
  "description": "Baie Lazare"
  },
  {
  "id": "Baie Sainte Anne",
  "description": "Baie Sainte Anne"
  },
  {
  "id": "Beau Vallon",
  "description": "Beau Vallon"
  },
  {
  "id": "Bel Air",
  "description": "Bel Air"
  },
  {
  "id": "Bel Ombre",
  "description": "Bel Ombre"
  },
  {
  "id": "Cascade",
  "description": "Cascade"
  },
  {
  "id": "Glacis",
  "description": "Glacis"
  },
  {
  "id": "Grand Anse Mahe",
  "description": "Grand Anse Mahe"
  },
  {
  "id": "Grand Anse Praslin",
  "description": "Grand Anse Praslin"
  },
  {
  "id": "Ile Perseverance I",
  "description": "Ile Perseverance I"
  },
  {
  "id": "Ile Perseverance II",
  "description": "Ile Perseverance II"
  },
  {
  "id": "La Digue and Inner Islands",
  "description": "La Digue and Inner Islands"
  },
  {
  "id": "La Rivière Anglaise",
  "description": "La Rivière Anglaise"
  },
  {
  "id": "Les Mamelles",
  "description": "Les Mamelles"
  },
  {
  "id": "Mont Buxton",
  "description": "Mont Buxton"
  },
  {
  "id": "Mont Fleuri",
  "description": "Mont Fleuri"
  },
  {
  "id": "Outer Islands",
  "description": "Outer Islands"
  },
  {
  "id": "Plaisance",
  "description": "Plaisance"
  },
  {
  "id": "Pointe La Rue",
  "description": "Pointe La Rue"
  },
  {
  "id": "Port Glaud",
  "description": "Port Glaud"
  },
  {
  "id": "Roche Caiman",
  "description": "Roche Caiman"
  },
  {
  "id": "Saint Louis",
  "description": "Saint Louis"
  },
  {
  "id": "Takamaka",
  "description": "Takamaka"
  }
  ]
  },
  {
  "code": "SL",
  "description": "Sierra Leone",
  "regions": [
  {
  "id": "Eastern Province",
  "description": "Eastern Province"
  },
  {
  "id": "Northern Province",
  "description": "Northern Province"
  },
  {
  "id": "North West",
  "description": "North West"
  },
  {
  "id": "Southern Province",
  "description": "Southern Province"
  },
  {
  "id": "Western Area",
  "description": "Western Area"
  }
  ]
  },
  {
  "code": "SG",
  "description": "Singapore",
  "regions": [
  {
  "id": "Central Singapore",
  "description": "Central Singapore"
  },
  {
  "id": "North East",
  "description": "North East"
  },
  {
  "id": "North West",
  "description": "North West"
  },
  {
  "id": "South East",
  "description": "South East"
  },
  {
  "id": "South West",
  "description": "South West"
  }
  ]
  },
  {
  "code": "SK",
  "description": "Slovakia",
  "regions": [
  {
  "id": "Banská Bystrica Region",
  "description": "Banská Bystrica Region"
  },
  {
  "id": "Bratislava Region",
  "description": "Bratislava Region"
  },
  {
  "id": "Košice Region",
  "description": "Košice Region"
  },
  {
  "id": "Nitra Region",
  "description": "Nitra Region"
  },
  {
  "id": "Prešov Region",
  "description": "Prešov Region"
  },
  {
  "id": "Trenčín Region",
  "description": "Trenčín Region"
  },
  {
  "id": "Trnava Region",
  "description": "Trnava Region"
  },
  {
  "id": "Žilina Region",
  "description": "Žilina Region"
  }
  ]
  },
  {
  "code": "SI",
  "description": "Slovenia",
  "regions": [
  {
  "id": "Ajdovščina Municipality",
  "description": "Ajdovščina Municipality"
  },
  {
  "id": "Ankaran Municipality",
  "description": "Ankaran Municipality"
  },
  {
  "id": "Apače",
  "description": "Apače"
  },
  {
  "id": "Beltinci",
  "description": "Beltinci"
  },
  {
  "id": "Benedikt",
  "description": "Benedikt"
  },
  {
  "id": "Bistrica ob Sotli",
  "description": "Bistrica ob Sotli"
  },
  {
  "id": "Bled",
  "description": "Bled"
  },
  {
  "id": "Bloke",
  "description": "Bloke"
  },
  {
  "id": "Bohinj Municipality",
  "description": "Bohinj Municipality"
  },
  {
  "id": "Borovnica",
  "description": "Borovnica"
  },
  {
  "id": "Bovec",
  "description": "Bovec"
  },
  {
  "id": "Braslovče",
  "description": "Braslovče"
  },
  {
  "id": "Brda",
  "description": "Brda"
  },
  {
  "id": "Brežice",
  "description": "Brežice"
  },
  {
  "id": "Brezovica",
  "description": "Brezovica"
  },
  {
  "id": "Cankova",
  "description": "Cankova"
  },
  {
  "id": "Celje",
  "description": "Celje"
  },
  {
  "id": "Cerklje na Gorenjskem",
  "description": "Cerklje na Gorenjskem"
  },
  {
  "id": "Cerknica",
  "description": "Cerknica"
  },
  {
  "id": "Cerkno",
  "description": "Cerkno"
  },
  {
  "id": "Cerkvenjak",
  "description": "Cerkvenjak"
  },
  {
  "id": "Cirkulane",
  "description": "Cirkulane"
  },
  {
  "id": "Črenšovci",
  "description": "Črenšovci"
  },
  {
  "id": "Črna na Koroškem Municipality",
  "description": "Črna na Koroškem Municipality"
  },
  {
  "id": "Črnomelj Municipality",
  "description": "Črnomelj Municipality"
  },
  {
  "id": "Destrnik",
  "description": "Destrnik"
  },
  {
  "id": "Divača",
  "description": "Divača"
  },
  {
  "id": "Dobje",
  "description": "Dobje"
  },
  {
  "id": "Dobrepolje",
  "description": "Dobrepolje"
  },
  {
  "id": "Dobrna",
  "description": "Dobrna"
  },
  {
  "id": "Dobrova-Horjul-Polhov Gradec",
  "description": "Dobrova-Horjul-Polhov Gradec"
  },
  {
  "id": "Dobrovnik-Dobronak",
  "description": "Dobrovnik-Dobronak"
  },
  {
  "id": "Dolenjske Toplice",
  "description": "Dolenjske Toplice"
  },
  {
  "id": "Dol pri Ljubljani",
  "description": "Dol pri Ljubljani"
  },
  {
  "id": "Domžale",
  "description": "Domžale"
  },
  {
  "id": "Dornava",
  "description": "Dornava"
  },
  {
  "id": "Dravograd",
  "description": "Dravograd"
  },
  {
  "id": "Duplek",
  "description": "Duplek"
  },
  {
  "id": "Gorišnica",
  "description": "Gorišnica"
  },
  {
  "id": "Gorje",
  "description": "Gorje"
  },
  {
  "id": "Gornja Radgona",
  "description": "Gornja Radgona"
  },
  {
  "id": "Gornji Grad",
  "description": "Gornji Grad"
  },
  {
  "id": "Gornji Petrovci",
  "description": "Gornji Petrovci"
  },
  {
  "id": "Grad",
  "description": "Grad"
  },
  {
  "id": "Grosuplje",
  "description": "Grosuplje"
  },
  {
  "id": "Hajdina",
  "description": "Hajdina"
  },
  {
  "id": "Hoče-Slivnica",
  "description": "Hoče-Slivnica"
  },
  {
  "id": "Hodoš-Hodos",
  "description": "Hodoš-Hodos"
  },
  {
  "id": "Horjul",
  "description": "Horjul"
  },
  {
  "id": "Hrastnik Municipality",
  "description": "Hrastnik Municipality"
  },
  {
  "id": "Hrpelje-Kozina",
  "description": "Hrpelje-Kozina"
  },
  {
  "id": "Idrija",
  "description": "Idrija"
  },
  {
  "id": "Ig Municipality",
  "description": "Ig Municipality"
  },
  {
  "id": "Ilirska Bistrica",
  "description": "Ilirska Bistrica"
  },
  {
  "id": "Ivančna Gorica",
  "description": "Ivančna Gorica"
  },
  {
  "id": "Izola-Isola",
  "description": "Izola-Isola"
  },
  {
  "id": "Jesenice",
  "description": "Jesenice"
  },
  {
  "id": "Jezersko",
  "description": "Jezersko"
  },
  {
  "id": "Juršinci",
  "description": "Juršinci"
  },
  {
  "id": "Kamnik",
  "description": "Kamnik"
  },
  {
  "id": "Kanal ob Soči Municipality",
  "description": "Kanal ob Soči Municipality"
  },
  {
  "id": "Kidričevo",
  "description": "Kidričevo"
  },
  {
  "id": "Kobarid Municipality",
  "description": "Kobarid Municipality"
  },
  {
  "id": "Kobilje",
  "description": "Kobilje"
  },
  {
  "id": "Kočevje",
  "description": "Kočevje"
  },
  {
  "id": "Komen",
  "description": "Komen"
  },
  {
  "id": "Komenda",
  "description": "Komenda"
  },
  {
  "id": "Koper-Capodistria",
  "description": "Koper-Capodistria"
  },
  {
  "id": "Kostanjevica na Krki",
  "description": "Kostanjevica na Krki"
  },
  {
  "id": "Kostel",
  "description": "Kostel"
  },
  {
  "id": "Kozje",
  "description": "Kozje"
  },
  {
  "id": "Kranj",
  "description": "Kranj"
  },
  {
  "id": "Kranjska Gora",
  "description": "Kranjska Gora"
  },
  {
  "id": "Križevci",
  "description": "Križevci"
  },
  {
  "id": "Krško",
  "description": "Krško"
  },
  {
  "id": "Kungota",
  "description": "Kungota"
  },
  {
  "id": "Kuzma",
  "description": "Kuzma"
  },
  {
  "id": "Laško Municipality",
  "description": "Laško Municipality"
  },
  {
  "id": "Lenart",
  "description": "Lenart"
  },
  {
  "id": "Lendava-Lendva",
  "description": "Lendava-Lendva"
  },
  {
  "id": "Litija",
  "description": "Litija"
  },
  {
  "id": "Ljubljana",
  "description": "Ljubljana"
  },
  {
  "id": "Ljubno",
  "description": "Ljubno"
  },
  {
  "id": "Ljutomer",
  "description": "Ljutomer"
  },
  {
  "id": "Logatec",
  "description": "Logatec"
  },
  {
  "id": "Log–Dragomer",
  "description": "Log–Dragomer"
  },
  {
  "id": "Loška Dolina Municipality",
  "description": "Loška Dolina Municipality"
  },
  {
  "id": "Loški Potok",
  "description": "Loški Potok"
  },
  {
  "id": "Lovrenc na Pohorju",
  "description": "Lovrenc na Pohorju"
  },
  {
  "id": "Luče",
  "description": "Luče"
  },
  {
  "id": "Lukovica",
  "description": "Lukovica"
  },
  {
  "id": "Majšperk",
  "description": "Majšperk"
  },
  {
  "id": "Makole",
  "description": "Makole"
  },
  {
  "id": "Maribor City Municipality",
  "description": "Maribor City Municipality"
  },
  {
  "id": "Markovci",
  "description": "Markovci"
  },
  {
  "id": "Medvode",
  "description": "Medvode"
  },
  {
  "id": "Mengeš",
  "description": "Mengeš"
  },
  {
  "id": "Metlika",
  "description": "Metlika"
  },
  {
  "id": "Mežica",
  "description": "Mežica"
  },
  {
  "id": "Miklavž na Dravskem Polju",
  "description": "Miklavž na Dravskem Polju"
  },
  {
  "id": "Miren-Kostanjevica",
  "description": "Miren-Kostanjevica"
  },
  {
  "id": "Mirna",
  "description": "Mirna"
  },
  {
  "id": "Mirna Peč Municipality",
  "description": "Mirna Peč Municipality"
  },
  {
  "id": "Mislinja",
  "description": "Mislinja"
  },
  {
  "id": "Mokronog-Trebelno Municipality",
  "description": "Mokronog-Trebelno Municipality"
  },
  {
  "id": "Moravče",
  "description": "Moravče"
  },
  {
  "id": "Moravske Toplice",
  "description": "Moravske Toplice"
  },
  {
  "id": "Mozirje",
  "description": "Mozirje"
  },
  {
  "id": "Murska Sobota",
  "description": "Murska Sobota"
  },
  {
  "id": "Muta",
  "description": "Muta"
  },
  {
  "id": "Naklo",
  "description": "Naklo"
  },
  {
  "id": "Nazarje",
  "description": "Nazarje"
  },
  {
  "id": "Nova Gorica",
  "description": "Nova Gorica"
  },
  {
  "id": "Novo Mesto",
  "description": "Novo Mesto"
  },
  {
  "id": "Občina Gorenja vas-Poljane",
  "description": "Občina Gorenja vas-Poljane"
  },
  {
  "id": "Odranci",
  "description": "Odranci"
  },
  {
  "id": "Oplotnica Municipality",
  "description": "Oplotnica Municipality"
  },
  {
  "id": "Ormož",
  "description": "Ormož"
  },
  {
  "id": "Osilnica",
  "description": "Osilnica"
  },
  {
  "id": "Pesnica",
  "description": "Pesnica"
  },
  {
  "id": "Piran-Pirano",
  "description": "Piran-Pirano"
  },
  {
  "id": "Pivka",
  "description": "Pivka"
  },
  {
  "id": "Podčetrtek",
  "description": "Podčetrtek"
  },
  {
  "id": "Podlehnik",
  "description": "Podlehnik"
  },
  {
  "id": "Podvelka",
  "description": "Podvelka"
  },
  {
  "id": "Poljčane",
  "description": "Poljčane"
  },
  {
  "id": "Polzela",
  "description": "Polzela"
  },
  {
  "id": "Postojna",
  "description": "Postojna"
  },
  {
  "id": "Prebold",
  "description": "Prebold"
  },
  {
  "id": "Preddvor",
  "description": "Preddvor"
  },
  {
  "id": "Prevalje",
  "description": "Prevalje"
  },
  {
  "id": "Ptuj",
  "description": "Ptuj"
  },
  {
  "id": "Puconci",
  "description": "Puconci"
  },
  {
  "id": "Rače-Fram",
  "description": "Rače-Fram"
  },
  {
  "id": "Radeče Municipality",
  "description": "Radeče Municipality"
  },
  {
  "id": "Radenci",
  "description": "Radenci"
  },
  {
  "id": "Radlje ob Dravi",
  "description": "Radlje ob Dravi"
  },
  {
  "id": "Radovljica",
  "description": "Radovljica"
  },
  {
  "id": "Ravne na Koroškem",
  "description": "Ravne na Koroškem"
  },
  {
  "id": "Razkrižje",
  "description": "Razkrižje"
  },
  {
  "id": "Rečica ob Savinji",
  "description": "Rečica ob Savinji"
  },
  {
  "id": "Renče-Vogrsko",
  "description": "Renče-Vogrsko"
  },
  {
  "id": "Ribnica",
  "description": "Ribnica"
  },
  {
  "id": "Ribnica na Pohorju",
  "description": "Ribnica na Pohorju"
  },
  {
  "id": "Rogaška Slatina",
  "description": "Rogaška Slatina"
  },
  {
  "id": "Rogašovci",
  "description": "Rogašovci"
  },
  {
  "id": "Rogatec",
  "description": "Rogatec"
  },
  {
  "id": "Ruše Municipality",
  "description": "Ruše Municipality"
  },
  {
  "id": "Šalovci",
  "description": "Šalovci"
  },
  {
  "id": "Selnica ob Dravi",
  "description": "Selnica ob Dravi"
  },
  {
  "id": "Semič",
  "description": "Semič"
  },
  {
  "id": "Šempeter-Vrtojba",
  "description": "Šempeter-Vrtojba"
  },
  {
  "id": "Šenčur",
  "description": "Šenčur"
  },
  {
  "id": "Šentilj",
  "description": "Šentilj"
  },
  {
  "id": "Šentjernej",
  "description": "Šentjernej"
  },
  {
  "id": "Sentjur",
  "description": "Sentjur"
  },
  {
  "id": "Šentrupert",
  "description": "Šentrupert"
  },
  {
  "id": "Sevnica Municipality",
  "description": "Sevnica Municipality"
  },
  {
  "id": "Sežana",
  "description": "Sežana"
  },
  {
  "id": "Škocjan",
  "description": "Škocjan"
  },
  {
  "id": "Škofja Loka",
  "description": "Škofja Loka"
  },
  {
  "id": "Škofljica",
  "description": "Škofljica"
  },
  {
  "id": "Slovenj Gradec",
  "description": "Slovenj Gradec"
  },
  {
  "id": "Slovenska Bistrica",
  "description": "Slovenska Bistrica"
  },
  {
  "id": "Slovenska Konjice",
  "description": "Slovenska Konjice"
  },
  {
  "id": "Šmarje pri Jelšah",
  "description": "Šmarje pri Jelšah"
  },
  {
  "id": "Šmarješke Toplice",
  "description": "Šmarješke Toplice"
  },
  {
  "id": "Šmartno ob Paki",
  "description": "Šmartno ob Paki"
  },
  {
  "id": "Šmartno pri Litiji",
  "description": "Šmartno pri Litiji"
  },
  {
  "id": "Sodražica",
  "description": "Sodražica"
  },
  {
  "id": "Solčava Municipality",
  "description": "Solčava Municipality"
  },
  {
  "id": "Šoštanj",
  "description": "Šoštanj"
  },
  {
  "id": "Središče ob Dravi",
  "description": "Središče ob Dravi"
  },
  {
  "id": "Starše",
  "description": "Starše"
  },
  {
  "id": "Štore",
  "description": "Štore"
  },
  {
  "id": "Straža",
  "description": "Straža"
  },
  {
  "id": "Sveta Ana Municipality",
  "description": "Sveta Ana Municipality"
  },
  {
  "id": "Sveti Andraž v Slovenskih Goricah",
  "description": "Sveti Andraž v Slovenskih Goricah"
  },
  {
  "id": "Sveti Jurij",
  "description": "Sveti Jurij"
  },
  {
  "id": "Sveti Jurij v Slovenskih Goricah",
  "description": "Sveti Jurij v Slovenskih Goricah"
  },
  {
  "id": "Sveti Tomaž",
  "description": "Sveti Tomaž"
  },
  {
  "id": "Sv. Trojica v Slov. Goricah",
  "description": "Sv. Trojica v Slov. Goricah"
  },
  {
  "id": "Tabor",
  "description": "Tabor"
  },
  {
  "id": "Tišina",
  "description": "Tišina"
  },
  {
  "id": "Tolmin",
  "description": "Tolmin"
  },
  {
  "id": "Trbovlje",
  "description": "Trbovlje"
  },
  {
  "id": "Trebnje",
  "description": "Trebnje"
  },
  {
  "id": "Trnovska Vas",
  "description": "Trnovska Vas"
  },
  {
  "id": "Tržič",
  "description": "Tržič"
  },
  {
  "id": "Trzin",
  "description": "Trzin"
  },
  {
  "id": "Turnišče",
  "description": "Turnišče"
  },
  {
  "id": "Velenje",
  "description": "Velenje"
  },
  {
  "id": "Velika Polana",
  "description": "Velika Polana"
  },
  {
  "id": "Velike Lašče",
  "description": "Velike Lašče"
  },
  {
  "id": "Veržej",
  "description": "Veržej"
  },
  {
  "id": "Videm",
  "description": "Videm"
  },
  {
  "id": "Vipava",
  "description": "Vipava"
  },
  {
  "id": "Vitanje",
  "description": "Vitanje"
  },
  {
  "id": "Vodice",
  "description": "Vodice"
  },
  {
  "id": "Vojnik",
  "description": "Vojnik"
  },
  {
  "id": "Vransko",
  "description": "Vransko"
  },
  {
  "id": "Vrhnika",
  "description": "Vrhnika"
  },
  {
  "id": "Vuzenica",
  "description": "Vuzenica"
  },
  {
  "id": "Zagorje ob Savi Municipality",
  "description": "Zagorje ob Savi Municipality"
  },
  {
  "id": "Žalec",
  "description": "Žalec"
  },
  {
  "id": "Zavrč",
  "description": "Zavrč"
  },
  {
  "id": "Železniki Municipality",
  "description": "Železniki Municipality"
  },
  {
  "id": "Žetale",
  "description": "Žetale"
  },
  {
  "id": "Žiri",
  "description": "Žiri"
  },
  {
  "id": "Žirovnica",
  "description": "Žirovnica"
  },
  {
  "id": "Zreče Municipality",
  "description": "Zreče Municipality"
  },
  {
  "id": "Žužemberk",
  "description": "Žužemberk"
  }
  ]
  },
  {
  "code": "SB",
  "description": "Solomon Islands",
  "regions": [
  {
  "id": "Central Province",
  "description": "Central Province"
  },
  {
  "id": "Choiseul Province",
  "description": "Choiseul Province"
  },
  {
  "id": "Guadalcanal Province",
  "description": "Guadalcanal Province"
  },
  {
  "id": "Honiara",
  "description": "Honiara"
  },
  {
  "id": "Isabel Province",
  "description": "Isabel Province"
  },
  {
  "id": "Makira-Ulawa Province",
  "description": "Makira-Ulawa Province"
  },
  {
  "id": "Malaita Province",
  "description": "Malaita Province"
  },
  {
  "id": "Rennell and Bellona Province",
  "description": "Rennell and Bellona Province"
  },
  {
  "id": "Temotu Province",
  "description": "Temotu Province"
  },
  {
  "id": "Western Province",
  "description": "Western Province"
  }
  ]
  },
  {
  "code": "SO",
  "description": "Somalia",
  "regions": [
  {
  "id": "Awdal",
  "description": "Awdal"
  },
  {
  "id": "Bakool",
  "description": "Bakool"
  },
  {
  "id": "Banaadir",
  "description": "Banaadir"
  },
  {
  "id": "Bari",
  "description": "Bari"
  },
  {
  "id": "Bay",
  "description": "Bay"
  },
  {
  "id": "Galguduud",
  "description": "Galguduud"
  },
  {
  "id": "Gedo",
  "description": "Gedo"
  },
  {
  "id": "Hiiraan",
  "description": "Hiiraan"
  },
  {
  "id": "Lower Juba",
  "description": "Lower Juba"
  },
  {
  "id": "Lower Shabeelle",
  "description": "Lower Shabeelle"
  },
  {
  "id": "Middle Juba",
  "description": "Middle Juba"
  },
  {
  "id": "Middle Shabele",
  "description": "Middle Shabele"
  },
  {
  "id": "Mudug",
  "description": "Mudug"
  },
  {
  "id": "Nugaal",
  "description": "Nugaal"
  },
  {
  "id": "Sanaag",
  "description": "Sanaag"
  },
  {
  "id": "Sool",
  "description": "Sool"
  },
  {
  "id": "Togdheer",
  "description": "Togdheer"
  },
  {
  "id": "Woqooyi Galbeed",
  "description": "Woqooyi Galbeed"
  }
  ]
  },
  {
  "code": "ZA",
  "description": "South Africa",
  "regions": [
  {
  "id": "Eastern Cape",
  "description": "Eastern Cape"
  },
  {
  "id": "Free State",
  "description": "Free State"
  },
  {
  "id": "Gauteng",
  "description": "Gauteng"
  },
  {
  "id": "KwaZulu-Natal",
  "description": "KwaZulu-Natal"
  },
  {
  "id": "Limpopo",
  "description": "Limpopo"
  },
  {
  "id": "Mpumalanga",
  "description": "Mpumalanga"
  },
  {
  "id": "Northern Cape",
  "description": "Northern Cape"
  },
  {
  "id": "North West",
  "description": "North West"
  },
  {
  "id": "Western Cape",
  "description": "Western Cape"
  }
  ]
  },
  {
  "code": "GS",
  "description": "South Georgia/South Sandwich Islands",
  "regions": []
  },
  {
  "code": "KR",
  "description": "South Korea",
  "regions": [
  {
  "id": "Busan",
  "description": "Busan"
  },
  {
  "id": "Chungcheongnam-do",
  "description": "Chungcheongnam-do"
  },
  {
  "id": "Daegu",
  "description": "Daegu"
  },
  {
  "id": "Daejeon",
  "description": "Daejeon"
  },
  {
  "id": "Gangwon-do",
  "description": "Gangwon-do"
  },
  {
  "id": "Gwangju",
  "description": "Gwangju"
  },
  {
  "id": "Gyeonggi-do",
  "description": "Gyeonggi-do"
  },
  {
  "id": "Gyeongsangbuk-do",
  "description": "Gyeongsangbuk-do"
  },
  {
  "id": "Gyeongsangnam-do",
  "description": "Gyeongsangnam-do"
  },
  {
  "id": "Incheon",
  "description": "Incheon"
  },
  {
  "id": "Jeju-do",
  "description": "Jeju-do"
  },
  {
  "id": "Jeollabuk-do",
  "description": "Jeollabuk-do"
  },
  {
  "id": "Jeollanam-do",
  "description": "Jeollanam-do"
  },
  {
  "id": "North Chungcheong",
  "description": "North Chungcheong"
  },
  {
  "id": "Sejong-si",
  "description": "Sejong-si"
  },
  {
  "id": "Seoul",
  "description": "Seoul"
  },
  {
  "id": "Ulsan",
  "description": "Ulsan"
  }
  ]
  },
  {
  "code": "SS",
  "description": "South Sudan",
  "regions": [
  {
  "id": "Akobo",
  "description": "Akobo"
  },
  {
  "id": "Amadi State",
  "description": "Amadi State"
  },
  {
  "id": "Aweil",
  "description": "Aweil"
  },
  {
  "id": "Aweil East",
  "description": "Aweil East"
  },
  {
  "id": "Bieh",
  "description": "Bieh"
  },
  {
  "id": "Boma",
  "description": "Boma"
  },
  {
  "id": "Central Equatoria",
  "description": "Central Equatoria"
  },
  {
  "id": "Central Upper Nile",
  "description": "Central Upper Nile"
  },
  {
  "id": "Eastern Equatoria",
  "description": "Eastern Equatoria"
  },
  {
  "id": "Eastern Lakes",
  "description": "Eastern Lakes"
  },
  {
  "id": "Fangak",
  "description": "Fangak"
  },
  {
  "id": "Fashoda",
  "description": "Fashoda"
  },
  {
  "id": "Gbudwe",
  "description": "Gbudwe"
  },
  {
  "id": "Gogrial",
  "description": "Gogrial"
  },
  {
  "id": "Gok",
  "description": "Gok"
  },
  {
  "id": "Imatong",
  "description": "Imatong"
  },
  {
  "id": "Jonglei",
  "description": "Jonglei"
  },
  {
  "id": "Jubek",
  "description": "Jubek"
  },
  {
  "id": "Kapoeta",
  "description": "Kapoeta"
  },
  {
  "id": "Lakes",
  "description": "Lakes"
  },
  {
  "id": "Latjoor",
  "description": "Latjoor"
  },
  {
  "id": "Lol",
  "description": "Lol"
  },
  {
  "id": "Maiwut",
  "description": "Maiwut"
  },
  {
  "id": "Maridi",
  "description": "Maridi"
  },
  {
  "id": "Northern Bahr al Ghazal",
  "description": "Northern Bahr al Ghazal"
  },
  {
  "id": "Northern Liech",
  "description": "Northern Liech"
  },
  {
  "id": "Northern Upper Nile",
  "description": "Northern Upper Nile"
  },
  {
  "id": "Ruweng",
  "description": "Ruweng"
  },
  {
  "id": "Southern Liech",
  "description": "Southern Liech"
  },
  {
  "id": "Tambura",
  "description": "Tambura"
  },
  {
  "id": "Terekeka",
  "description": "Terekeka"
  },
  {
  "id": "Tonj",
  "description": "Tonj"
  },
  {
  "id": "Twic",
  "description": "Twic"
  },
  {
  "id": "Unity",
  "description": "Unity"
  },
  {
  "id": "Upper Nile",
  "description": "Upper Nile"
  },
  {
  "id": "Warrap",
  "description": "Warrap"
  },
  {
  "id": "Wau",
  "description": "Wau"
  },
  {
  "id": "Western Bahr al Ghazal",
  "description": "Western Bahr al Ghazal"
  },
  {
  "id": "Western Equatoria",
  "description": "Western Equatoria"
  },
  {
  "id": "Western Lakes",
  "description": "Western Lakes"
  },
  {
  "id": "Yei River",
  "description": "Yei River"
  }
  ]
  },
  {
  "code": "ES",
  "description": "Spain",
  "regions": [
  {
  "id": "Andalusia",
  "description": "Andalusia"
  },
  {
  "id": "Aragon",
  "description": "Aragon"
  },
  {
  "id": "Asturias",
  "description": "Asturias"
  },
  {
  "id": "Balearic Islands",
  "description": "Balearic Islands"
  },
  {
  "id": "Basque Country",
  "description": "Basque Country"
  },
  {
  "id": "Canary Islands",
  "description": "Canary Islands"
  },
  {
  "id": "Cantabria",
  "description": "Cantabria"
  },
  {
  "id": "Castille and León",
  "description": "Castille and León"
  },
  {
  "id": "Castille-La Mancha",
  "description": "Castille-La Mancha"
  },
  {
  "id": "Catalonia",
  "description": "Catalonia"
  },
  {
  "id": "Ceuta",
  "description": "Ceuta"
  },
  {
  "id": "Extremadura",
  "description": "Extremadura"
  },
  {
  "id": "Galicia",
  "description": "Galicia"
  },
  {
  "id": "La Rioja",
  "description": "La Rioja"
  },
  {
  "id": "Madrid",
  "description": "Madrid"
  },
  {
  "id": "Melilla",
  "description": "Melilla"
  },
  {
  "id": "Murcia",
  "description": "Murcia"
  },
  {
  "id": "Navarre",
  "description": "Navarre"
  },
  {
  "id": "Valencia",
  "description": "Valencia"
  }
  ]
  },
  {
  "code": "LK",
  "description": "Sri Lanka",
  "regions": [
  {
  "id": "Central Province",
  "description": "Central Province"
  },
  {
  "id": "Eastern Province",
  "description": "Eastern Province"
  },
  {
  "id": "North Central Province",
  "description": "North Central Province"
  },
  {
  "id": "Northern Province",
  "description": "Northern Province"
  },
  {
  "id": "North Western Province",
  "description": "North Western Province"
  },
  {
  "id": "Sabaragamuwa Province",
  "description": "Sabaragamuwa Province"
  },
  {
  "id": "Southern Province",
  "description": "Southern Province"
  },
  {
  "id": "Uva Province",
  "description": "Uva Province"
  },
  {
  "id": "Western Province",
  "description": "Western Province"
  }
  ]
  },
  {
  "code": "LC",
  "description": "St. Lucia",
  "regions": [
  {
  "id": "Anse-la-Raye",
  "description": "Anse-la-Raye"
  },
  {
  "id": "Canaries",
  "description": "Canaries"
  },
  {
  "id": "Castries",
  "description": "Castries"
  },
  {
  "id": "Choiseul",
  "description": "Choiseul"
  },
  {
  "id": "Dennery",
  "description": "Dennery"
  },
  {
  "id": "Gros-Islet",
  "description": "Gros-Islet"
  },
  {
  "id": "Laborie",
  "description": "Laborie"
  },
  {
  "id": "Micoud",
  "description": "Micoud"
  },
  {
  "id": "Soufrière",
  "description": "Soufrière"
  },
  {
  "id": "Vieux-Fort",
  "description": "Vieux-Fort"
  }
  ]
  },
  {
  "code": "SD",
  "description": "Sudan",
  "regions": [
  {
  "id": "Al Jazīrah",
  "description": "Al Jazīrah"
  },
  {
  "id": "Al Qaḑārif",
  "description": "Al Qaḑārif"
  },
  {
  "id": "Blue Nile",
  "description": "Blue Nile"
  },
  {
  "id": "Central Darfur",
  "description": "Central Darfur"
  },
  {
  "id": "Eastern Darfur",
  "description": "Eastern Darfur"
  },
  {
  "id": "Kassala",
  "description": "Kassala"
  },
  {
  "id": "Khartoum",
  "description": "Khartoum"
  },
  {
  "id": "Northern Darfur",
  "description": "Northern Darfur"
  },
  {
  "id": "Northern State",
  "description": "Northern State"
  },
  {
  "id": "North Kordofan",
  "description": "North Kordofan"
  },
  {
  "id": "Red Sea",
  "description": "Red Sea"
  },
  {
  "id": "River Nile",
  "description": "River Nile"
  },
  {
  "id": "Sinnār",
  "description": "Sinnār"
  },
  {
  "id": "Southern Darfur",
  "description": "Southern Darfur"
  },
  {
  "id": "Southern Kordofan",
  "description": "Southern Kordofan"
  },
  {
  "id": "Western Darfur",
  "description": "Western Darfur"
  },
  {
  "id": "West Kordofan State",
  "description": "West Kordofan State"
  },
  {
  "id": "White Nile",
  "description": "White Nile"
  }
  ]
  },
  {
  "code": "SR",
  "description": "Suriname",
  "regions": [
  {
  "id": "Brokopondo District",
  "description": "Brokopondo District"
  },
  {
  "id": "Commewijne District",
  "description": "Commewijne District"
  },
  {
  "id": "Coronie District",
  "description": "Coronie District"
  },
  {
  "id": "Marowijne District",
  "description": "Marowijne District"
  },
  {
  "id": "Nickerie District",
  "description": "Nickerie District"
  },
  {
  "id": "Para District",
  "description": "Para District"
  },
  {
  "id": "Paramaribo District",
  "description": "Paramaribo District"
  },
  {
  "id": "Saramacca District",
  "description": "Saramacca District"
  },
  {
  "id": "Sipaliwini District",
  "description": "Sipaliwini District"
  },
  {
  "id": "Wanica District",
  "description": "Wanica District"
  }
  ]
  },
  {
  "code": "SZ",
  "description": "Swaziland",
  "regions": [
  {
  "id": "Hhohho Region",
  "description": "Hhohho Region"
  },
  {
  "id": "Lubombo Region",
  "description": "Lubombo Region"
  },
  {
  "id": "Manzini Region",
  "description": "Manzini Region"
  },
  {
  "id": "Shiselweni",
  "description": "Shiselweni"
  }
  ]
  },
  {
  "code": "SE",
  "description": "Sweden",
  "regions": [
  {
  "id": "Blekinge",
  "description": "Blekinge"
  },
  {
  "id": "Dalarna",
  "description": "Dalarna"
  },
  {
  "id": "Gävleborg",
  "description": "Gävleborg"
  },
  {
  "id": "Gotland",
  "description": "Gotland"
  },
  {
  "id": "Halland",
  "description": "Halland"
  },
  {
  "id": "Jämtland",
  "description": "Jämtland"
  },
  {
  "id": "Jönköping",
  "description": "Jönköping"
  },
  {
  "id": "Kalmar",
  "description": "Kalmar"
  },
  {
  "id": "Kronoberg",
  "description": "Kronoberg"
  },
  {
  "id": "Norrbotten",
  "description": "Norrbotten"
  },
  {
  "id": "Örebro",
  "description": "Örebro"
  },
  {
  "id": "Östergötland",
  "description": "Östergötland"
  },
  {
  "id": "Skåne",
  "description": "Skåne"
  },
  {
  "id": "Södermanland",
  "description": "Södermanland"
  },
  {
  "id": "Stockholm",
  "description": "Stockholm"
  },
  {
  "id": "Uppsala",
  "description": "Uppsala"
  },
  {
  "id": "Värmland",
  "description": "Värmland"
  },
  {
  "id": "Västerbotten",
  "description": "Västerbotten"
  },
  {
  "id": "Västernorrland",
  "description": "Västernorrland"
  },
  {
  "id": "Västmanland",
  "description": "Västmanland"
  },
  {
  "id": "Västra Götaland",
  "description": "Västra Götaland"
  }
  ]
  },
  {
  "code": "CH",
  "description": "Switzerland",
  "regions": [
  {
  "id": "Aargau",
  "description": "Aargau"
  },
  {
  "id": "Appenzell Ausserrhoden",
  "description": "Appenzell Ausserrhoden"
  },
  {
  "id": "Appenzell Innerrhoden",
  "description": "Appenzell Innerrhoden"
  },
  {
  "id": "Basel-City",
  "description": "Basel-City"
  },
  {
  "id": "Basel-Landschaft",
  "description": "Basel-Landschaft"
  },
  {
  "id": "Bern",
  "description": "Bern"
  },
  {
  "id": "Fribourg",
  "description": "Fribourg"
  },
  {
  "id": "Geneva",
  "description": "Geneva"
  },
  {
  "id": "Glarus",
  "description": "Glarus"
  },
  {
  "id": "Grisons",
  "description": "Grisons"
  },
  {
  "id": "Jura",
  "description": "Jura"
  },
  {
  "id": "Lucerne",
  "description": "Lucerne"
  },
  {
  "id": "Neuchâtel",
  "description": "Neuchâtel"
  },
  {
  "id": "Nidwalden",
  "description": "Nidwalden"
  },
  {
  "id": "Obwalden",
  "description": "Obwalden"
  },
  {
  "id": "Saint Gallen",
  "description": "Saint Gallen"
  },
  {
  "id": "Schaffhausen",
  "description": "Schaffhausen"
  },
  {
  "id": "Schwyz",
  "description": "Schwyz"
  },
  {
  "id": "Solothurn",
  "description": "Solothurn"
  },
  {
  "id": "Thurgau",
  "description": "Thurgau"
  },
  {
  "id": "Ticino",
  "description": "Ticino"
  },
  {
  "id": "Uri",
  "description": "Uri"
  },
  {
  "id": "Valais",
  "description": "Valais"
  },
  {
  "id": "Vaud",
  "description": "Vaud"
  },
  {
  "id": "Zug",
  "description": "Zug"
  },
  {
  "id": "Zurich",
  "description": "Zurich"
  }
  ]
  },
  {
  "code": "SY",
  "description": "Syria",
  "regions": [
  {
  "id": "Aleppo",
  "description": "Aleppo"
  },
  {
  "id": "Al-Hasakah",
  "description": "Al-Hasakah"
  },
  {
  "id": "Ar-Raqqah",
  "description": "Ar-Raqqah"
  },
  {
  "id": "As-Suwayda",
  "description": "As-Suwayda"
  },
  {
  "id": "Daraa",
  "description": "Daraa"
  },
  {
  "id": "Deir ez-Zor",
  "description": "Deir ez-Zor"
  },
  {
  "id": "Dimashq",
  "description": "Dimashq"
  },
  {
  "id": "Hama",
  "description": "Hama"
  },
  {
  "id": "Homs",
  "description": "Homs"
  },
  {
  "id": "Idlib",
  "description": "Idlib"
  },
  {
  "id": "Latakia",
  "description": "Latakia"
  },
  {
  "id": "Quneitra",
  "description": "Quneitra"
  },
  {
  "id": "Rif-dimashq",
  "description": "Rif-dimashq"
  },
  {
  "id": "Tartus",
  "description": "Tartus"
  }
  ]
  },
  {
  "code": "TW",
  "description": "Taiwan",
  "regions": [
  {
  "id": "Fukien",
  "description": "Fukien"
  },
  {
  "id": "Taipei",
  "description": "Taipei"
  },
  {
  "id": "Taiwan",
  "description": "Taiwan"
  },
  {
  "id": "Takao",
  "description": "Takao"
  }
  ]
  },
  {
  "code": "TJ",
  "description": "Tajikistan",
  "regions": [
  {
  "id": "Dushanbe",
  "description": "Dushanbe"
  },
  {
  "id": "Gorno-Badakhshan",
  "description": "Gorno-Badakhshan"
  },
  {
  "id": "Khatlon Province",
  "description": "Khatlon Province"
  },
  {
  "id": "Republican Subordination",
  "description": "Republican Subordination"
  },
  {
  "id": "Sughd",
  "description": "Sughd"
  }
  ]
  },
  {
  "code": "TZ",
  "description": "Tanzania",
  "regions": [
  {
  "id": "Arusha",
  "description": "Arusha"
  },
  {
  "id": "Dar es Salaam Region",
  "description": "Dar es Salaam Region"
  },
  {
  "id": "Dodoma",
  "description": "Dodoma"
  },
  {
  "id": "Geita",
  "description": "Geita"
  },
  {
  "id": "Iringa",
  "description": "Iringa"
  },
  {
  "id": "Kagera",
  "description": "Kagera"
  },
  {
  "id": "Katavi",
  "description": "Katavi"
  },
  {
  "id": "Kigoma",
  "description": "Kigoma"
  },
  {
  "id": "Kilimanjaro",
  "description": "Kilimanjaro"
  },
  {
  "id": "Lindi",
  "description": "Lindi"
  },
  {
  "id": "Manyara",
  "description": "Manyara"
  },
  {
  "id": "Mara",
  "description": "Mara"
  },
  {
  "id": "Mbeya",
  "description": "Mbeya"
  },
  {
  "id": "Morogoro",
  "description": "Morogoro"
  },
  {
  "id": "Mtwara",
  "description": "Mtwara"
  },
  {
  "id": "Mwanza",
  "description": "Mwanza"
  },
  {
  "id": "Njombe",
  "description": "Njombe"
  },
  {
  "id": "Pemba North",
  "description": "Pemba North"
  },
  {
  "id": "Pemba South",
  "description": "Pemba South"
  },
  {
  "id": "Pwani",
  "description": "Pwani"
  },
  {
  "id": "Rukwa",
  "description": "Rukwa"
  },
  {
  "id": "Ruvuma",
  "description": "Ruvuma"
  },
  {
  "id": "Shinyanga",
  "description": "Shinyanga"
  },
  {
  "id": "Simiyu",
  "description": "Simiyu"
  },
  {
  "id": "Singida",
  "description": "Singida"
  },
  {
  "id": "Songwe",
  "description": "Songwe"
  },
  {
  "id": "Tabora",
  "description": "Tabora"
  },
  {
  "id": "Tanga",
  "description": "Tanga"
  },
  {
  "id": "Zanzibar Central/South",
  "description": "Zanzibar Central/South"
  },
  {
  "id": "Zanzibar North",
  "description": "Zanzibar North"
  },
  {
  "id": "Zanzibar Urban/West",
  "description": "Zanzibar Urban/West"
  }
  ]
  },
  {
  "code": "TH",
  "description": "Thailand",
  "regions": [
  {
  "id": "Amnat Charoen",
  "description": "Amnat Charoen"
  },
  {
  "id": "Ang Thong",
  "description": "Ang Thong"
  },
  {
  "id": "Bangkok",
  "description": "Bangkok"
  },
  {
  "id": "Bueng Kan",
  "description": "Bueng Kan"
  },
  {
  "id": "Buriram",
  "description": "Buriram"
  },
  {
  "id": "Chachoengsao",
  "description": "Chachoengsao"
  },
  {
  "id": "Chai Nat",
  "description": "Chai Nat"
  },
  {
  "id": "Chaiyaphum",
  "description": "Chaiyaphum"
  },
  {
  "id": "Chanthaburi",
  "description": "Chanthaburi"
  },
  {
  "id": "Chiang Mai",
  "description": "Chiang Mai"
  },
  {
  "id": "Chiang Rai",
  "description": "Chiang Rai"
  },
  {
  "id": "Chon Buri",
  "description": "Chon Buri"
  },
  {
  "id": "Chumphon",
  "description": "Chumphon"
  },
  {
  "id": "Kalasin",
  "description": "Kalasin"
  },
  {
  "id": "Kamphaeng Phet",
  "description": "Kamphaeng Phet"
  },
  {
  "id": "Kanchanaburi",
  "description": "Kanchanaburi"
  },
  {
  "id": "Khon Kaen",
  "description": "Khon Kaen"
  },
  {
  "id": "Krabi",
  "description": "Krabi"
  },
  {
  "id": "Lampang",
  "description": "Lampang"
  },
  {
  "id": "Lamphun",
  "description": "Lamphun"
  },
  {
  "id": "Loei",
  "description": "Loei"
  },
  {
  "id": "Lopburi",
  "description": "Lopburi"
  },
  {
  "id": "Mae Hong Son",
  "description": "Mae Hong Son"
  },
  {
  "id": "Maha Sarakham",
  "description": "Maha Sarakham"
  },
  {
  "id": "Mukdahan",
  "description": "Mukdahan"
  },
  {
  "id": "Nakhon Nayok",
  "description": "Nakhon Nayok"
  },
  {
  "id": "Nakhon Pathom",
  "description": "Nakhon Pathom"
  },
  {
  "id": "Nakhon Phanom",
  "description": "Nakhon Phanom"
  },
  {
  "id": "Nakhon Ratchasima",
  "description": "Nakhon Ratchasima"
  },
  {
  "id": "Nakhon Sawan",
  "description": "Nakhon Sawan"
  },
  {
  "id": "Nakhon Si Thammarat",
  "description": "Nakhon Si Thammarat"
  },
  {
  "id": "Nan",
  "description": "Nan"
  },
  {
  "id": "Narathiwat",
  "description": "Narathiwat"
  },
  {
  "id": "Nong Bua Lamphu",
  "description": "Nong Bua Lamphu"
  },
  {
  "id": "Nong Khai",
  "description": "Nong Khai"
  },
  {
  "id": "Nonthaburi",
  "description": "Nonthaburi"
  },
  {
  "id": "Pathum Thani",
  "description": "Pathum Thani"
  },
  {
  "id": "Pattani",
  "description": "Pattani"
  },
  {
  "id": "Phang Nga",
  "description": "Phang Nga"
  },
  {
  "id": "Phatthalung",
  "description": "Phatthalung"
  },
  {
  "id": "Phayao",
  "description": "Phayao"
  },
  {
  "id": "Phetchabun",
  "description": "Phetchabun"
  },
  {
  "id": "Phetchaburi",
  "description": "Phetchaburi"
  },
  {
  "id": "Phichit",
  "description": "Phichit"
  },
  {
  "id": "Phitsanulok",
  "description": "Phitsanulok"
  },
  {
  "id": "Phrae",
  "description": "Phrae"
  },
  {
  "id": "Phra Nakhon Si Ayutthaya",
  "description": "Phra Nakhon Si Ayutthaya"
  },
  {
  "id": "Phuket",
  "description": "Phuket"
  },
  {
  "id": "Prachin Buri",
  "description": "Prachin Buri"
  },
  {
  "id": "Prachuap Khiri Khan",
  "description": "Prachuap Khiri Khan"
  },
  {
  "id": "Ranong province",
  "description": "Ranong province"
  },
  {
  "id": "Ratchaburi",
  "description": "Ratchaburi"
  },
  {
  "id": "Rayong",
  "description": "Rayong"
  },
  {
  "id": "Roi Et",
  "description": "Roi Et"
  },
  {
  "id": "Sa Kaeo",
  "description": "Sa Kaeo"
  },
  {
  "id": "Sakon Nakhon",
  "description": "Sakon Nakhon"
  },
  {
  "id": "Samut Prakan",
  "description": "Samut Prakan"
  },
  {
  "id": "Samut Sakhon",
  "description": "Samut Sakhon"
  },
  {
  "id": "Samut Songkhram",
  "description": "Samut Songkhram"
  },
  {
  "id": "Saraburi",
  "description": "Saraburi"
  },
  {
  "id": "Satun",
  "description": "Satun"
  },
  {
  "id": "Sing Buri",
  "description": "Sing Buri"
  },
  {
  "id": "Si Sa Ket",
  "description": "Si Sa Ket"
  },
  {
  "id": "Songkhla",
  "description": "Songkhla"
  },
  {
  "id": "Sukhothai",
  "description": "Sukhothai"
  },
  {
  "id": "Suphan Buri",
  "description": "Suphan Buri"
  },
  {
  "id": "Surat Thani",
  "description": "Surat Thani"
  },
  {
  "id": "Surin",
  "description": "Surin"
  },
  {
  "id": "Tak",
  "description": "Tak"
  },
  {
  "id": "Trang",
  "description": "Trang"
  },
  {
  "id": "Trat",
  "description": "Trat"
  },
  {
  "id": "Ubon Ratchathani",
  "description": "Ubon Ratchathani"
  },
  {
  "id": "Udon Thani",
  "description": "Udon Thani"
  },
  {
  "id": "Uthai Thani",
  "description": "Uthai Thani"
  },
  {
  "id": "Uttaradit",
  "description": "Uttaradit"
  },
  {
  "id": "Yala",
  "description": "Yala"
  },
  {
  "id": "Yasothon",
  "description": "Yasothon"
  }
  ]
  },
  {
  "code": "TL",
  "description": "Timor-Leste",
  "regions": [
  {
  "id": "Aileu",
  "description": "Aileu"
  },
  {
  "id": "Ainaro",
  "description": "Ainaro"
  },
  {
  "id": "Baucau",
  "description": "Baucau"
  },
  {
  "id": "Bobonaro",
  "description": "Bobonaro"
  },
  {
  "id": "Cova Lima",
  "description": "Cova Lima"
  },
  {
  "id": "Dili Municipality",
  "description": "Dili Municipality"
  },
  {
  "id": "Ermera",
  "description": "Ermera"
  },
  {
  "id": "Lautém",
  "description": "Lautém"
  },
  {
  "id": "Liquiçá",
  "description": "Liquiçá"
  },
  {
  "id": "Manatuto",
  "description": "Manatuto"
  },
  {
  "id": "Manufahi",
  "description": "Manufahi"
  },
  {
  "id": "Oecusse",
  "description": "Oecusse"
  },
  {
  "id": "Viqueque",
  "description": "Viqueque"
  }
  ]
  },
  {
  "code": "TG",
  "description": "Togo",
  "regions": [
  {
  "id": "Centrale",
  "description": "Centrale"
  },
  {
  "id": "Kara",
  "description": "Kara"
  },
  {
  "id": "Maritime",
  "description": "Maritime"
  },
  {
  "id": "Plateaux",
  "description": "Plateaux"
  },
  {
  "id": "Savanes",
  "description": "Savanes"
  }
  ]
  },
  {
  "code": "TO",
  "description": "Tonga",
  "regions": [
  {
  "id": "Ha‘apai",
  "description": "Ha‘apai"
  },
  {
  "id": "ʻEua",
  "description": "ʻEua"
  },
  {
  "id": "Niuas",
  "description": "Niuas"
  },
  {
  "id": "Tongatapu",
  "description": "Tongatapu"
  },
  {
  "id": "Vava‘u",
  "description": "Vava‘u"
  }
  ]
  },
  {
  "code": "TT",
  "description": "Trinidad and Tobago",
  "regions": [
  {
  "id": "Borough of Arima",
  "description": "Borough of Arima"
  },
  {
  "id": "Chaguanas",
  "description": "Chaguanas"
  },
  {
  "id": "Couva-Tabaquite-Talparo",
  "description": "Couva-Tabaquite-Talparo"
  },
  {
  "id": "Diego Martin Regional Corporation",
  "description": "Diego Martin Regional Corporation"
  },
  {
  "id": "Mayaro",
  "description": "Mayaro"
  },
  {
  "id": "Penal/Debe",
  "description": "Penal/Debe"
  },
  {
  "id": "Point Fortin",
  "description": "Point Fortin"
  },
  {
  "id": "Port of Spain",
  "description": "Port of Spain"
  },
  {
  "id": "Princes Town",
  "description": "Princes Town"
  },
  {
  "id": "San Fernando",
  "description": "San Fernando"
  },
  {
  "id": "Sangre Grande Regional Corporation",
  "description": "Sangre Grande Regional Corporation"
  },
  {
  "id": "San Juan/Laventille",
  "description": "San Juan/Laventille"
  },
  {
  "id": "Siparia Regional Corporation",
  "description": "Siparia Regional Corporation"
  },
  {
  "id": "Tobago",
  "description": "Tobago"
  },
  {
  "id": "Tunapuna/Piarco",
  "description": "Tunapuna/Piarco"
  }
  ]
  },
  {
  "code": "TN",
  "description": "Tunisia",
  "regions": [
  {
  "id": "Ariana Governorate",
  "description": "Ariana Governorate"
  },
  {
  "id": "Béja Governorate",
  "description": "Béja Governorate"
  },
  {
  "id": "Ben Arous Governorate",
  "description": "Ben Arous Governorate"
  },
  {
  "id": "Bizerte Governorate",
  "description": "Bizerte Governorate"
  },
  {
  "id": "Gabès Governorate",
  "description": "Gabès Governorate"
  },
  {
  "id": "Gafsa",
  "description": "Gafsa"
  },
  {
  "id": "Jendouba Governorate",
  "description": "Jendouba Governorate"
  },
  {
  "id": "Kairouan",
  "description": "Kairouan"
  },
  {
  "id": "Kasserine Governorate",
  "description": "Kasserine Governorate"
  },
  {
  "id": "Kebili Governorate",
  "description": "Kebili Governorate"
  },
  {
  "id": "Kef Governorate",
  "description": "Kef Governorate"
  },
  {
  "id": "Mahdia Governorate",
  "description": "Mahdia Governorate"
  },
  {
  "id": "Manouba",
  "description": "Manouba"
  },
  {
  "id": "Medenine Governorate",
  "description": "Medenine Governorate"
  },
  {
  "id": "Monastir Governorate",
  "description": "Monastir Governorate"
  },
  {
  "id": "Nabeul Governorate",
  "description": "Nabeul Governorate"
  },
  {
  "id": "Sfax Governorate",
  "description": "Sfax Governorate"
  },
  {
  "id": "Sidi Bouzid Governorate",
  "description": "Sidi Bouzid Governorate"
  },
  {
  "id": "Siliana Governorate",
  "description": "Siliana Governorate"
  },
  {
  "id": "Sousse Governorate",
  "description": "Sousse Governorate"
  },
  {
  "id": "Tataouine",
  "description": "Tataouine"
  },
  {
  "id": "Tozeur Governorate",
  "description": "Tozeur Governorate"
  },
  {
  "id": "Tunis Governorate",
  "description": "Tunis Governorate"
  },
  {
  "id": "Zaghouan Governorate",
  "description": "Zaghouan Governorate"
  }
  ]
  },
  {
  "code": "TR",
  "description": "Turkey",
  "regions": [
  {
  "id": "Adana",
  "description": "Adana"
  },
  {
  "id": "Adıyaman Province",
  "description": "Adıyaman Province"
  },
  {
  "id": "Afyonkarahisar Province",
  "description": "Afyonkarahisar Province"
  },
  {
  "id": "Ağrı",
  "description": "Ağrı"
  },
  {
  "id": "Aksaray",
  "description": "Aksaray"
  },
  {
  "id": "Amasya",
  "description": "Amasya"
  },
  {
  "id": "Ankara",
  "description": "Ankara"
  },
  {
  "id": "Antalya",
  "description": "Antalya"
  },
  {
  "id": "Ardahan",
  "description": "Ardahan"
  },
  {
  "id": "Artvin",
  "description": "Artvin"
  },
  {
  "id": "Aydın",
  "description": "Aydın"
  },
  {
  "id": "Balıkesir",
  "description": "Balıkesir"
  },
  {
  "id": "Bartın",
  "description": "Bartın"
  },
  {
  "id": "Batman",
  "description": "Batman"
  },
  {
  "id": "Bayburt Province",
  "description": "Bayburt Province"
  },
  {
  "id": "Bilecik",
  "description": "Bilecik"
  },
  {
  "id": "Bingöl",
  "description": "Bingöl"
  },
  {
  "id": "Bitlis",
  "description": "Bitlis"
  },
  {
  "id": "Bolu",
  "description": "Bolu"
  },
  {
  "id": "Burdur",
  "description": "Burdur"
  },
  {
  "id": "Bursa Province",
  "description": "Bursa Province"
  },
  {
  "id": "Canakkale",
  "description": "Canakkale"
  },
  {
  "id": "Çankırı",
  "description": "Çankırı"
  },
  {
  "id": "Çorum",
  "description": "Çorum"
  },
  {
  "id": "Denizli",
  "description": "Denizli"
  },
  {
  "id": "Diyarbakır Province",
  "description": "Diyarbakır Province"
  },
  {
  "id": "Düzce",
  "description": "Düzce"
  },
  {
  "id": "Edirne",
  "description": "Edirne"
  },
  {
  "id": "Elazığ",
  "description": "Elazığ"
  },
  {
  "id": "Erzincan",
  "description": "Erzincan"
  },
  {
  "id": "Erzurum",
  "description": "Erzurum"
  },
  {
  "id": "Eskişehir",
  "description": "Eskişehir"
  },
  {
  "id": "Gaziantep",
  "description": "Gaziantep"
  },
  {
  "id": "Giresun",
  "description": "Giresun"
  },
  {
  "id": "Gümüşhane Province",
  "description": "Gümüşhane Province"
  },
  {
  "id": "Hakkâri",
  "description": "Hakkâri"
  },
  {
  "id": "Hatay",
  "description": "Hatay"
  },
  {
  "id": "Iğdır",
  "description": "Iğdır"
  },
  {
  "id": "Isparta",
  "description": "Isparta"
  },
  {
  "id": "Istanbul",
  "description": "Istanbul"
  },
  {
  "id": "İzmir Province",
  "description": "İzmir Province"
  },
  {
  "id": "Kahramanmaraş",
  "description": "Kahramanmaraş"
  },
  {
  "id": "Karabük Province",
  "description": "Karabük Province"
  },
  {
  "id": "Karaman",
  "description": "Karaman"
  },
  {
  "id": "Kars Province",
  "description": "Kars Province"
  },
  {
  "id": "Kastamonu",
  "description": "Kastamonu"
  },
  {
  "id": "Kayseri",
  "description": "Kayseri"
  },
  {
  "id": "Kilis",
  "description": "Kilis"
  },
  {
  "id": "Kırıkkale",
  "description": "Kırıkkale"
  },
  {
  "id": "Kırklareli",
  "description": "Kırklareli"
  },
  {
  "id": "Kırşehir",
  "description": "Kırşehir"
  },
  {
  "id": "Kocaeli",
  "description": "Kocaeli"
  },
  {
  "id": "Konya",
  "description": "Konya"
  },
  {
  "id": "Kütahya",
  "description": "Kütahya"
  },
  {
  "id": "Malatya",
  "description": "Malatya"
  },
  {
  "id": "Manisa",
  "description": "Manisa"
  },
  {
  "id": "Mardin",
  "description": "Mardin"
  },
  {
  "id": "Mersin",
  "description": "Mersin"
  },
  {
  "id": "Muğla",
  "description": "Muğla"
  },
  {
  "id": "Muş",
  "description": "Muş"
  },
  {
  "id": "Nevşehir Province",
  "description": "Nevşehir Province"
  },
  {
  "id": "Niğde Province",
  "description": "Niğde Province"
  },
  {
  "id": "Ordu",
  "description": "Ordu"
  },
  {
  "id": "Osmaniye",
  "description": "Osmaniye"
  },
  {
  "id": "Rize Province",
  "description": "Rize Province"
  },
  {
  "id": "Sakarya",
  "description": "Sakarya"
  },
  {
  "id": "Samsun",
  "description": "Samsun"
  },
  {
  "id": "Şanlıurfa",
  "description": "Şanlıurfa"
  },
  {
  "id": "Siirt",
  "description": "Siirt"
  },
  {
  "id": "Sinop",
  "description": "Sinop"
  },
  {
  "id": "Sivas",
  "description": "Sivas"
  },
  {
  "id": "Şırnak",
  "description": "Şırnak"
  },
  {
  "id": "Tekirdağ",
  "description": "Tekirdağ"
  },
  {
  "id": "Tokat Province",
  "description": "Tokat Province"
  },
  {
  "id": "Trabzon",
  "description": "Trabzon"
  },
  {
  "id": "Tunceli",
  "description": "Tunceli"
  },
  {
  "id": "Uşak",
  "description": "Uşak"
  },
  {
  "id": "Van",
  "description": "Van"
  },
  {
  "id": "Yalova",
  "description": "Yalova"
  },
  {
  "id": "Yozgat",
  "description": "Yozgat"
  },
  {
  "id": "Zonguldak Province",
  "description": "Zonguldak Province"
  }
  ]
  },
  {
  "code": "TM",
  "description": "Turkmenistan",
  "regions": [
  {
  "id": "Ahal",
  "description": "Ahal"
  },
  {
  "id": "Ashgabat",
  "description": "Ashgabat"
  },
  {
  "id": "Balkan",
  "description": "Balkan"
  },
  {
  "id": "Daşoguz",
  "description": "Daşoguz"
  },
  {
  "id": "Lebap",
  "description": "Lebap"
  },
  {
  "id": "Mary",
  "description": "Mary"
  }
  ]
  },
  {
  "code": "TC",
  "description": "Turks and Caicos Islands",
  "regions": []
  },
  {
  "code": "TV",
  "description": "Tuvalu",
  "regions": [
  {
  "id": "Funafuti",
  "description": "Funafuti"
  },
  {
  "id": "Nanumanga",
  "description": "Nanumanga"
  },
  {
  "id": "Nanumea",
  "description": "Nanumea"
  },
  {
  "id": "Niutao",
  "description": "Niutao"
  },
  {
  "id": "Nui",
  "description": "Nui"
  },
  {
  "id": "Nukufetau",
  "description": "Nukufetau"
  },
  {
  "id": "Nukulaelae",
  "description": "Nukulaelae"
  },
  {
  "id": "Vaitupu",
  "description": "Vaitupu"
  }
  ]
  },
  {
  "code": "UG",
  "description": "Uganda",
  "regions": [
  {
  "id": "Central Region",
  "description": "Central Region"
  },
  {
  "id": "Eastern Region",
  "description": "Eastern Region"
  },
  {
  "id": "Northern Region",
  "description": "Northern Region"
  },
  {
  "id": "Western Region",
  "description": "Western Region"
  }
  ]
  },
  {
  "code": "UA",
  "description": "Ukraine",
  "regions": [
  {
  "id": "Cherkasy",
  "description": "Cherkasy"
  },
  {
  "id": "Chernihiv",
  "description": "Chernihiv"
  },
  {
  "id": "Chernivtsi",
  "description": "Chernivtsi"
  },
  {
  "id": "Crimea",
  "description": "Crimea"
  },
  {
  "id": "Dnipropetrovsk",
  "description": "Dnipropetrovsk"
  },
  {
  "id": "Donetsk",
  "description": "Donetsk"
  },
  {
  "id": "Ivano-Frankivsk",
  "description": "Ivano-Frankivsk"
  },
  {
  "id": "Kharkivs’ka Oblast’",
  "description": "Kharkivs’ka Oblast’"
  },
  {
  "id": "Kherson",
  "description": "Kherson"
  },
  {
  "id": "Khmelnytskyi",
  "description": "Khmelnytskyi"
  },
  {
  "id": "Kiev",
  "description": "Kiev"
  },
  {
  "id": "Kirovohrad",
  "description": "Kirovohrad"
  },
  {
  "id": "Kyiv City",
  "description": "Kyiv City"
  },
  {
  "id": "Luhansk",
  "description": "Luhansk"
  },
  {
  "id": "Lviv",
  "description": "Lviv"
  },
  {
  "id": "Mykolaiv",
  "description": "Mykolaiv"
  },
  {
  "id": "Odessa",
  "description": "Odessa"
  },
  {
  "id": "Poltava",
  "description": "Poltava"
  },
  {
  "id": "Rivne",
  "description": "Rivne"
  },
  {
  "id": "Sevastopol City",
  "description": "Sevastopol City"
  },
  {
  "id": "Sumy",
  "description": "Sumy"
  },
  {
  "id": "Ternopil",
  "description": "Ternopil"
  },
  {
  "id": "Transcarpathia",
  "description": "Transcarpathia"
  },
  {
  "id": "Vinnytsia",
  "description": "Vinnytsia"
  },
  {
  "id": "Volyn",
  "description": "Volyn"
  },
  {
  "id": "Zaporizhzhia",
  "description": "Zaporizhzhia"
  },
  {
  "id": "Zhytomyr",
  "description": "Zhytomyr"
  }
  ]
  },
  {
  "code": "AE",
  "description": "United Arab Emirates",
  "regions": [
  {
  "id": " ",
  "description": "State Unknown"
  }
  ]
  },
  {
  "code": "GB",
  "description": "United Kingdom",
  "regions": [
  {
  "id": "England",
  "description": "England"
  },
  {
  "id": "Northern Ireland",
  "description": "Northern Ireland"
  },
  {
  "id": "Scotland",
  "description": "Scotland"
  },
  {
  "id": "Wales",
  "description": "Wales"
  }
  ]
  },
  {
  "code": "UM",
  "description": "United States Minor Outlying Islands",
  "regions": [
  {
  "id": "Baker Island",
  "description": "Baker Island"
  },
  {
  "id": "Howland Island",
  "description": "Howland Island"
  },
  {
  "id": "Jarvis Island",
  "description": "Jarvis Island"
  },
  {
  "id": "Johnston Atoll",
  "description": "Johnston Atoll"
  },
  {
  "id": "Kingman Reef",
  "description": "Kingman Reef"
  },
  {
  "id": "Midway Islands",
  "description": "Midway Islands"
  },
  {
  "id": "Navassa Island",
  "description": "Navassa Island"
  },
  {
  "id": "Palmyra Atoll",
  "description": "Palmyra Atoll"
  },
  {
  "id": "Wake Island",
  "description": "Wake Island"
  }
  ]
  },
  {
  "code": "USA",
  "description": "United States of America",
  "regions": [
  {
  "id": "AA",
  "description": "Armed Forces Americas"
  },
  {
  "id": "AE",
  "description": "Armed Forces Europe"
  },
  {
  "id": "AK",
  "description": "Alaska"
  },
  {
  "id": "AL",
  "description": "Alabama"
  },
  {
  "id": "AP",
  "description": "Armed Forces Pacific"
  },
  {
  "id": "AR",
  "description": "Arkansas"
  },
  {
  "id": "AZ",
  "description": "Arizona"
  },
  {
  "id": "CA",
  "description": "California"
  },
  {
  "id": "CO",
  "description": "Colorado"
  },
  {
  "id": "CT",
  "description": "Connecticut"
  },
  {
  "id": "DC",
  "description": "District of Columbia"
  },
  {
  "id": "DE",
  "description": "Delaware"
  },
  {
  "id": "FL",
  "description": "Florida"
  },
  {
  "id": "GA",
  "description": "Georgia"
  },
  {
  "id": "GU",
  "description": "Guam"
  },
  {
  "id": "HI",
  "description": "Hawaii"
  },
  {
  "id": "IA",
  "description": "Iowa"
  },
  {
  "id": "ID",
  "description": "Idaho"
  },
  {
  "id": "IL",
  "description": "Illinois"
  },
  {
  "id": "IN",
  "description": "Indiana"
  },
  {
  "id": "KS",
  "description": "Kansas"
  },
  {
  "id": "KY",
  "description": "Kentucky"
  },
  {
  "id": "LA",
  "description": "Louisiana"
  },
  {
  "id": "MA",
  "description": "Massachusetts"
  },
  {
  "id": "MD",
  "description": "Maryland"
  },
  {
  "id": "ME",
  "description": "Maine"
  },
  {
  "id": "MI",
  "description": "Michigan"
  },
  {
  "id": "MN",
  "description": "Minnesota"
  },
  {
  "id": "MO",
  "description": "Missouri"
  },
  {
  "id": "MS",
  "description": "Mississippi"
  },
  {
  "id": "MT",
  "description": "Montana"
  },
  {
  "id": "NC",
  "description": "North Carolina"
  },
  {
  "id": "ND",
  "description": "North Dakota"
  },
  {
  "id": "NE",
  "description": "Nebraska"
  },
  {
  "id": "NH",
  "description": "New Hampshire"
  },
  {
  "id": "NJ",
  "description": "New Jersey"
  },
  {
  "id": "NM",
  "description": "New Mexico"
  },
  {
  "id": "NV",
  "description": "Nevada"
  },
  {
  "id": "NY",
  "description": "New York"
  },
  {
  "id": "OH",
  "description": "Ohio"
  },
  {
  "id": "OK",
  "description": "Oklahoma"
  },
  {
  "id": "OR",
  "description": "Oregon"
  },
  {
  "id": "PA",
  "description": "Pennsylvania"
  },
  {
  "id": "PR",
  "description": "Puerto Rico"
  },
  {
  "id": "PW",
  "description": "Palau"
  },
  {
  "id": "RI",
  "description": "Rhode Island"
  },
  {
  "id": "SC",
  "description": "South Carolina"
  },
  {
  "id": "SD",
  "description": "South Dakota"
  },
  {
  "id": "TN",
  "description": "Tennessee"
  },
  {
  "id": "TX",
  "description": "Texas"
  },
  {
  "id": "UT",
  "description": "Utah"
  },
  {
  "id": "VA",
  "description": "Virginia"
  },
  {
  "id": "VI",
  "description": "Virgin Islands"
  },
  {
  "id": "VT",
  "description": "Vermont"
  },
  {
  "id": "WA",
  "description": "Washington"
  },
  {
  "id": "WI",
  "description": "Wisconsin"
  },
  {
  "id": "WV",
  "description": "West Virginia"
  },
  {
  "id": "WY",
  "description": "Wyoming"
  }
  ]
  },
  {
  "code": "UY",
  "description": "Uruguay",
  "regions": [
  {
  "id": "Artigas",
  "description": "Artigas"
  },
  {
  "id": "Canelones",
  "description": "Canelones"
  },
  {
  "id": "Cerro Largo",
  "description": "Cerro Largo"
  },
  {
  "id": "Colonia",
  "description": "Colonia"
  },
  {
  "id": "Durazno Department",
  "description": "Durazno Department"
  },
  {
  "id": "Flores Department",
  "description": "Flores Department"
  },
  {
  "id": "Florida",
  "description": "Florida"
  },
  {
  "id": "Lavalleja",
  "description": "Lavalleja"
  },
  {
  "id": "Maldonado",
  "description": "Maldonado"
  },
  {
  "id": "Montevideo Department",
  "description": "Montevideo Department"
  },
  {
  "id": "Paysandú Department",
  "description": "Paysandú Department"
  },
  {
  "id": "Río Negro Department",
  "description": "Río Negro Department"
  },
  {
  "id": "Rivera Department",
  "description": "Rivera Department"
  },
  {
  "id": "Rocha Department",
  "description": "Rocha Department"
  },
  {
  "id": "Salto Department",
  "description": "Salto Department"
  },
  {
  "id": "San José Department",
  "description": "San José Department"
  },
  {
  "id": "Soriano",
  "description": "Soriano"
  },
  {
  "id": "Tacuarembó Department",
  "description": "Tacuarembó Department"
  },
  {
  "id": "Treinta y Tres Department",
  "description": "Treinta y Tres Department"
  }
  ]
  },
  {
  "code": "UZ",
  "description": "Uzbekistan",
  "regions": [
  {
  "id": "Andijan Region",
  "description": "Andijan Region"
  },
  {
  "id": "Bukhara",
  "description": "Bukhara"
  },
  {
  "id": "Fergana",
  "description": "Fergana"
  },
  {
  "id": "Jizzakh Region",
  "description": "Jizzakh Region"
  },
  {
  "id": "Karakalpakstan",
  "description": "Karakalpakstan"
  },
  {
  "id": "Namangan",
  "description": "Namangan"
  },
  {
  "id": "Navoiy Region",
  "description": "Navoiy Region"
  },
  {
  "id": "Qashqadaryo",
  "description": "Qashqadaryo"
  },
  {
  "id": "Samarqand Region",
  "description": "Samarqand Region"
  },
  {
  "id": "Sirdaryo Region",
  "description": "Sirdaryo Region"
  },
  {
  "id": "Surxondaryo Region",
  "description": "Surxondaryo Region"
  },
  {
  "id": "Tashkent",
  "description": "Tashkent"
  },
  {
  "id": "Tashkent Region",
  "description": "Tashkent Region"
  },
  {
  "id": "Xorazm Region",
  "description": "Xorazm Region"
  }
  ]
  },
  {
  "code": "VU",
  "description": "Vanuatu",
  "regions": [
  {
  "id": "Malampa",
  "description": "Malampa"
  },
  {
  "id": "Penama",
  "description": "Penama"
  },
  {
  "id": "Sanma",
  "description": "Sanma"
  },
  {
  "id": "Shefa",
  "description": "Shefa"
  },
  {
  "id": "Tafea",
  "description": "Tafea"
  },
  {
  "id": "Torba",
  "description": "Torba"
  }
  ]
  },
  {
  "code": "VA",
  "description": "Vatican City",
  "regions": []
  },
  {
  "code": "VE",
  "description": "Venezuela",
  "regions": [
  {
  "id": "Amazonas",
  "description": "Amazonas"
  },
  {
  "id": "Anzoátegui",
  "description": "Anzoátegui"
  },
  {
  "id": "Apure",
  "description": "Apure"
  },
  {
  "id": "Aragua",
  "description": "Aragua"
  },
  {
  "id": "Barinas",
  "description": "Barinas"
  },
  {
  "id": "Bolívar",
  "description": "Bolívar"
  },
  {
  "id": "Carabobo",
  "description": "Carabobo"
  },
  {
  "id": "Cojedes",
  "description": "Cojedes"
  },
  {
  "id": "Delta Amacuro",
  "description": "Delta Amacuro"
  },
  {
  "id": "Dependencias Federales",
  "description": "Dependencias Federales"
  },
  {
  "id": "Distrito Federal",
  "description": "Distrito Federal"
  },
  {
  "id": "Falcón",
  "description": "Falcón"
  },
  {
  "id": "Guárico",
  "description": "Guárico"
  },
  {
  "id": "Lara",
  "description": "Lara"
  },
  {
  "id": "Mérida",
  "description": "Mérida"
  },
  {
  "id": "Miranda",
  "description": "Miranda"
  },
  {
  "id": "Monagas",
  "description": "Monagas"
  },
  {
  "id": "Nueva Esparta",
  "description": "Nueva Esparta"
  },
  {
  "id": "Portuguesa",
  "description": "Portuguesa"
  },
  {
  "id": "Sucre",
  "description": "Sucre"
  },
  {
  "id": "Táchira",
  "description": "Táchira"
  },
  {
  "id": "Trujillo",
  "description": "Trujillo"
  },
  {
  "id": "Vargas",
  "description": "Vargas"
  },
  {
  "id": "Yaracuy",
  "description": "Yaracuy"
  },
  {
  "id": "Zulia",
  "description": "Zulia"
  }
  ]
  },
  {
  "code": "VN",
  "description": "Vietnam",
  "regions": [
  {
  "id": "An Giang Province",
  "description": "An Giang Province"
  },
  {
  "id": "Bắc Giang Province",
  "description": "Bắc Giang Province"
  },
  {
  "id": "Bắc Kạn Province",
  "description": "Bắc Kạn Province"
  },
  {
  "id": "Bạc Liêu Province",
  "description": "Bạc Liêu Province"
  },
  {
  "id": "Bắc Ninh Province",
  "description": "Bắc Ninh Province"
  },
  {
  "id": "Bà Rịa–Vũng Tàu Province",
  "description": "Bà Rịa–Vũng Tàu Province"
  },
  {
  "id": "Bến Tre Province",
  "description": "Bến Tre Province"
  },
  {
  "id": "Bình Định Province",
  "description": "Bình Định Province"
  },
  {
  "id": "Bình Dương Province",
  "description": "Bình Dương Province"
  },
  {
  "id": "Bình Phước Province",
  "description": "Bình Phước Province"
  },
  {
  "id": "Bình Thuận Province",
  "description": "Bình Thuận Province"
  },
  {
  "id": "Cà Mau Province",
  "description": "Cà Mau Province"
  },
  {
  "id": "Can Tho",
  "description": "Can Tho"
  },
  {
  "id": "Cao Bằng Province",
  "description": "Cao Bằng Province"
  },
  {
  "id": "Đắk Lắk",
  "description": "Đắk Lắk"
  },
  {
  "id": "Đăk Nông Province",
  "description": "Đăk Nông Province"
  },
  {
  "id": "Da Nang",
  "description": "Da Nang"
  },
  {
  "id": "Điện Biên Province",
  "description": "Điện Biên Province"
  },
  {
  "id": "Đồng Nai Province",
  "description": "Đồng Nai Province"
  },
  {
  "id": "Đồng Tháp Province",
  "description": "Đồng Tháp Province"
  },
  {
  "id": "Gia Lai Province",
  "description": "Gia Lai Province"
  },
  {
  "id": "Hà Giang Province",
  "description": "Hà Giang Province"
  },
  {
  "id": "Hải Dương Province",
  "description": "Hải Dương Province"
  },
  {
  "id": "Haiphong",
  "description": "Haiphong"
  },
  {
  "id": "Hà Nam Province",
  "description": "Hà Nam Province"
  },
  {
  "id": "Hanoi",
  "description": "Hanoi"
  },
  {
  "id": "Hà Tĩnh Province",
  "description": "Hà Tĩnh Province"
  },
  {
  "id": "Hậu Giang",
  "description": "Hậu Giang"
  },
  {
  "id": "Hòa Bình Province",
  "description": "Hòa Bình Province"
  },
  {
  "id": "Ho Chi Minh",
  "description": "Ho Chi Minh"
  },
  {
  "id": "Hưng Yên Province",
  "description": "Hưng Yên Province"
  },
  {
  "id": "Khánh Hòa Province",
  "description": "Khánh Hòa Province"
  },
  {
  "id": "Kiên Giang Province",
  "description": "Kiên Giang Province"
  },
  {
  "id": "Kon Tum",
  "description": "Kon Tum"
  },
  {
  "id": "Lai Châu Province",
  "description": "Lai Châu Province"
  },
  {
  "id": "Lâm Đồng Province",
  "description": "Lâm Đồng Province"
  },
  {
  "id": "Lạng Sơn Province",
  "description": "Lạng Sơn Province"
  },
  {
  "id": "Lào Cai Province",
  "description": "Lào Cai Province"
  },
  {
  "id": "Long An Povince",
  "description": "Long An Povince"
  },
  {
  "id": "Nam Định Province",
  "description": "Nam Định Province"
  },
  {
  "id": "Nghệ An Province",
  "description": "Nghệ An Province"
  },
  {
  "id": "Ninh Bình Province",
  "description": "Ninh Bình Province"
  },
  {
  "id": "Ninh Thuận Province",
  "description": "Ninh Thuận Province"
  },
  {
  "id": "Phú Thọ Province",
  "description": "Phú Thọ Province"
  },
  {
  "id": "Phú Yên Province",
  "description": "Phú Yên Province"
  },
  {
  "id": "Quảng Bình Province",
  "description": "Quảng Bình Province"
  },
  {
  "id": "Quảng Nam Province",
  "description": "Quảng Nam Province"
  },
  {
  "id": "Quảng Ngãi Province",
  "description": "Quảng Ngãi Province"
  },
  {
  "id": "Quảng Ninh",
  "description": "Quảng Ninh"
  },
  {
  "id": "Quảng Trị Province",
  "description": "Quảng Trị Province"
  },
  {
  "id": "Sóc Trăng Province",
  "description": "Sóc Trăng Province"
  },
  {
  "id": "Sơn La Province",
  "description": "Sơn La Province"
  },
  {
  "id": "Tây Ninh Province",
  "description": "Tây Ninh Province"
  },
  {
  "id": "Thái Bình Province",
  "description": "Thái Bình Province"
  },
  {
  "id": "Thái Nguyên Province",
  "description": "Thái Nguyên Province"
  },
  {
  "id": "Thanh Hóa Province",
  "description": "Thanh Hóa Province"
  },
  {
  "id": "Thừa Thiên Huế Province",
  "description": "Thừa Thiên Huế Province"
  },
  {
  "id": "Tiền Giang",
  "description": "Tiền Giang"
  },
  {
  "id": "Trà Vinh Province",
  "description": "Trà Vinh Province"
  },
  {
  "id": "Tuyên Quang Province",
  "description": "Tuyên Quang Province"
  },
  {
  "id": "Vĩnh Long Province",
  "description": "Vĩnh Long Province"
  },
  {
  "id": "Vĩnh Phúc Province",
  "description": "Vĩnh Phúc Province"
  },
  {
  "id": "Yên Bái Province",
  "description": "Yên Bái Province"
  }
  ]
  },
  {
  "code": "VG",
  "description": "Virgin Islands, British",
  "regions": []
  },
  {
  "code": "VI",
  "description": "Virgin Islands, U.S.",
  "regions": [
  {
  "id": "Saint Croix Island",
  "description": "Saint Croix Island"
  },
  {
  "id": "Saint John Island",
  "description": "Saint John Island"
  },
  {
  "id": "Saint Thomas Island",
  "description": "Saint Thomas Island"
  }
  ]
  },
  {
  "code": "WF",
  "description": "Wallis and Futuna",
  "regions": [
  {
  "id": "Alo",
  "description": "Alo"
  },
  {
  "id": "Sigave",
  "description": "Sigave"
  },
  {
  "id": "Uvea",
  "description": "Uvea"
  }
  ]
  },
  {
  "code": "EH",
  "description": "Western Sahara",
  "regions": []
  },
  {
  "code": "WS",
  "description": "Western Samoa",
  "regions": [
  {
  "id": "A'ana",
  "description": "A'ana"
  },
  {
  "id": "Aiga-i-le-Tai",
  "description": "Aiga-i-le-Tai"
  },
  {
  "id": "Atua",
  "description": "Atua"
  },
  {
  "id": "Fa'asaleleaga",
  "description": "Fa'asaleleaga"
  },
  {
  "id": "Gaga'emauga",
  "description": "Gaga'emauga"
  },
  {
  "id": "Gaga'ifomauga",
  "description": "Gaga'ifomauga"
  },
  {
  "id": "Palauli",
  "description": "Palauli"
  },
  {
  "id": "Satupa'itea",
  "description": "Satupa'itea"
  },
  {
  "id": "Tuamasaga",
  "description": "Tuamasaga"
  },
  {
  "id": "Va'a-o-Fonoti",
  "description": "Va'a-o-Fonoti"
  },
  {
  "id": "Vaisigano",
  "description": "Vaisigano"
  }
  ]
  },
  {
  "code": "YE",
  "description": "Yemen",
  "regions": [
  {
  "id": "Abyan Governorate",
  "description": "Abyan Governorate"
  },
  {
  "id": "Aḑ Ḑāli‘",
  "description": "Aḑ Ḑāli‘"
  },
  {
  "id": "Aden",
  "description": "Aden"
  },
  {
  "id": "Al Bayda",
  "description": "Al Bayda"
  },
  {
  "id": "Al Hudaydah",
  "description": "Al Hudaydah"
  },
  {
  "id": "Al Jawf",
  "description": "Al Jawf"
  },
  {
  "id": "Al Mahrah Governorate",
  "description": "Al Mahrah Governorate"
  },
  {
  "id": "Al Mahwit Governorate",
  "description": "Al Mahwit Governorate"
  },
  {
  "id": "Amanat Alasimah",
  "description": "Amanat Alasimah"
  },
  {
  "id": "Dhamār",
  "description": "Dhamār"
  },
  {
  "id": "Ḩajjah",
  "description": "Ḩajjah"
  },
  {
  "id": "Ibb Governorate",
  "description": "Ibb Governorate"
  },
  {
  "id": "Laḩij",
  "description": "Laḩij"
  },
  {
  "id": "Ma’rib",
  "description": "Ma’rib"
  },
  {
  "id": "Muhafazat Hadramaout",
  "description": "Muhafazat Hadramaout"
  },
  {
  "id": "Omran",
  "description": "Omran"
  },
  {
  "id": "Raymah",
  "description": "Raymah"
  },
  {
  "id": "Şa‘dah",
  "description": "Şa‘dah"
  },
  {
  "id": "Sanaa Governorate",
  "description": "Sanaa Governorate"
  },
  {
  "id": "Shabwah",
  "description": "Shabwah"
  },
  {
  "id": "Soqatra",
  "description": "Soqatra"
  },
  {
  "id": "Ta‘izz",
  "description": "Ta‘izz"
  }
  ]
  },
  {
  "code": "YU",
  "description": "Yugoslavia",
  "regions": []
  },
  {
  "code": "ZM",
  "description": "Zambia",
  "regions": [
  {
  "id": "Central Province",
  "description": "Central Province"
  },
  {
  "id": "Copperbelt",
  "description": "Copperbelt"
  },
  {
  "id": "Eastern Province",
  "description": "Eastern Province"
  },
  {
  "id": "Luapula Province",
  "description": "Luapula Province"
  },
  {
  "id": "Lusaka Province",
  "description": "Lusaka Province"
  },
  {
  "id": "Muchinga",
  "description": "Muchinga"
  },
  {
  "id": "Northern Province",
  "description": "Northern Province"
  },
  {
  "id": "North-Western",
  "description": "North-Western"
  },
  {
  "id": "Southern Province",
  "description": "Southern Province"
  },
  {
  "id": "Western Province",
  "description": "Western Province"
  }
  ]
  },
  {
  "code": "ZW",
  "description": "Zimbabwe",
  "regions": [
  {
  "id": "Bulawayo",
  "description": "Bulawayo"
  },
  {
  "id": "Harare",
  "description": "Harare"
  },
  {
  "id": "Manicaland",
  "description": "Manicaland"
  },
  {
  "id": "Mashonaland Central",
  "description": "Mashonaland Central"
  },
  {
  "id": "Mashonaland East Province",
  "description": "Mashonaland East Province"
  },
  {
  "id": "Mashonaland West",
  "description": "Mashonaland West"
  },
  {
  "id": "Masvingo Province",
  "description": "Masvingo Province"
  },
  {
  "id": "Matabeleland North",
  "description": "Matabeleland North"
  },
  {
  "id": "Matabeleland South Province",
  "description": "Matabeleland South Province"
  },
  {
  "id": "Midlands Province",
  "description": "Midlands Province"
  }
  ]
  }
  ]